import React, { useState, useCallback, useMemo, useContext, createContext, useEffect, useRef, useReducer, memo, Fragment } from 'react';
import { Bbox } from '@evergis/sgis/es/Bbox';
import { getMouseOffset, listenDomEvent } from '@evergis/sgis/es/utils/domEvent';
import { Api, LineEndingType, unique, AttributeType, GeometryType, EvergisDynamicLayer as EvergisDynamicLayer$1, EvergisTileLayer as EvergisTileLayer$1, isEvergisDynamicLayer } from '@evergis/api';
import { Map as Map$1, BboxChangeEvent, BboxChangeEndEvent } from '@evergis/sgis/es/Map';
import { DomPainter, MapResize } from '@evergis/sgis/es/painters/DomPainter/DomPainter';
import { FeatureLayer as FeatureLayer$1 } from '@evergis/sgis/es/layers/FeatureLayer';
import { Icon, IconButton, EverCloudStatisticsIcon, EverCloudZoomtoIcon, EverCloudCloseIcon, EverCloudPlayPrevIcon, EverCloudPlayNextIcon, EverCloudClassificationIcon, EverCloudRefreshIcon } from '@evergis/icons';
import { BrushFill } from '@evergis/sgis/es/symbols/polygon/BrushFill';
import { Color } from '@evergis/color';
import { ConditionInterpreter, TokenType, ConditionEvaluator, Char } from '@evergis/condition';
import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { ImageFill } from '@evergis/sgis/es/symbols/polygon/ImageFill';
import { PolygonSymbol } from '@evergis/sgis/es/symbols/polygon/Simple';
import { PolylineSymbol } from '@evergis/sgis/es/symbols/PolylineSymbol';
import { PolyRender, FillStyle } from '@evergis/sgis/es/renders/Poly';
import { projectRings, length, area, distance } from '@evergis/sgis/es/geotools';
import { simplifyCoordinates, softEquals } from '@evergis/sgis/es/utils/math';
import { PolylineControl } from '@evergis/sgis/es/controls/PolylineControl';
import { LabelFeature } from '@evergis/sgis/es/features/Label';
import { webMercator, geo, wgs84, ellipticalMercator, plain } from '@evergis/sgis/es/Crs';
import { Polygon } from '@evergis/sgis/es/features/Polygon';
import { DrawingFinishEvent } from '@evergis/sgis/es/controls/Control';
import { isValid, toDate, format, parseJSON, parseISO } from 'date-fns';
import { MultiPoint } from '@evergis/sgis/es/features/MultiPoint';
import { Polyline } from '@evergis/sgis/es/features/Polyline';
import { PointFeature } from '@evergis/sgis/es/features/PointFeature';
import { PolyEditor } from '@evergis/sgis/es/controls/PolyEditor';
import get from 'lodash-es/get';
import { isNil } from 'lodash-es';
import ReactDOM from 'react-dom';
import { DynamicPointSymbol, Symbol as Symbol$1 } from '@evergis/sgis/es/symbols/Symbol';
import { Poly } from '@evergis/sgis/es/features/Poly';
import { PointSymbol } from '@evergis/sgis/es/symbols/point/Point';
import { Arc } from '@evergis/sgis/es/renders/Arc';
import { DynamicRender } from '@evergis/sgis/es/renders/Render';
import { SvgRender } from '@evergis/sgis/es/painters/DomPainter/SvgRender';
import { MouseEventFlags, mouseEvents } from '@evergis/sgis/es/EventHandler';
import { StaticImageSymbol } from '@evergis/sgis/es/symbols/point/StaticImageSymbol';
import { SquareSymbol } from '@evergis/sgis/es/symbols/point/Square';
import { MaskedImage } from '@evergis/sgis/es/symbols/point/MaskedImage';
import { H3Symbol } from '@evergis/sgis/es/symbols/H3Symbol';
import { CombinedPolylineSymbol } from '@evergis/sgis/es/symbols/CombinedPolylineSymbol';
import { H3Feature } from '@evergis/sgis/es/features/H3Feature';
import { CombinedPolyline } from '@evergis/sgis/es/features/CombinedPolyline';
import { Canvas } from '@evergis/sgis/es/painters/DomPainter/Canvas';
import { sGisClickEvent } from '@evergis/sgis/es/commonEvents';
import { ClusterLayer as ClusterLayer$1 } from '@evergis/sgis/es/layers/ClusterLayer';
import { GridClusterProvider } from '@evergis/sgis/es/layers/clusterProviders/GridClusterProvider';
import { PointEditor } from '@evergis/sgis/es/controls/PointEditor';
import { debounce } from '@evergis/sgis/es/utils/utils';
import styled, { css } from 'styled-components';
import punycode from 'punycode';
import { TileLayer as TileLayer$1 } from '@evergis/sgis/es/layers/TileLayer';
import { SVG } from '@svgdotjs/svg.js';
import { Color as Color$1 } from '@evergis/color/es/Color';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

const usePagination = length => {
  const [current, setCurrent] = useState(0);
  const next = useCallback(() => setCurrent(value => value < length - 1 ? value + 1 : value), [length, setCurrent]);
  const prev = useCallback(() => setCurrent(value => value === 0 ? value : value - 1), [setCurrent]);
  const reset = useCallback(() => setCurrent(0), [setCurrent]);
  return [current, {
    prev,
    next,
    reset
  }];
};

const BASE_URL = '/';
const defaultApi = /*#__PURE__*/new Api({
  url: BASE_URL
});
const evergisContext = /*#__PURE__*/createContext(defaultApi);
const EvergisProvider = _ref => {
  let {
    api,
    children
  } = _ref;
  const value = useMemo(() => api || defaultApi, [api]);
  return React.createElement(evergisContext.Provider, {
    value: value
  }, children);
};
const useEvergisContext = () => useContext(evergisContext);

const defaultMap = /*#__PURE__*/new Map$1();
const defaultPainter = /*#__PURE__*/new DomPainter(defaultMap);
const mapContext = /*#__PURE__*/createContext({
  map: defaultMap,
  painter: defaultPainter
});
const MapProvider = _ref => {
  let {
    map,
    painter,
    children
  } = _ref;
  const value = useMemo(() => ({
    map: map || defaultMap,
    painter: painter || (map ? new DomPainter(map) : defaultPainter)
  }), [map, painter]);
  return React.createElement(mapContext.Provider, {
    value: value
  }, children);
};
const useMapContext = () => useContext(mapContext);

const defaultLayer = /*#__PURE__*/new FeatureLayer$1();
const defaultPopupLayer = /*#__PURE__*/new FeatureLayer$1();
const tooltipContext = /*#__PURE__*/createContext({
  layer: defaultLayer,
  popupLayer: defaultPopupLayer
});
const TooltipProvider = _ref => {
  let {
    layer,
    popupLayer,
    children
  } = _ref;
  const value = useMemo(() => ({
    layer: layer || defaultLayer,
    popupLayer: popupLayer || defaultPopupLayer
  }), [layer, popupLayer]);
  return React.createElement(tooltipContext.Provider, {
    value: value
  }, children);
};
const useTooltipContext = () => useContext(tooltipContext);

const LegendContext = /*#__PURE__*/createContext(null);
const LegendProvider = _ref => {
  let {
    symbol,
    children
  } = _ref;
  return React.createElement(LegendContext.Provider, {
    value: symbol || null
  }, children);
};
const useLegendContext = () => useContext(LegendContext);

const evergisSelectContext = /*#__PURE__*/createContext([]);
const EvergisSelectProvider = _ref => {
  let {
    layers,
    children
  } = _ref;
  return React.createElement(evergisSelectContext.Provider, {
    value: layers
  }, children);
};
const useEvergisSelectContext = () => useContext(evergisSelectContext);

const useEventPoint = () => {
  const {
    painter
  } = useMapContext();
  return useCallback(event => {
    if ('point' in event) {
      return event.point;
    }

    const browserEvent = 'browserEvent' in event ? event['browserEvent'] : event;
    const wrapper = painter.wrapper;
    const {
      x,
      y
    } = getMouseOffset(wrapper, 'touches' in browserEvent ? {
      pageX: browserEvent.touches[0].pageX,
      pageY: browserEvent.touches[0].pageY
    } : browserEvent);
    const originalPoint = painter.getPointFromPxPosition(x, y);
    return originalPoint;
  }, [painter]);
};

function useMapViewActions() {
  const {
    map,
    painter
  } = useMapContext();
  const getEventPoint = useEventPoint();
  const zoomTo = useCallback(k => {
    map.zoom(k, map.position);
  }, [map]);
  const zoomIn = useCallback(() => zoomTo(1), [zoomTo]);
  const zoomOut = useCallback(() => zoomTo(-1), [zoomTo]);
  const animateTo = useCallback(_ref => {
    let {
      position,
      resolution,
      extent
    } = _ref;

    if (position || resolution) {
      const nextPosition = position ? position.slice(0) : map.position;
      map.animateTo(nextPosition, resolution || map.resolution);
    }

    if (extent) {
      const {
        xMax,
        xMin,
        yMax,
        yMin
      } = extent;
      const bbox = new Bbox([xMin, yMax], [xMax, yMin], map.crs);
      painter && painter.show(bbox, true);
    }
  }, [map, painter]);
  const zoomAround = useCallback(event => {
    map.zoom(1, getEventPoint(event));
  }, [getEventPoint, map]);
  const changeZoomLevel = useCallback(level => {
    const {
      tileScheme
    } = map;
    let tileLevel = tileScheme.levels.find(_ref2 => {
      let {
        zIndex
      } = _ref2;
      return zIndex === level;
    });
    const resolution = tileLevel ? tileLevel.resolution : map.resolution;
    map.animateSetResolution(resolution, map.position);
  }, [map]);
  return {
    zoomTo,
    zoomIn,
    zoomOut,
    zoomAround,
    animateTo,
    changeZoomLevel
  };
}

const useZoomToFeature = () => {
  const {
    animateTo
  } = useMapViewActions();
  return useCallback(feature => {
    const extent = feature.extent();

    if (extent) {
      animateTo({
        extent
      });
    }
  }, [animateTo]);
};

const useEvergisCard = features => {
  const [current, {
    prev,
    next,
    reset
  }] = usePagination(features.length);
  const feature = features[current];
  const zoomToFeature = useZoomToFeature();
  const zoom = useCallback(() => zoomToFeature(feature), [zoomToFeature, feature]);
  useEffect(() => {
    reset(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [features.length]);
  return {
    feature,
    current,
    prev,
    next,
    zoom
  };
};

function isRangeClass(value) {
  return Boolean(value && 'from' in value);
}
function isUniqueClass(value) {
  return Boolean(value && 'uniqueValue' in value);
}

const NULL_EXPRESSION = {
  // @ts-ignore TODO
  attribute: null,
  // @ts-ignore TODO
  operation: null,
  value: null
};
let ClassificationCondition = /*#__PURE__*/function () {
  function ClassificationCondition(condition) {
    _classCallCheck(this, ClassificationCondition);

    this.expressions = [];
    this.condition = condition;
    const conditionResult = new ConditionInterpreter(condition).value;
    this.expressions = conditionResult instanceof Error ? [] : conditionResult.expressions;
  }

  _createClass(ClassificationCondition, [{
    key: "attributeName",
    get: function get() {
      return this.leftExpression.attribute;
    }
  }, {
    key: "uniqueValue",
    get: function get() {
      if (this.isUnique()) {
        const {
          value
        } = this.leftExpression;
        return typeof value === 'string' ? value : '';
      }

      console.warn("Trying to get unique from range condition " + this.condition);
      return '';
    }
  }, {
    key: "range",
    get: function get() {
      if (!this.isRange()) {
        console.warn("Trying to get range from unique condition " + this.condition);
        return [0, 0];
      }

      if (this.expressions.length === 2) {
        const {
          value: from
        } = this.leftExpression;
        const {
          value: to
        } = this.rightExpression;
        return [from, to];
      }

      if (this.expressions.length === 1) {
        const {
          operation,
          value
        } = this.leftExpression;
        const isFrom = operation === TokenType.ArGr;
        return [isFrom ? value : null, isFrom ? null : value];
      }

      return [0, 0];
    }
  }, {
    key: "type",
    get: function get() {
      return this.isUnique() ? 1
      /* Unique */
      : 0
      /* Range */
      ;
    }
  }, {
    key: "isUnique",
    value: function isUnique() {
      return this.leftExpression.operation === TokenType.ArEq;
    }
  }, {
    key: "isRange",
    value: function isRange() {
      return [TokenType.ArGr, TokenType.ArGre, TokenType.ArLs, TokenType.ArLse].includes(this.leftExpression.operation);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.condition;
    }
  }, {
    key: "leftExpression",
    get: function get() {
      return this.expressions.length > 0 ? this.expressions[0] : NULL_EXPRESSION;
    }
  }, {
    key: "rightExpression",
    get: function get() {
      return this.expressions.length > 1 ? this.expressions[1] : NULL_EXPRESSION;
    }
  }]);

  return ClassificationCondition;
}();

const PARAMETER_SEPARATOR = '.';
const parameterToPaths = parameter => parameter.split(PARAMETER_SEPARATOR);
const pathsToParameter = paths => paths.join(PARAMETER_SEPARATOR);

function isObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

const isParameterByAttribute = value => Boolean(isObject(value) && (value == null ? void 0 : value.type) === 'byAttribute');
const isCalculatedParameter = value => Boolean(isObject(value) && (value == null ? void 0 : value.type) === 'calculated');
const getParameterValue = value => {
  if (isParameterByAttribute(value) || isCalculatedParameter(value)) {
    return value.defaultValue;
  }

  return value;
};
const symbolParameterWalker = valueModifier => (symbol, parameter) => {
  const paths = Array.isArray(parameter) ? parameter : parameterToPaths(parameter);
  const [firstKey, ...restKeys] = paths; // @ts-ignore

  const symbolPart = symbol[firstKey];

  if (restKeys.length) {
    const goDeeper = symbolParameterWalker(valueModifier);
    return _extends({}, symbol, {
      [firstKey]: goDeeper(symbolPart, restKeys) || symbolPart
    });
  }

  return _extends({}, symbol, {
    [firstKey]: valueModifier(symbolPart) || symbolPart
  });
};
const setDefaultParameterValue = /*#__PURE__*/symbolParameterWalker(getParameterValue);
const setParameterValue = (symbol, path, value) => symbolParameterWalker(() => value)(symbol, path);
function applyParameterValue(symbol, path, value) {
  if (path === 'symbol') {
    return value;
  }

  return setParameterValue(symbol, path, value);
}

const symbolTypeGuard = type => symbol => symbol && symbol.type === type;

const isPointLabelSymbol = /*#__PURE__*/symbolTypeGuard('labelPointSymbol');
const isPolygonLabelSymbol = /*#__PURE__*/symbolTypeGuard('polygonLabelSymbol');
const isPolylineLabelSymbol = /*#__PURE__*/symbolTypeGuard('polylineLabelSymbol');
const isLabelSymbol = symbol => Boolean(symbol && (isPointLabelSymbol(symbol) || isPolygonLabelSymbol(symbol) || isPolylineLabelSymbol(symbol)));

const _excluded = ["ignoreLabel", "label", "symbol", "raster", "children"];
const createCompositeSymbol = childSymbols => ({
  type: 'compositeSymbol',
  childSymbols
});
const getChildSymbols = symbol => {
  if (!symbol || !isCompositeSymbol(symbol)) return [];
  return symbol.childSymbols || [];
};
const extractSymbol = symbol => {
  const childSymbols = getChildSymbols(symbol);
  return {
    // @ts-ignore
    symbol: childSymbols.find(isSimpleSymbol),
    label: childSymbols.find(isLabelSymbol) || null,
    raster: childSymbols.find(isRasterSymbol) || null
  };
};
const extractStyle = style => {
  // @ts-ignore
  if (isCompositeSymbol(style.symbol)) {
    return _extends({}, style, extractSymbol(style.symbol), {
      // @ts-ignore
      children: style.children && style.children.map(extractStyle)
    });
  } // NOTE: for cases when style is exist style object should have same reference for all extractStyle calls


  return style || {};
};
const packStyle = style => {
  const {
    ignoreLabel,
    label,
    symbol,
    raster,
    children
  } = style,
        styleDc = _objectWithoutPropertiesLoose(style, _excluded);

  const childSymbols = [!ignoreLabel && label, raster].filter(Boolean);
  return _extends({}, styleDc, {
    symbol: childSymbols.length ? // @ts-ignore
    createCompositeSymbol([symbol, ...childSymbols]) : symbol,
    // @ts-ignore
    children: children ? // @ts-ignore
    children.map(childStyle => packStyle(_extends({}, childStyle, {
      ignoreLabel,
      label
    }))) : children
  });
};

const isPointSymbol = /*#__PURE__*/symbolTypeGuard('circlePointSymbol');
const isSquareSymbol = /*#__PURE__*/symbolTypeGuard('squarePointSymbol');
const isMaskedImageSymbol = /*#__PURE__*/symbolTypeGuard('maskedImagePointSymbol');
const isStaticImageSymbol = /*#__PURE__*/symbolTypeGuard('imagePointSymbol');
const isCombinedPolylineSymbol = /*#__PURE__*/symbolTypeGuard("combinedPolylineSymbol");
const isPolygonSymbol = /*#__PURE__*/symbolTypeGuard('polygonSymbol');
const isPolylineSymbol = /*#__PURE__*/symbolTypeGuard('polylineSymbol');
const isSimplePolylineSymbol = /*#__PURE__*/symbolTypeGuard('simplePolylineSymbol');
const isPolylineSymbols = symbol => Boolean(symbol && (isPolylineSymbol(symbol) || isSimplePolylineSymbol(symbol)));
const isCompositeSymbol = /*#__PURE__*/symbolTypeGuard('compositeSymbol');
const isRasterSymbol = /*#__PURE__*/symbolTypeGuard('rasterSymbol');
const isImageSymbol = symbol => Boolean(symbol && (isMaskedImageSymbol(symbol) || isStaticImageSymbol(symbol)));
const isTwoDimensionalSymbol = symbol => Boolean(symbol && 'width' in symbol);
const isSizableSymbol = symbol => Boolean(symbol && 'size' in symbol);
const isStrokeStyledSymbol = symbol => Boolean(symbol && (isPolygonSymbol(symbol) || isPolylineSymbols(symbol)));
const isScalablePolylineSymbol = symbol => symbol.beginning !== null && symbol.ending !== null || symbol.stroke && symbol.stroke.type !== 'solid';
const isSimpleSymbol = symbol => Boolean(symbol && !isLabelSymbol(symbol) && !isCompositeSymbol(symbol) && !isRasterSymbol(symbol));
const isH3GridSymbol = /*#__PURE__*/symbolTypeGuard("h3grid");
const isSvgPointSymbol = /*#__PURE__*/symbolTypeGuard("svgPointSymbol");
const isClusterSymbol = /*#__PURE__*/symbolTypeGuard("cluster");
const isClusterFillColor = (symbol, parameter) => {
  return isClusterSymbol(symbol) && parameter === "fillColor";
};
const getExtractedSymbol = function getExtractedSymbol(symbol, extractCluster) {
  var _extractSymbol;

  if (extractCluster === void 0) {
    extractCluster = false;
  }

  const extracted = isCompositeSymbol(symbol) ? (_extractSymbol = extractSymbol(symbol)) == null ? void 0 : _extractSymbol.symbol : symbol;
  return extractCluster && isClusterSymbol(extracted) ? extracted.singleObjectSymbol : extracted;
};

const isHatchBrush = /*#__PURE__*/symbolTypeGuard('hatch');
const isPatternBrush = /*#__PURE__*/symbolTypeGuard('pattern');
const isDashedBrush = /*#__PURE__*/symbolTypeGuard('dashed');
const isSolidBrush = /*#__PURE__*/symbolTypeGuard('solid');
const isPolygonHasPatternBrush = symbol => Boolean(symbol && isPolygonSymbol(symbol) && isPatternBrush(symbol.fill));
const isPolygonHasHatchBrush = symbol => Boolean(symbol && isPolygonSymbol(symbol) && isHatchBrush(symbol.fill));

const isMiterExist = miter => Boolean(miter && miter.type !== LineEndingType.None);
const isFilledLineMitter = miter => miter.type === LineEndingType.FilledCircle || miter.type === LineEndingType.FilledArrow || miter.type === LineEndingType.FilledSquare;
const isArrowLineMiter = miter => miter.type === LineEndingType.Arrow || miter.type === LineEndingType.FilledArrow;
const isSquareLineMiter = miter => miter.type === LineEndingType.Square || miter.type === LineEndingType.FilledSquare;
const isCircleLineMiter = miter => miter.type === LineEndingType.Circle || miter.type === LineEndingType.FilledCircle;

const isSimpleOffset = offset => offset && !isParameterByAttribute(offset[0]) && !isParameterByAttribute(offset[1]);
const isSymbolWithOffset = symbol => Boolean(symbol && 'offset' in symbol);

const isStringParameterValue = parameterValue => typeof parameterValue === 'string';
const isParameterValueSimple = parameterValue => typeof parameterValue === 'number' || typeof parameterValue === 'string';
const isParameterValueSymbol = parameterValue => !isParameterValueSimple(parameterValue);

const isStyle = value => 'symbol' in value;

let EvergisStyle = /*#__PURE__*/function () {
  function EvergisStyle(style) {
    _classCallCheck(this, EvergisStyle);

    this.style = extractStyle(style);
    this.classificationManager = new ClassificationManager(this.style);
  }

  _createClass(EvergisStyle, [{
    key: "serialize",
    value: function serialize() {
      return packStyle(this.style);
    }
  }, {
    key: "hasRasters",
    value: function hasRasters() {
      return !!(this.style.raster || (this.style.children || []).some(style => style.raster));
    }
  }, {
    key: "symbol",
    get: function get() {
      return this.style.symbol;
    }
  }, {
    key: "raster",
    get: function get() {
      return this.style.raster;
    }
  }, {
    key: "label",
    get: function get() {
      return this.style.label;
    }
  }, {
    key: "children",
    get: function get() {
      return this.style.children;
    }
  }, {
    key: "title",
    get: function get() {
      return this.style.title;
    }
  }, {
    key: "condition",
    get: function get() {
      return this.style.condition;
    }
  }, {
    key: "ignoreLabel",
    get: function get() {
      return this.style.ignoreLabel;
    }
  }, {
    key: "resolution",
    get: function get() {
      const {
        minResolution,
        maxResolution
      } = this.style;
      return minResolution === void 0 || maxResolution === void 0 ? null : [minResolution, maxResolution];
    }
  }]);

  return EvergisStyle;
}();

const toClassificationClass = (parameterValue, title, condition) => _extends({
  parameterValue,
  title
}, condition.isUnique() ? {
  uniqueValue: condition.uniqueValue
} : {
  from: condition.range[0],
  to: condition.range[1]
});

const DEFAULT_EXTRAS = {
  defaultTitle: '',
  // @ts-ignore
  defaultValue: null
};
const toClassification = function toClassification(values, parameter, extras) {
  if (extras === void 0) {
    extras = DEFAULT_EXTRAS;
  }

  return (// @ts-ignore
    values.reduce( // @ts-ignore
    (classification, value) => {
      const classificationCondition = new ClassificationCondition(value.condition || '');
      const classificationValue = toClassificationClass(isStyle(value) ? value.symbol : value.value, // @ts-ignore
      value.title, classificationCondition);
      classification.values.push(classificationValue);
      return _extends({}, classification, {
        type: classification.type || classificationCondition.type,
        attribute: classification.attribute || classificationCondition.attributeName
      });
    }, _extends({}, extras, {
      attribute: null,
      parameter,
      type: null,
      values: []
    }))
  );
};
const getClassifications = function getClassifications(symbol, pathContext) {
  if (pathContext === void 0) {
    pathContext = [];
  }

  return Object.entries(symbol).reduce((classifications, _ref) => {
    let [parameter, parameterValue] = _ref;
    const skipHeight = isTwoDimensionalSymbol(symbol) && parameter === 'height';
    const skip = !isObject(parameterValue) || skipHeight;

    if (skip) {
      return classifications;
    }

    if (!isParameterByAttribute(parameterValue)) {
      return [...classifications, // @ts-ignore
      ...getClassifications(symbol[parameter], [...pathContext, parameter])];
    }

    const classification = toClassification(parameterValue.values, pathsToParameter([...pathContext, parameter]), {
      // @ts-ignore
      defaultTitle: parameterValue.title,
      defaultValue: parameterValue.defaultValue
    });
    return [...classifications, classification];
  }, []);
};

let ClassificationManager = /*#__PURE__*/function () {
  function ClassificationManager(style) {
    _classCallCheck(this, ClassificationManager);

    this.style = style;
    this.classifications = [];
    this.collectClassifications();
  }

  _createClass(ClassificationManager, [{
    key: "values",
    get: function get() {
      return this.classifications;
    }
  }, {
    key: "find",
    value: function find(predicate) {
      for (const classification of this.classifications) {
        if (predicate(classification)) {
          return classification;
        }
      }

      return null;
    }
  }, {
    key: "filter",
    value: function filter(callback) {
      return this.classifications.filter(callback);
    }
  }, {
    key: "map",
    value: function map(callback) {
      return this.classifications.map(callback);
    }
  }, {
    key: "reduce",
    value: function reduce(callback, initial) {
      return this.classifications.reduce(callback, initial);
    }
  }, {
    key: "hasClassifications",
    value: function hasClassifications() {
      return this.classifications.length > 0;
    }
  }, {
    key: "collectClassifications",
    value: function collectClassifications() {
      if (this.style.children && this.style.children.length) {
        this.classifications.push(toClassification(this.style.children, 'symbol'));
      }

      if (this.style.symbol) {
        this.classifications.push(...getClassifications(this.style.symbol));
      }
    }
  }]);

  return ClassificationManager;
}();

const unClassify = symbol => Object.entries(symbol).reduce((flatSymbol, _ref) => {
  let [parameter, parameterValue] = _ref;
  let result = Array.isArray(parameterValue) ? parameterValue.map(getParameterValue) : getParameterValue(parameterValue);

  if (isObject(result)) {
    return _extends({}, flatSymbol, {
      [parameter]: unClassify(parameterValue)
    });
  }

  return _extends({}, flatSymbol, {
    [parameter]: result
  });
}, {});

const DEFAULT_LANGUAGE = "ru";
const resources = {
  en: {},
  ru: {}
};
i18n.use(LanguageDetector).use(initReactI18next).init({
  fallbackLng: DEFAULT_LANGUAGE,
  ns: Object.keys(resources[DEFAULT_LANGUAGE]),
  interpolation: {
    escapeValue: false
  },
  resources,
  supportedLngs: Object.keys(resources)
});

const printRangeClass = (value, index) => {
  var _value$attribute, _value$attribute2;

  const isDouble = Boolean(((_value$attribute = value.attribute) == null ? void 0 : _value$attribute.type) === 'Double');
  const isDate = Boolean(((_value$attribute2 = value.attribute) == null ? void 0 : _value$attribute2.type) === 'DateTime');
  const {
    from,
    to
  } = getRangeValues(value, isDouble, isDate, index);

  if (from === null) {
    return to + " " + (isDate ? i18n.t("andBefore", {
      ns: "style"
    }) : i18n.t("andLess", {
      ns: "style"
    }));
  }

  if (to === null) {
    return (isDate ? i18n.t("after", {
      ns: "style"
    }) : i18n.t("more", {
      ns: "style"
    })) + " " + from;
  }

  return from === to ? "" + from : from + " - " + to;
};

function getRangeValues(_ref, isDouble, isDate, index) {
  let {
    from,
    to
  } = _ref;
  return {
    from: from !== null && index !== 0 ? isDate ? from : isDouble ? +from : +from + 1 : from,
    to
  };
}

const getHexColor = colorString => colorString ? new Color(colorString).toString('hex') : undefined;

// TODO reduce
const PREVIEW_LIMITS = {
  STROKE_WIDTH_MIN: 0.25,
  STROKE_WIDTH_MAX: 6.5
};

function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

/* eslint-disable @typescript-eslint/no-magic-numbers */
const SOLID_INTERVALS = [];
const solidStrokeStylePreset = {
  style: 0
  /* Solid */
  ,
  type: 'solid',
  intervals: SOLID_INTERVALS
};
const strokeStylePresets = [solidStrokeStylePreset, {
  style: 2
  /* Dot */
  ,
  type: 'dashed',
  intervals: [2, 2]
}, {
  style: 1
  /* Dash */
  ,
  type: 'dashed',
  intervals: [3, 3, 3, 3]
}, {
  style: 3
  /* DashDot */
  ,
  type: 'dashed',
  intervals: [5, 2, 1, 2]
}, {
  style: 4
  /* DashDotDot */
  ,
  type: 'dashed',
  intervals: [5, 2, 1, 1, 1, 2]
}, {
  style: 5
  /* Custom */
  ,
  type: 'dashed',
  intervals: [5, 4]
}];

const walkByNumbersGroup = (numbers, offset, walker) => {
  if (!numbers || !numbers.length) return [];
  const newNumbers = [];

  for (let i = 0; i < numbers.length; i++) {
    if (i % 2) {
      newNumbers.push(...walker([numbers[i - 1], numbers[i]], offset));
    }
  }

  return newNumbers;
};

const toIntervals = (numbers, width) => walkByNumbersGroup(numbers, clamp(getParameterValue(width), PREVIEW_LIMITS.STROKE_WIDTH_MIN, PREVIEW_LIMITS.STROKE_WIDTH_MAX), (_ref, offset) => {
  let [length, gap] = _ref;
  return [length * offset, gap * offset];
});
const toLineDash = (numbers, width) => walkByNumbersGroup(numbers, clamp(getParameterValue(width), PREVIEW_LIMITS.STROKE_WIDTH_MIN, PREVIEW_LIMITS.STROKE_WIDTH_MAX), (_ref2, offset) => {
  let [length, gap] = _ref2;
  return [Math.round(length / Math.max(1, Math.min(offset, 16) / 4)), Math.round(gap + 1 + Math.max(1, Math.min(offset, 16) / 2))];
});
const getLineDash = brush => {
  if (!brush || brush.type === 'solid') return []; // @ts-ignore

  return toLineDash(brush.intervals, brush.width);
};
const defineStrokeStylePreset = intervals => {
  if (!intervals.length) return solidStrokeStylePreset;
  return strokeStylePresets.find(preset => {
    if (preset.intervals.length !== intervals.length) return false;
    const uniqueStrokeWidths = preset.intervals.map((presetInterval, i) => intervals[i] / presetInterval).filter(unique);
    return uniqueStrokeWidths.length === 1;
  });
};
const getDashStylePreset = dashStyle => strokeStylePresets.find(preset => preset.style === dashStyle);

const ALPHA_NORMALIZER = 65025;

const sum = numbers => numbers.reduce((result, num) => result + num, 0);

const shouldFillMatrixCell = (matrixSize, hatchAngle, x, y) => {
  const center = Math.round(matrixSize / 2);

  if ((hatchAngle === 0 || hatchAngle === Math.PI) && x === center) {
    return true;
  }

  if (hatchAngle === Math.PI / 4 && y === x) {
    return true;
  }

  if (hatchAngle === Math.PI / 2 && y === center) {
    return true;
  }

  return hatchAngle === 3 * Math.PI / 4 && matrixSize - 1 - y === x;
};

const createEmptyMatrix = size => Array(size).fill(null).map(() => Array(size));

const fillMatrix = (matrix, filler) => {
  const matrixSize = matrix.length;

  for (let x = 0; x < matrixSize; x++) {
    for (let y = 0; y < matrixSize; y++) {
      matrix[x][y] = filler(x, y, matrixSize);
    }
  }
};

const createFillBrushMatrix = (hatchAngle, hatchWidth, scalingFactor) => {
  const matrixSize = Math.max(Math.round(sum([Math.max(...scalingFactor), hatchWidth])), hatchWidth);
  const matrix = createEmptyMatrix(matrixSize);
  fillMatrix(matrix, (x, y, size) => shouldFillMatrixCell(size, hatchAngle, x, y) ? 255 : 0);
  return matrix;
};

const createSymbolFillBrush = fillBrush => {
  if (fillBrush.type !== 'hatch') return undefined;
  return createFillBrushMatrix( // @ts-ignore
  getParameterValue(fillBrush.hatchAngle), // @ts-ignore
  Math.round(fillBrush.hatchWidth), fillBrush.scalingFactor);
};

let SGisBrushFill = /*#__PURE__*/function (_sBrushFill) {
  _inherits(SGisBrushFill, _sBrushFill);

  var _super = /*#__PURE__*/_createSuper(SGisBrushFill);

  function SGisBrushFill(originalSymbol) {
    var _originalSymbol$strok, _originalSymbol$strok2, _originalSymbol$fill, _originalSymbol$fill2;

    var _this;

    _classCallCheck(this, SGisBrushFill);

    _this = _super.call(this, {
      // @ts-ignore
      strokeColor: getHexColor(getParameterValue((_originalSymbol$strok = originalSymbol.stroke) == null ? void 0 : _originalSymbol$strok.color)),
      // @ts-ignore
      strokeWidth: getParameterValue((_originalSymbol$strok2 = originalSymbol.stroke) == null ? void 0 : _originalSymbol$strok2.width),
      lineDash: getLineDash(originalSymbol.stroke),
      fillBackground: getHexColor( // @ts-ignore
      getParameterValue((_originalSymbol$fill = originalSymbol.fill) == null ? void 0 : _originalSymbol$fill.color)),
      fillForeground: isHatchBrush(originalSymbol.fill) ? // @ts-ignore
      getHexColor(getParameterValue((_originalSymbol$fill2 = originalSymbol.fill) == null ? void 0 : _originalSymbol$fill2.hatchColor)) : void 0,
      fillBrush: createSymbolFillBrush(originalSymbol.fill),
      lineCap: 'square'
    });
    _this.originalSymbol = originalSymbol;
    return _this;
  }

  _createClass(SGisBrushFill, [{
    key: "_updateBrush",
    value: function _updateBrush() {
      // @ts-ignore
      if (!this._initialized) return;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        return;
      }

      const brush = this.fillBrush;
      const brushSize = brush.length;
      const foreground = new Color(this.fillForeground);
      const background = new Color(this.fillBackground);
      canvas.height = brushSize;
      canvas.width = brushSize;

      for (let i = 0; i < brushSize; i++) {
        // eslint-disable-next-line id-length
        for (let j = 0; j < brush[i].length; j++) {
          const srcA = brush[i][j] * foreground.a / ALPHA_NORMALIZER;
          const dstA = background.a / 255 * (1 - srcA);
          const alpha = +Math.min(1, srcA + dstA).toFixed(2);
          const red = Math.round(Math.min(255, background.r * dstA + foreground.r * srcA));
          const green = Math.round(Math.min(255, background.g * dstA + foreground.g * srcA));
          const blue = Math.round(Math.min(255, background.b * dstA + foreground.b * srcA));
          ctx.fillStyle = "rgba(" + red + "," + green + "," + blue + "," + alpha + ")";
          ctx.fillRect(j, i, 1, 1);
        }
      }

      this._brush = new Image();
      this._brush.src = canvas.toDataURL();
    }
  }, {
    key: "clone",
    value: function clone() {
      return new SGisBrushFill(this.originalSymbol);
    }
  }]);

  return SGisBrushFill;
}(BrushFill);

let SGisImageFill = /*#__PURE__*/function (_sImageFill) {
  _inherits(SGisImageFill, _sImageFill);

  var _super = /*#__PURE__*/_createSuper(SGisImageFill);

  function SGisImageFill(originalSymbol) {
    var _originalSymbol$strok, _originalSymbol$strok2;

    var _this;

    _classCallCheck(this, SGisImageFill);

    _this = _super.call(this, {
      // @ts-ignore
      strokeColor: getHexColor(getParameterValue((_originalSymbol$strok = originalSymbol.stroke) == null ? void 0 : _originalSymbol$strok.color)),
      // @ts-ignore
      strokeWidth: getParameterValue((_originalSymbol$strok2 = originalSymbol.stroke) == null ? void 0 : _originalSymbol$strok2.width),
      lineDash: getLineDash(originalSymbol.stroke),
      src: "data:image/png;base64," + originalSymbol.fill.pattern,
      lineCap: isDashedBrush(originalSymbol.stroke) ? 'square' : 'round'
    });
    _this.originalSymbol = originalSymbol;
    return _this;
  }

  _createClass(SGisImageFill, [{
    key: "clone",
    value: function clone() {
      return new SGisImageFill(this.originalSymbol);
    }
  }]);

  return SGisImageFill;
}(ImageFill);

let SGisPolygonSymbol = /*#__PURE__*/function (_sPolygonSymbol) {
  _inherits(SGisPolygonSymbol, _sPolygonSymbol);

  var _super = /*#__PURE__*/_createSuper(SGisPolygonSymbol);

  function SGisPolygonSymbol(originalSymbol) {
    var _originalSymbol$strok, _originalSymbol$strok2, _originalSymbol$fill;

    var _this;

    _classCallCheck(this, SGisPolygonSymbol);

    _this = _super.call(this, {
      // @ts-ignore
      strokeColor: getHexColor(getParameterValue((_originalSymbol$strok = originalSymbol.stroke) == null ? void 0 : _originalSymbol$strok.color)),
      // @ts-ignore
      strokeWidth: getParameterValue((_originalSymbol$strok2 = originalSymbol.stroke) == null ? void 0 : _originalSymbol$strok2.width),
      lineDash: getLineDash(originalSymbol.stroke),
      // @ts-ignore
      fillColor: getHexColor(getParameterValue((_originalSymbol$fill = originalSymbol.fill) == null ? void 0 : _originalSymbol$fill.color)),
      // TODO?: may be it should be defined by user
      lineCap: isDashedBrush(originalSymbol.stroke) ? 'square' : 'round'
    });
    _this.originalSymbol = originalSymbol;
    return _this;
  }

  _createClass(SGisPolygonSymbol, [{
    key: "clone",
    value: function clone() {
      return new SGisPolygonSymbol(this.originalSymbol);
    }
  }]);

  return SGisPolygonSymbol;
}(PolygonSymbol);

const adaptMiterRings = (rings, resolution, fromCrs, toCrs) => {
  const projected = projectRings(rings, fromCrs, toCrs);
  return simplifyCoordinates(projected.map(ring => // @ts-ignore
  ring.map(_ref => {
    let [x, y] = _ref;
    return [x / resolution, y / -resolution];
  })), 1);
};

const miterSizeCalcs = {
  ["small"
  /* Small */
  ]: strokeWidth => (strokeWidth + 1) * 3 + 1,
  ["large"
  /* Large */
  ]: strokeWidth => (strokeWidth + 1) * 5 - 1
};
let LineMiterRender = /*#__PURE__*/function () {
  function LineMiterRender(baseInfo) {
    _classCallCheck(this, LineMiterRender);

    this.getAnchor = rings => {
      if (this.position === 'right') {
        const lastRing = rings[rings.length - 1];
        return lastRing && lastRing[lastRing.length - 1] || null;
      }

      const firstRing = rings[0];
      return firstRing && firstRing[0] || null;
    };

    Object.assign(this, baseInfo);
  }

  _createClass(LineMiterRender, [{
    key: "getRender",
    value: function getRender(anchorRings, anchorCrs, resolution, currentCrs) {
      const xMultiplier = this.position === 'right' ? 1 : -1;
      const miterAnchor = this.getAnchor(anchorRings);
      const miterRings = this.createRings(miterAnchor, xMultiplier);
      const projectedMiterRings = adaptMiterRings(miterRings, resolution, anchorCrs, currentCrs);
      return this.createRender(projectedMiterRings);
    }
  }, {
    key: "miterSize",
    get: function get() {
      const calcMiterSize = miterSizeCalcs[this.size];
      return calcMiterSize ? calcMiterSize(this.strokeWidth) : 1;
    }
  }]);

  return LineMiterRender;
}();

let ArrowLineMiterRender = /*#__PURE__*/function (_LineMiterRender) {
  _inherits(ArrowLineMiterRender, _LineMiterRender);

  var _super = /*#__PURE__*/_createSuper(ArrowLineMiterRender);

  function ArrowLineMiterRender() {
    _classCallCheck(this, ArrowLineMiterRender);

    return _super.apply(this, arguments);
  }

  _createClass(ArrowLineMiterRender, [{
    key: "usageSize",
    get: function get() {
      return this.miterSize + this.strokeWidth;
    }
  }, {
    key: "createRings",
    value: function createRings(_ref, xMultiplier) {
      let [x, y] = _ref;
      return [[[x, y + this.miterSize / 2], [x + this.miterSize * xMultiplier, y], [x, y - this.miterSize / 2]]];
    }
  }, {
    key: "createRender",
    value: function createRender(miterRings) {
      const isFilled = this.kind === LineEndingType.FilledArrow;
      return new PolyRender(miterRings, {
        enclosed: isFilled,
        fillColor: isFilled ? this.color : void 0,
        fillStyle: isFilled ? FillStyle.Color : FillStyle.None,
        lineCap: 'square',
        lineJoin: 'miter',
        strokeColor: this.color,
        strokeWidth: this.strokeWidth
      });
    }
  }]);

  return ArrowLineMiterRender;
}(LineMiterRender);

const NO_CONTENT_VALUE = '—';
var DateFormat;

(function (DateFormat) {
  DateFormat["ClientDefaultFormat"] = "dd.MM.yyyy HH:mm";
  DateFormat["DateTime"] = "dd.MM.yyyy HH:mm:ss";
  DateFormat["UTC"] = "yyyy-MM-dd'T'HH:mm:ss.sssxxx";
  DateFormat["AxisTooltip"] = "d MMMM yyyy";
})(DateFormat || (DateFormat = {}));

const stringDateParsers = [parseJSON, parseISO, rawDate => new Date(rawDate)];
const getDate = rawDate => {
  if (!rawDate) return null;

  if (typeof rawDate === "string") {
    for (const parser of stringDateParsers) {
      const date = parser(rawDate);

      if (isValid(date)) {
        return toDate(date);
      }
    }

    return null;
  }

  const parsedDate = toDate(rawDate);
  return isValid(parsedDate) ? parsedDate : null;
};
const formatDate = function formatDate(date, _temp) {
  let {
    dateFormat = DateFormat.ClientDefaultFormat,
    defaultValue = NO_CONTENT_VALUE
  } = _temp === void 0 ? {} : _temp;
  const dateValue = date ? getDate(date) : null;

  if (isValid(dateValue)) {
    return format(dateValue, dateFormat);
  }

  return defaultValue.toString();
};

function numberWithSpaces(x, fractionDigits, delim) {
  if (fractionDigits === void 0) {
    fractionDigits = 2;
  }

  if (delim === void 0) {
    delim = ',';
  }

  const [num, frac] = x.toFixed(fractionDigits).split('.');
  const numWithSpaces = num.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return [numWithSpaces, frac].join(delim);
}

function matchPhone(value) {
  const phoneRegexp = /((8|\+7)[- ]?)?(\(?\d{3,4}\)?[- ]?)?[\d\- ]{7,10}/g;
  return !isStringAsInn(value) && value.match(phoneRegexp);
}
function isStringAsInn(value) {
  const innRegexp = /^(([0-9]{12})|([0-9]{10}))$/;
  return innRegexp.test(value);
}
function isStringAsKpp(value) {
  const kppRegexp = /^(([0-9]{9}))$/;
  return kppRegexp.test(value);
}
function isStringAsOgrn(value) {
  const ogrnRegexp = /^([0-9]{13})?$/;
  return ogrnRegexp.test((+value).toString());
}
function isStringContainsDate(value) {
  const dateRegexp = /\d{4}(-|\/)\d{2}(-|\/)\d{2}/g;
  return dateRegexp.test(value);
}
function isRequisiteNumbers(value) {
  return isStringAsInn(value) || isStringAsKpp(value) || isStringAsOgrn(value);
}
function isStringAsPhone(value) {
  const phoneRegexp = /^((8|\+7)[- ]?)?(\(?\d{3,4}\)?[- ]?)?[\d\- ]{7,10}/;
  return !isRequisiteNumbers(value) && !isStringContainsDate(value) && phoneRegexp.test(value);
}
function isStringAsMail(value) {
  return isStringAsUrl(value) && value.includes('@');
}
function isStringAsUrl(value) {
  if (isValidUrl(value)) {
    return true;
  }

  const urlRegexp = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
  const urlKind = value.match(urlRegexp);
  return urlKind !== null;
}
function isValidUrl(value) {
  try {
    new URL(value);
  } catch (_) {
    return false;
  }

  return true;
}
const mailHref = mail => "mailto:" + mail;
const phoneHref = mail => "tel:" + mail;
const urlHref = url => isValidUrl(url) ? url : "//" + url;

const stringAttribute = value => ({
  type: 0
  /* String */
  ,
  value
});

const urlAttribute = value => ({
  type: 2
  /* Url */
  ,
  value
});

const mailAttribute = value => ({
  type: 3
  /* Mail */
  ,
  value
});

const phoneAttribute = value => ({
  type: 1
  /* Phone */
  ,
  value
});

const convertStringAttribute = value => {
  if (isStringAsMail(value)) {
    return mailAttribute(value);
  }

  if (isStringAsUrl(value)) {
    return urlAttribute(value);
  }

  if (isStringAsPhone(value)) {
    return phoneAttribute(value);
  }

  return stringAttribute(value);
};

const formatStringAttribute = value => {
  const phones = matchPhone(value);

  if (!isRequisiteNumbers(value) && !isStringContainsDate(value) && phones && phones.length) {
    return phones.map(phoneAttribute);
  }

  const attributeValues = value.split(/[\s|]/).map(convertStringAttribute);

  if (attributeValues.every(_ref => {
    let {
      type
    } = _ref;
    return type === 0;
  }
  /* String */
  )) {
    return [stringAttribute(attributeValues.map(_ref2 => {
      let {
        value
      } = _ref2;
      return isNaN(+value) || isRequisiteNumbers(value) ? isStringAsOgrn(value) ? +value : value : numberWithSpaces(+value, 0, '');
    }).join(' '))];
  }

  return attributeValues;
};

const formatDateTimeAttribute = value => stringAttribute(value.toString());

const formatIntAttribute = value => stringAttribute(numberWithSpaces(value, 0, ''));

const DOUBLE_FRACTIONS = 2;

const formatDoubleAttribute = value => stringAttribute(numberWithSpaces(value, DOUBLE_FRACTIONS, '.'));

const isNullOrUndefined = value => value === null || value === undefined;

const NO_CONTENT_ATTRIBUTE = {
  type: 0
  /* String */
  ,
  value: NO_CONTENT_VALUE
};
const formatAttributeValue = attribute => {
  if (isNullOrUndefined(attribute.value)) {
    return [NO_CONTENT_ATTRIBUTE];
  }

  switch (attribute.type) {
    case 'String':
      return formatStringAttribute(attribute.value);

    case 'DateTime':
      return [formatDateTimeAttribute(attribute.value)];

    case 'Int32':
    case 'Int64':
      return [formatIntAttribute(attribute.value)];

    case 'Double':
      return [formatDoubleAttribute(attribute.value)];

    default:
      return [NO_CONTENT_ATTRIBUTE];
  }
};

/** Spatial Reference WKID using for @evergis/sgis */

var SrId;

(function (SrId) {
  /** 3857 */
  SrId[SrId["WebMercator"] = 3857] = "WebMercator";
  /** 4326 */

  SrId[SrId["Geo"] = 4326] = "Geo";
  /** 84 */

  SrId[SrId["Wgs84"] = 84] = "Wgs84";
  /** 3395 */

  SrId[SrId["EllipticalMercator"] = 3395] = "EllipticalMercator";
})(SrId || (SrId = {}));

const CRS_MAP = {
  [SrId.WebMercator]: webMercator,
  [SrId.Geo]: geo,
  [SrId.Wgs84]: wgs84,
  [SrId.EllipticalMercator]: ellipticalMercator
};
const DEFAULT_SRID = SrId.WebMercator;
const DEFAULT_CRS = CRS_MAP[DEFAULT_SRID];
const getCrs = srId => CRS_MAP[srId];

const getFeatureAttributeType = attributeValue => {
  if (attributeValue instanceof Date) {
    return AttributeType.DateTime;
  }

  if (typeof attributeValue === 'string') {
    return AttributeType.String;
  }

  if (typeof attributeValue === 'number') {
    return AttributeType.Int64;
  }

  return AttributeType.Unknown;
};
const getLayerAttributes = layerDefinition => {
  const attributes = layerDefinition && layerDefinition.attributes || {};
  return Object.entries(attributes).map(_ref => {
    let [name, definition] = _ref;
    return _extends({
      name
    }, definition);
  });
};
const getFeatureAttributes = attributes => {
  return attributes ? Object.entries(attributes).map(_ref2 => {
    let [name, value] = _ref2;
    return {
      name,
      value,
      type: getFeatureAttributeType(value)
    };
  }) : [];
};
const mergeAttributes = (attributes1, attributes2) => {
  return attributes1.map(attribute => _extends({}, attribute, attributes2.find(_ref3 => {
    let {
      name
    } = _ref3;
    return attribute.name === name;
  }) || {}));
};

let EvergisFeature = /*#__PURE__*/function () {
  function EvergisFeature(feature) {
    _classCallCheck(this, EvergisFeature);

    this.id = null;
    this.displayName = null;
    this.geometry = null;
    this.layerName = null;
    this.layerAlias = null;
    this.attributes = null;
    this.symbol = null;
    this.id = feature.id;
    this.displayName = feature.id;
    this.geometry = feature.geometry;
    this.layerName = feature.layer;
    this.layerAlias = feature.layer;
    this.attributes = getFeatureAttributes(feature.attributes);
  }

  _createClass(EvergisFeature, [{
    key: "sGisFeature",
    value: function sGisFeature() {
      if (!this.geometry || !this.symbol) {
        return null;
      } // @ts-ignore


      const {
        type,
        coordinates,
        sr
      } = this.geometry;
      const crs = CRS_MAP[sr];

      if (!crs) {
        return null;
      }

      switch (type) {
        case GeometryType.Point:
          return new PointFeature(coordinates, {
            symbol: selectedPoint,
            crs
          });

        case GeometryType.Multipoint:
          return new MultiPoint(coordinates, {
            symbol: selectedPoint,
            crs
          });

        case GeometryType.Polyline:
          return new Polyline(coordinates, {
            symbol: selectedPolyline,
            crs
          });

        case GeometryType.Polygon:
          return new Polygon(coordinates, {
            symbol: selectedPolygon,
            crs
          });

        default:
          return null;
      }
    }
  }, {
    key: "extent",
    value: function extent() {
      const feature = this.sGisFeature();
      return feature && feature.bbox;
    }
  }]);

  return EvergisFeature;
}();

function evaluateCondition(condition, attributes) {
  try {
    const evaluator = new ConditionEvaluator(attributes);
    const result = evaluator.evaluate(condition);

    if (result instanceof Error) {
      return null;
    }

    return result;
  } catch (_unused) {
    return null;
  }
}

function getAttributeValue(attributes, attributeName) {
  const attributeMeta = attributes.find(_ref => {
    let {
      name
    } = _ref;
    return name === attributeName;
  });
  return attributeMeta ? attributeMeta.value : null;
}

const getAttributeNameFromCondition = condition => new ClassificationCondition(condition).attributeName;
const getAttributeNameFromClassified = values => values.length > 0 ? getAttributeNameFromCondition(values[0].condition) : null;

function findFeatureValue(parameterValues, _ref2) {
  let [name, value] = _ref2;
  return value !== null ? parameterValues.find(_ref3 => {
    let {
      condition
    } = _ref3;
    return value !== undefined && evaluateCondition(condition, {
      [name]: value
    });
  }) : null;
}

function extractValuesAttribute(parameterValues, attributes) {
  const name = getAttributeNameFromClassified(parameterValues) || '';
  const value = name && getAttributeValue(attributes, name);
  return [name, value];
}

function evaluateFeatureSymbol(attributes) {
  // @ts-ignore
  function calc(result, _ref4) {
    let [parameterName, parameterValue] = _ref4;
    let newParameterValue;

    if (isParameterByAttribute(parameterValue)) {
      const [attributeName, attributeValue] = extractValuesAttribute(parameterValue.values, attributes);
      const featureValue = findFeatureValue(parameterValue.values, [attributeName, attributeValue]);
      newParameterValue = featureValue ? featureValue.value : parameterValue.defaultValue;
    } else if (isObject(parameterValue)) {
      // @ts-ignore
      newParameterValue = Object.entries(parameterValue).reduce(calc, parameterValue);
    }

    return newParameterValue !== undefined ? _extends({}, result, {
      [parameterName]: newParameterValue
    }) : result;
  }

  return calc;
}

function findChildFeatureStyle(childStyles, attributes) {
  return (childStyles || []).find(_ref5 => {
    let {
      condition
    } = _ref5;
    const attributeName = condition && getAttributeNameFromCondition(condition);
    const attributeValue = attributeName && getAttributeValue(attributes, attributeName);

    if (condition && attributeName && attributeValue !== undefined) {
      return evaluateCondition(condition, {
        [attributeName]: attributeValue
      });
    }

    return false;
  }) || null;
}
function findChildFeatureSymbol(childStyles, attributes) {
  const featureStyle = findChildFeatureStyle(childStyles, attributes);
  return featureStyle ? featureStyle.symbol : null;
}
function getFeatureSymbol(style, attributes) {
  if (!style || !style.symbol) {
    return null;
  }

  if (style.children !== null) {
    return findChildFeatureSymbol(style.children, attributes) || style.symbol;
  }

  return Object.entries(style.symbol).reduce(evaluateFeatureSymbol(attributes), style.symbol);
}

let EvergisLayer = /*#__PURE__*/function () {
  function EvergisLayer(service) {
    _classCallCheck(this, EvergisLayer);

    this.name = null;
    this.titleAttribute = null;
    this.alias = null;
    this.attributes = null;
    this.style = null;
    const evergisService = service;
    const {
      name,
      alias,
      style,
      layerDefinition
    } = evergisService;
    this.name = name;
    this.alias = alias || name;
    this.attributes = getLayerAttributes(layerDefinition);
    this.style = style && new EvergisStyle(style) || null;
    this.titleAttribute = layerDefinition && layerDefinition.titleAttribute || null;
  }

  _createClass(EvergisLayer, [{
    key: "evaluateFeature",
    value: function evaluateFeature(feature) {
      feature.attributes = mergeAttributes(feature.attributes || [], this.attributes || []);
      feature.symbol = this.style && getFeatureSymbol(this.style, feature.attributes);
      feature.layerAlias = this.alias;
      const titleAttribute = (feature.attributes || []).find(_ref => {
        let {
          name
        } = _ref;
        return name === this.titleAttribute;
      });
      const displayName = titleAttribute && formatAttributeValue(titleAttribute)[0].value || feature.id;
      feature.displayName = displayName ? "" + displayName : feature.id;
      return feature;
    }
  }]);

  return EvergisLayer;
}();

const findFeatureLayer = feature => layer => layer.name === feature.layerName;

const evaluateFeature = layers => feature => {
  const featureLayer = layers.find(findFeatureLayer(feature));
  return featureLayer ? featureLayer.evaluateFeature(feature) : feature;
};

function createValueTitle(value, index) {
  if (value.title) return value.title;
  if (isRangeClass(value)) return printRangeClass(value, index);
  if (isUniqueClass(value)) return value.uniqueValue;
  return '';
}

function isValidParameter(parameter) {
  return !(parameter != null && parameter.includes("labelSymbol")) && !(parameter != null && parameter.includes("singleObjectSymbol"));
}

var FilterConditionOperation;

(function (FilterConditionOperation) {
  FilterConditionOperation["AND"] = "&&";
  FilterConditionOperation["OR"] = "||";
})(FilterConditionOperation || (FilterConditionOperation = {}));

var ComparisonOperator;

(function (ComparisonOperator) {
  /** `==` */
  ComparisonOperator["Equals"] = "Equals";
  /** `!=` */

  ComparisonOperator["NotEquals"] = "NotEquals";
  /** `>` */

  ComparisonOperator["GreaterThan"] = "GreaterThan";
  /** `<` */

  ComparisonOperator["LessThan"] = "LessThan";
  /** `>=` */

  ComparisonOperator["GreaterOrEquals"] = "GreaterOrEquals";
  /** `<=` */

  ComparisonOperator["LessOrEquals"] = "LessOrEquals";
  ComparisonOperator["Filled"] = "Filled";
  ComparisonOperator["Empty"] = "Empty";
  /** `==` */

  ComparisonOperator["Contains"] = "Contains";
  /** `!=` */

  ComparisonOperator["NotContains"] = "NotContains";
  ComparisonOperator["StartsWith"] = "StartsWith";
  ComparisonOperator["NotStartsWith"] = "NotStartsWith";
  ComparisonOperator["EndsWith"] = "EndsWith";
  ComparisonOperator["NotEndsWith"] = "NotEndsWith";
  ComparisonOperator["Between"] = "Between";
  ComparisonOperator["Outside"] = "Outside";
})(ComparisonOperator || (ComparisonOperator = {}));

function formatArea(num) {
  let result = num;
  let measure = 'м²';

  if (num >= 10000000) {
    result = num / 1000000;
    measure = 'км²';
  } else if (num >= 10000) {
    result = num / 10000;
    measure = 'га';
  }

  return numberWithSpaces(result) + " " + measure;
}
function formatLength(num) {
  let result = num;
  let measure = 'м';

  if (num > 10000) {
    result = num / 1000;
    measure = 'км';
  }

  return numberWithSpaces(result) + " " + measure;
}
function formatPolygonMeasure(area, perimiter) {
  return "S : " + formatArea(area) + "  P : " + formatLength(perimiter);
}
function isPolylineLikePolygon(rings, resolution) {
  if (rings[0].length <= 3) {
    return false;
  }

  const coords = rings[0];
  const firstPoint = coords[0];
  const lastPoint = coords[coords.length - 1];
  const distance = resolution * 2;
  return softEquals(firstPoint[0], lastPoint[0], distance) && softEquals(firstPoint[1], lastPoint[1], distance);
}

function getScale(scale) {
  const scales = [1, 2, 5];

  for (let x = 0; x < 21; x++) {
    for (let y = 0; y < scales.length; y++) {
      const result = Math.pow(10, x) * scales[y];

      if (result > scale) {
        return result;
      }
    }
  }

  return 1;
}

const DEFAULT_FORMATTERS = {
  polygon: formatPolygonMeasure,
  length: formatLength
};

const COORD_FRACTION = 6;
const DEFAULT_LABEL_POSITION = [Infinity, Infinity];
let BaseMeasureToolCreator = /*#__PURE__*/function (_PolylineControl) {
  _inherits(BaseMeasureToolCreator, _PolylineControl);

  var _super = /*#__PURE__*/_createSuper(BaseMeasureToolCreator);

  function BaseMeasureToolCreator(map, painter, params) {
    var _this;

    _classCallCheck(this, BaseMeasureToolCreator);

    _this = _super.call(this, map, params);

    _this.cancel = () => {
      _this.fire('cancel');
    };

    _this.painter = painter;
    _this.renderLabelSymbol = params.renderLabelSymbol;
    _this.formatters = params.formatters || DEFAULT_FORMATTERS;
    _this.areaSymbol = params.areaSymbol;

    _this.on('pointAdd', _this.handlePointAdd); // @ts-ignore


    _this.on('change', _this.updateDistance);

    return _this;
  }

  _createClass(BaseMeasureToolCreator, [{
    key: "_handleMousemove",
    value: function _handleMousemove(event) {
      _get(_getPrototypeOf(BaseMeasureToolCreator.prototype), "_handleMousemove", this).call(this, event);

      this.drawPointOnMouseMove(event);
    }
  }, {
    key: "_activate",
    value: function _activate() {
      _get(_getPrototypeOf(BaseMeasureToolCreator.prototype), "_activate", this).call(this);

      this.addTempLabel();
      this.setCursor('pointer');
    }
  }, {
    key: "_deactivate",
    value: function _deactivate() {
      _get(_getPrototypeOf(BaseMeasureToolCreator.prototype), "_deactivate", this).call(this);

      this.removeCoordLabel();
      this.removeTempLabel();
      this.removeMeasureLabel();
      this.removeTempPolygon();
      this.setCursor('default');
    }
  }, {
    key: "handlePointAdd",
    value: function handlePointAdd() {
      const feature = this.activeFeature;
      if (!feature) return;
      const {
        rings,
        crs
      } = feature;

      if (isPolylineLikePolygon(rings, this.map.resolution)) {
        this.finishDrawing();
        this.fire(new DrawingFinishEvent(feature, new MouseEvent('mouseup')));
        return;
      }

      if (rings[0].length === 2) {
        const projection = crs.projectionTo(geo);
        const point = rings[0][0];
        if (!projection) return;
        const [lat, long] = projection(point);
        this.removeTempLabel();
        this.addMeasureResultLabel();
        this.addCoordLabel(lat.toFixed(COORD_FRACTION) + ", " + long.toFixed(COORD_FRACTION), point);
      } else {
        this.removeCoordLabel();
      }
    }
  }, {
    key: "polygonPreview",
    value: function polygonPreview() {
      if (this.tempPolygon) {
        this._tempLayer && this._tempLayer.remove(this.tempPolygon);
      }

      const feature = this.activeFeature;
      if (!feature) return;
      const {
        rings,
        crs
      } = feature;
      const polygonRings = [...rings[0]];
      polygonRings.shift();
      this.tempPolygon = new Polygon(polygonRings, {
        crs
      });
      this.tempPolygon.symbol = this.areaSymbol || measureAreaSymbol;
      this.activeFeature && this.activeFeature.hide();
      this._tempLayer && this._tempLayer.add(this.tempPolygon);
    }
  }, {
    key: "removeTempPolygon",
    value: function removeTempPolygon() {
      if (this.tempPolygon) {
        this._tempLayer && this._tempLayer.remove(this.tempPolygon);
        delete this.tempPolygon;
      }
    }
  }, {
    key: "updateDistance",
    value: function updateDistance(event) {
      const feature = this.activeFeature;
      const {
        ringIndex,
        pointIndex
      } = event;
      if (!feature || ringIndex === null || pointIndex === null) return;
      const {
        rings,
        crs
      } = feature;
      const position = rings[ringIndex][pointIndex];
      const length$1 = length(rings, crs);
      let content = this.formatters.length(length$1);

      if (isPolylineLikePolygon(rings, this.map.resolution)) {
        this.polygonPreview();
        const area$1 = area(rings, crs);
        content = this.formatters.polygon(area$1, length$1);
      } else if (this.tempPolygon) {
        feature.show();
        this.removeTempPolygon();
      }

      if (this.measureResultLabel) {
        this.measureResultLabel.position = position;
        this.measureResultLabel.content = content;
      }
    }
  }, {
    key: "addTempLabel",
    value: function addTempLabel() {
      this.tempLabel = new LabelFeature(DEFAULT_LABEL_POSITION, {
        content: 'Нажмите на карту, чтобы начать измерение',
        crs: this.map.crs,
        symbol: createLabelSymbol({
          renderLabel: this.renderLabelSymbol
        })
      });
      this._tempLayer && this._tempLayer.add(this.tempLabel);
    }
  }, {
    key: "addCoordLabel",
    value: function addCoordLabel(content, position) {
      this.coordLabel = new LabelFeature(position, {
        content,
        crs: this.map.crs,
        symbol: createLabelSymbol({
          renderLabel: this.renderLabelSymbol,
          onClose: this.cancel
        })
      });
      this._tempLayer && this.coordLabel && this._tempLayer.add(this.coordLabel);
    }
  }, {
    key: "addMeasureResultLabel",
    value: function addMeasureResultLabel() {
      this.measureResultLabel = new LabelFeature(DEFAULT_LABEL_POSITION, {
        crs: this.map.crs,
        symbol: createLabelSymbol({
          renderLabel: this.renderLabelSymbol
        })
      });
      this._tempLayer && this.measureResultLabel && this._tempLayer.add(this.measureResultLabel);
    }
  }, {
    key: "removeTempLabel",
    value: function removeTempLabel() {
      if (this.tempLabel) {
        this._tempLayer && this._tempLayer.remove(this.tempLabel);
        delete this.tempLabel;
      }
    }
  }, {
    key: "removeCoordLabel",
    value: function removeCoordLabel() {
      if (this.coordLabel) {
        this._tempLayer && this._tempLayer.remove(this.coordLabel);
        delete this.coordLabel;
      }
    }
  }, {
    key: "removeMeasureLabel",
    value: function removeMeasureLabel() {
      if (this.measureResultLabel) {
        this._tempLayer && this._tempLayer.remove(this.measureResultLabel);
        delete this.measureResultLabel;
      }
    }
  }, {
    key: "drawPointOnMouseMove",
    value: function drawPointOnMouseMove(event) {
      if (this.tempLabel) {
        this.tempLabel.position = event.point.position;
      }
    }
  }, {
    key: "setCursor",
    value: function setCursor(cursor) {
      const {
        wrapper
      } = this.painter;

      if (wrapper && typeof wrapper !== 'string') {
        wrapper.style.cursor = cursor;
      }
    }
  }]);

  return BaseMeasureToolCreator;
}(PolylineControl);

let BaseMeasureToolEditor = /*#__PURE__*/function (_PolyEditor) {
  _inherits(BaseMeasureToolEditor, _PolyEditor);

  var _super = /*#__PURE__*/_createSuper(BaseMeasureToolEditor);

  function BaseMeasureToolEditor(map, painter, params) {
    var _this;

    _classCallCheck(this, BaseMeasureToolEditor);

    _this = _super.call(this, map, params);

    _this.measureResult = () => {
      const feature = _this.activeFeature;
      if (!feature) return null;
      const {
        rings,
        isEnclosed,
        crs
      } = feature;
      const pointsCount = rings[0].length;
      const position = rings[0][pointsCount - 1];
      const area$1 = area(rings, crs);
      const length$1 = length(rings, crs, isEnclosed);
      const content = isEnclosed ? _this.formatters.polygon(area$1, length$1) : _this.formatters.length(length$1);
      return {
        content,
        position
      };
    };

    _this.removeFeature = () => {
      _this.fire('remove');
    };

    _this.painter = painter;
    _this.renderLabelSymbol = params.renderLabelSymbol;
    _this.formatters = params.formatters || DEFAULT_FORMATTERS;

    _this.on('change', _this.updateMeasureResult);

    _this.on('edit', _this.updateMeasureResult);

    return _this;
  }

  _createClass(BaseMeasureToolEditor, [{
    key: "_activate",
    value: function _activate() {
      _get(_getPrototypeOf(BaseMeasureToolEditor.prototype), "_activate", this).call(this);

      this.addMeasureResultLabel();
    }
  }, {
    key: "addMeasureResultLabel",
    value: function addMeasureResultLabel() {
      const measureResult = this.measureResult();
      if (measureResult === null) return;
      const {
        content,
        position
      } = measureResult;
      this.measureResultLabel = new LabelFeature(position, {
        content,
        crs: this.map.crs,
        symbol: createLabelSymbol({
          onClose: this.removeFeature,
          renderLabel: this.renderLabelSymbol
        })
      });
      this._tempLayer && this._tempLayer.add(this.measureResultLabel);
    }
  }, {
    key: "updateMeasureResult",
    value: function updateMeasureResult() {
      if (this.measureResultLabel) {
        const measureResult = this.measureResult();
        if (measureResult === null) return;
        const {
          content,
          position
        } = measureResult;
        this.measureResultLabel.content = content;
        this.measureResultLabel.position = position;
      }
    }
  }]);

  return BaseMeasureToolEditor;
}(PolyEditor);

const isNumeric = number => !isNaN(parseFloat(number)) && isFinite(number);

const isParameterType = (types, parameter) => {
  var _parameter$toLowerCas;

  return (typeof types === 'string' ? parameter == null ? void 0 : (_parameter$toLowerCas = parameter.toLowerCase()) == null ? void 0 : _parameter$toLowerCas.includes(types.toLowerCase()) : types.some(type => {
    var _parameter$toLowerCas2;

    return parameter == null ? void 0 : (_parameter$toLowerCas2 = parameter.toLowerCase()) == null ? void 0 : _parameter$toLowerCas2.includes(type.toLowerCase());
  })) || false;
};

const comparisonOperatorMapReversed = {
  [TokenType.ArEq]: ComparisonOperator.Equals,
  [TokenType.ArNotEq]: ComparisonOperator.NotEquals,
  [TokenType.ArGr]: ComparisonOperator.GreaterThan,
  [TokenType.ArLs]: ComparisonOperator.LessThan,
  [TokenType.ArGre]: ComparisonOperator.GreaterOrEquals,
  [TokenType.ArLse]: ComparisonOperator.LessOrEquals,
  [TokenType.Between]: ComparisonOperator.Between,
  [TokenType.Outside]: ComparisonOperator.Outside
};
const NUMERIC_ATTRIBUTE_TYPES = [AttributeType.Int32, AttributeType.Int64, AttributeType.DateTime, AttributeType.Double];

const formatValue = (value, isDate) => {
  return isDate ? "#'" + formatDate(value, {
    dateFormat: DateFormat.UTC,
    defaultValue: value
  }) + "'" : value ? value.toString() : 0;
};

function formatCondition(condition) {
  const {
    comparisonOperator,
    value,
    type,
    attribute
  } = condition;
  const operator = OPERATOR_CONDITION_REMAP[comparisonOperator] || comparisonOperator;
  const preparedValue = typeof value === "string" && value.includes(" - ") ? value.split(" - ") : value;
  const isDate = type === AttributeType.DateTime;
  const isBetweenOutside = BETWEEN_OPERATORS.includes(comparisonOperator);
  const escapeValue = !NUMERIC_ATTRIBUTE_TYPES.includes(type) && preparedValue !== null;

  if (isBetweenOutside && Array.isArray(preparedValue) && preparedValue[0] !== undefined) {
    return OPERATOR_CONDITION_REMAP[comparisonOperator] + "(" + attribute + ", " + formatValue(preparedValue[0], isDate) + ", " + formatValue(preparedValue[1], isDate) + ")";
  }

  const formattedValue = Array.isArray(preparedValue) ? preparedValue.map(val => formatValue(val, isDate)) : formatValue(preparedValue, isDate);
  const nulledValue = isNil(preparedValue) ? "{null}" : formattedValue;
  const valueEscaped = escapeValue && typeof nulledValue === "string" ? "'" + Char.escapeSpecChars(addOperationToValue(nulledValue, comparisonOperator)) + "'" : nulledValue;
  return attribute + " " + operator + " " + valueEscaped;
}
function createConditionString(condition) {
  if (Array.isArray(condition)) {
    return "( " + formatCondition(condition[0]) + " " + condition[0].operation + " " + formatCondition(condition[1]) + " )";
  }

  return formatCondition(condition);
}
function createCondition(_ref) {
  let {
    attribute,
    operation,
    value
  } = _ref;
  const comparisonOperator = comparisonOperatorMapReversed[operation];
  const convertedResult = convertOperatorValue(value, comparisonOperator);
  return _extends({
    attribute
  }, convertedResult);
}

function convertOperatorValue(value, comparisonOperator) {
  if (typeof value === "string") {
    const operatorIndex = +(comparisonOperator === ComparisonOperator.NotEquals);

    if (value.startsWith(Char.PERCENTAGE) && value.endsWith(Char.PERCENTAGE)) {
      return {
        value: value.slice(1, -1),
        comparisonOperator: CONTAINS_OPERATORS[operatorIndex]
      };
    }

    if (value.startsWith(Char.PERCENTAGE)) {
      return {
        value: value.slice(1),
        comparisonOperator: ENDS_WITH_OPERATORS[operatorIndex]
      };
    }

    if (value.endsWith(Char.PERCENTAGE)) {
      return {
        value: value.slice(0, -1),
        comparisonOperator: STARTS_WITH_OPERATORS[operatorIndex]
      };
    }
  }

  return {
    value,
    comparisonOperator
  };
}

const addContains = value => "%" + value + "%";

const addStartsWith = value => value + "%";

const addEndsWith = value => "%" + value;

function addOperationToValue(value, operator) {
  switch (operator) {
    case ComparisonOperator.Contains:
    case ComparisonOperator.NotContains:
      return addContains(value);

    case ComparisonOperator.StartsWith:
    case ComparisonOperator.NotStartsWith:
      return addStartsWith(value);

    case ComparisonOperator.EndsWith:
    case ComparisonOperator.NotEndsWith:
      return addEndsWith(value);

    case ComparisonOperator.Between:
      return Char.BETWEEN;

    case ComparisonOperator.Outside:
      return Char.OUTSIDE;

    default:
      return value;
  }
}

let FilterCondition = /*#__PURE__*/function () {
  function FilterCondition(condition) {
    if (condition === void 0) {
      condition = null;
    }

    _classCallCheck(this, FilterCondition);

    this.condition = condition;
    this.conditionInterpreter = new ConditionInterpreter(condition);
  }

  _createClass(FilterCondition, [{
    key: "conditions",
    get: function get() {
      const {
        value
      } = this.conditionInterpreter;

      if (value instanceof Error) {
        // TODO handle errors in client notifications
        console.warn(value.message);
      }

      return value instanceof Error ? [] : value.expressions.map(createCondition);
    }
  }, {
    key: "conditionOperation",
    get: function get() {
      const {
        value
      } = this.conditionInterpreter;

      if (value instanceof Error) {
        return null;
      }

      const isOrCondition = value.boolOperations.includes(TokenType.BoolOr);
      const isAndCondition = value.boolOperations.includes(TokenType.BoolAnd);

      if (isOrCondition && isAndCondition) {
        return null;
      }

      return isOrCondition ? FilterConditionOperation.OR : isAndCondition ? FilterConditionOperation.AND : null;
    }
  }, {
    key: "isParsingError",
    value: function isParsingError() {
      return this.conditionInterpreter.value instanceof Error;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.condition;
    }
  }], [{
    key: "from",
    value: function from(conditions, operation) {
      const condition = (conditions == null ? void 0 : conditions.map(createConditionString).join(" " + operation + " ")) || null;
      return new FilterCondition(condition);
    }
  }]);

  return FilterCondition;
}();

const isLayerService = value => isObject(value) && 'name' in value;
const getAttributeFromCondition = condition => {
  const parts = condition.split(' ');
  return parts[0].startsWith('(') ? parts[0].slice(1) : parts[0];
};
const getExprFromCondition = (condition, partIndex) => {
  var _expr;

  let expr;

  if (partIndex) {
    const parts = condition.split(' && ').map(part => part.slice(1, -1));
    expr = parts[partIndex - 1];
  } else {
    expr = condition;
  }

  return (_expr = expr) == null ? void 0 : _expr.split(' ');
};
const getSignFromConditionPart = (condition, partIndex) => {
  var _getExprFromCondition;

  return (_getExprFromCondition = getExprFromCondition(condition, partIndex)) == null ? void 0 : _getExprFromCondition[1];
};
const getValueFromConditionPart = (condition, partIndex) => {
  var _getExprFromCondition2;

  return (_getExprFromCondition2 = getExprFromCondition(condition, partIndex)) == null ? void 0 : _getExprFromCondition2[2];
};
const isRangeCondition = condition => (condition == null ? void 0 : condition.includes('(')) || false;
const getSymbolParameterInfo = parameter => {
  return PARAMETER_INFOS[parameter] || DEFAULT_PARAMETER_INFO;
};
const formatUniqueClassValue = (value, formatValue) => {
  const {
    attribute,
    uniqueValue
  } = value;
  return attribute && formatValue ? formatValue(attribute.type, uniqueValue, attribute.stringFormat) : uniqueValue;
};
const getRangeValues$1 = (_ref, isDouble, isDate, index) => {
  let {
    from,
    to
  } = _ref;
  return {
    from: from !== null && index !== 0 ? isDate ? from : isDouble ? +from : +from + 1 : from,
    to
  };
};
const formatRangeClassValue = (value, formatValue, index) => {
  var _value$attribute, _value$attribute2, _value$attribute3, _value$attribute4, _value$attribute5, _value$attribute6;

  const isDouble = ((_value$attribute = value.attribute) == null ? void 0 : _value$attribute.type) === 'Double';
  const isDate = ((_value$attribute2 = value.attribute) == null ? void 0 : _value$attribute2.type) === 'DateTime';
  const {
    from,
    to
  } = getRangeValues$1(value, isDouble, isDate, index);
  const formattedFrom = formatValue ? formatValue((_value$attribute3 = value.attribute) == null ? void 0 : _value$attribute3.type, from, (_value$attribute4 = value.attribute) == null ? void 0 : _value$attribute4.stringFormat) : from;
  const formattedTo = formatValue ? formatValue((_value$attribute5 = value.attribute) == null ? void 0 : _value$attribute5.type, to, (_value$attribute6 = value.attribute) == null ? void 0 : _value$attribute6.stringFormat) : to;

  if (from === null) {
    return "" + formattedTo + (!isDate ? " " + i18n.t("andLess", {
      ns: "style"
    }) : '');
  }

  if (to === null) {
    return "" + (!isDate ? i18n.t("more", {
      ns: "style"
    }) + " " : '') + formattedFrom;
  }

  return from === to ? "" + formattedFrom : formattedFrom + " - " + formattedTo;
};
const checkLayerHasLegend = layerInfo => {
  var _SYMBOL_CLASSIFICATIO;

  return ((_SYMBOL_CLASSIFICATIO = SYMBOL_CLASSIFICATION[layerInfo.geometryType]) == null ? void 0 : _SYMBOL_CLASSIFICATIO.some(param => {
    var _layerInfo$style;

    const paramValue = get((_layerInfo$style = layerInfo.style) == null ? void 0 : _layerInfo$style.symbol, param);
    return (paramValue == null ? void 0 : paramValue.type) === 'byAttribute';
  })) || false;
};
const getTitleFromCondition = _ref2 => {
  let {
    condition,
    attribute,
    formatValue
  } = _ref2;
  const parts = condition == null ? void 0 : condition.split(' == ');
  const uniqueValue = parts != null && parts[1] ? parts[1].startsWith("'") && parts[1].endsWith("'") ? parts[1].slice(1, -1) : parts[1] : '';
  return attribute && formatValue ? formatValue(attribute.type, uniqueValue, attribute.stringFormat) : uniqueValue;
};
function createValueTitleFromCondition(paramValue, attribute, formatValue, index) {
  if (!attribute) return '';
  if (paramValue.title) return paramValue.title;
  const value = {
    parameterValue: getParameterValue(paramValue.value),
    attribute
  };
  const sign = getSignFromConditionPart(paramValue.condition, 1);
  const isFirstFrom = sign.includes('>');
  value.from = isFirstFrom ? getValueFromConditionPart(paramValue.condition, 1) : null;
  value.to = paramValue.condition.includes(' && ') && isFirstFrom ? getValueFromConditionPart(paramValue.condition, 2) : !isFirstFrom ? getValueFromConditionPart(paramValue.condition, 1) : null;
  if (isRangeClass(value)) return formatRangeClassValue(value, formatValue, index);
  if (isUniqueClass(value)) return formatUniqueClassValue(value, formatValue);
  return '';
} // Основывается на http://cf.everpoint.ru/pages/viewpage.action?pageId=45024217 ->
// пункт "Настраиваемые значения параметров символики в системе"
// Для добавления подготовленных значений размеров символов нужно использовать константу PREPARED_SYMBOL_SIZES

const DEFAULT_LEGEND_STYLES = {
  [0
  /* Point */
  ]: {
    fillColor: '#00000047',
    strokeWidth: 1,
    strokeColor: '#0000001f'
  },
  [1
  /* ImagePoint */
  ]: {
    maskedColor: '#00000047'
  },
  [2
  /* Line */
  ]: {
    stroke: {
      width: 2,
      color: '#00000047'
    }
  },
  [3
  /* Polygon */
  ]: {
    fill: {
      color: '#00000000',
      hatchColor: '#00000000'
    },
    stroke: {
      width: 1,
      color: '#0000001f'
    }
  }
};
const SYMBOL_SIZE_PARAMETERS = ['size', 'width', 'height']; // Основывается на http://cf.everpoint.ru/pages/viewpage.action?pageId=45024217 -> пункт "Библиотека символов"

const DEFAULT_LEGEND_SIZES = {
  circlePointSymbol: 8,
  squarePointSymbol: 12,
  imagePointSymbol: 24,
  maskedImagePointSymbol: 24,
  svgPointSymbol: 24
};

const getNonClassifiedParamValue = (baseSymbol, parameter, classificationsParams, type) => {
  if (classificationsParams.includes(parameter)) {
    const defaultParameterValue = getParameterFromSymbol(DEFAULT_LEGEND_STYLES[type], parameter);

    if (defaultParameterValue) {
      return defaultParameterValue;
    }

    if (SYMBOL_SIZE_PARAMETERS.includes(parameter) && DEFAULT_LEGEND_SIZES[baseSymbol.type]) {
      return DEFAULT_LEGEND_SIZES[baseSymbol.type];
    }
  }

  return getParameterValue(getParameterFromSymbol(baseSymbol, parameter));
};

const updateSymbolParameter = (symbol, path, value) => symbolParameterWalker(() => value)(symbol, path);

const createPointSymbol = (baseSymbol, parameter, classificationsParams, parameterValue) => {
  return updateSymbolParameter(_extends({}, baseSymbol, {
    fillColor: getNonClassifiedParamValue(baseSymbol, 'fillColor', classificationsParams, 0
    /* Point */
    ),
    strokeColor: getNonClassifiedParamValue(baseSymbol, 'strokeColor', classificationsParams, 0
    /* Point */
    ),
    strokeWidth: getNonClassifiedParamValue(baseSymbol, 'strokeWidth', classificationsParams, 0
    /* Point */
    ),
    size: getNonClassifiedParamValue(baseSymbol, 'size', classificationsParams, 0
    /* Point */
    ),
    offset: [0, 0]
  }), parameter, parameterValue);
};

function getDimensions(symbol, size) {
  const height = getParameterValue(symbol.height);
  const width = getParameterValue(symbol.width);

  if (width === height) {
    return {
      width: size,
      height: size
    };
  }

  const ratio = height / width;

  if (width < height) {
    return {
      width: size,
      height: height + (size - width) * ratio
    };
  }

  return {
    width: width + (size - height) * ratio,
    height: size
  };
}

const createImagePointSymbol = (baseSymbol, parameter, classificationsParams, parameterValue) => {
  let symbol = _extends({}, baseSymbol);

  if (isMaskedImageSymbol(symbol)) {
    symbol.maskedColor = getNonClassifiedParamValue(baseSymbol, 'maskedColor', classificationsParams, 1
    /* ImagePoint */
    );
  }

  if (parameter === 'height' || parameter === 'width') {
    const {
      height,
      width
    } = getDimensions(baseSymbol, parameterValue);
    symbol.height = height;
    symbol.width = width;
  } else {
    symbol.width = getNonClassifiedParamValue(baseSymbol, 'width', classificationsParams, 1
    /* ImagePoint */
    );
    symbol.height = symbol.width;
    symbol = updateSymbolParameter(symbol, parameter, parameterValue);
  }

  symbol.offset = [getParameterValue(symbol.height) / 2, getParameterValue(symbol.width) / 2];
  return symbol;
};

const createLineSymbol = (baseSymbol, parameter, classificationsParams, parameterValue) => {
  return updateSymbolParameter(_extends({}, baseSymbol, {
    type: 'polylineSymbol',
    stroke: {
      color: getNonClassifiedParamValue(baseSymbol, 'stroke.color', classificationsParams, 2
      /* Line */
      ),
      width: getNonClassifiedParamValue(baseSymbol, 'stroke.width', classificationsParams, 2
      /* Line */
      )
    }
  }), parameter, parameterValue);
};

const createPolygonSymbol = (baseSymbol, parameter, classificationsParams, parameterValue) => {
  return updateSymbolParameter(_extends({}, baseSymbol, {
    fill: {
      color: getNonClassifiedParamValue(baseSymbol, 'fill.color', classificationsParams, 3
      /* Polygon */
      ),
      hatchColor: getNonClassifiedParamValue(baseSymbol, 'fill.hatchColor', classificationsParams, 3
      /* Polygon */
      )
    },
    stroke: {
      color: getNonClassifiedParamValue(baseSymbol, 'stroke.color', classificationsParams, 3
      /* Polygon */
      ),
      width: getNonClassifiedParamValue(baseSymbol, 'stroke.width', classificationsParams, 3
      /* Polygon */
      )
    }
  }), parameter, parameterValue);
};

const createH3Symbol = (baseSymbol, parameter, classificationsParams, parameterValue) => {
  return updateSymbolParameter(_extends({}, baseSymbol, {
    fill: {
      color: getNonClassifiedParamValue(baseSymbol, 'fill.color', classificationsParams, 3
      /* Polygon */
      )
    },
    stroke: {
      color: getNonClassifiedParamValue(baseSymbol, 'stroke.color', classificationsParams, 3
      /* Polygon */
      ),
      width: getNonClassifiedParamValue(baseSymbol, 'stroke.width', classificationsParams, 3
      /* Polygon */
      )
    }
  }), parameter, parameterValue);
};

const createClusterSymbol = (baseSymbol, parameter, classificationsParams, parameterValue) => {
  return updateSymbolParameter(_extends({}, baseSymbol, {
    fillColor: getNonClassifiedParamValue(baseSymbol, 'fillColor', classificationsParams, 0
    /* Point */
    )
  }), parameter, parameterValue);
};

const createLegendSymbol = (parameterValue, parameter, classificationsParams, baseSymbol) => {
  if (isParameterValueSymbol(parameterValue)) {
    return parameterValue;
  }

  if (isClusterSymbol(baseSymbol)) {
    return createClusterSymbol(baseSymbol, parameter, classificationsParams, parameterValue);
  }

  if (isSizableSymbol(baseSymbol)) {
    return createPointSymbol(baseSymbol, parameter, classificationsParams, parameterValue);
  }

  if (isTwoDimensionalSymbol(baseSymbol)) {
    return createImagePointSymbol(baseSymbol, parameter, classificationsParams, parameterValue);
  }

  if (isPolylineSymbols(baseSymbol)) {
    return createLineSymbol(baseSymbol, parameter, classificationsParams, parameterValue);
  }

  if (isPolygonSymbol(baseSymbol)) {
    return createPolygonSymbol(baseSymbol, parameter, classificationsParams, parameterValue);
  }

  if (isH3GridSymbol(baseSymbol)) {
    return createH3Symbol(baseSymbol, parameter, classificationsParams, parameterValue);
  }

  return null;
};
function createHiddenCondition(attributeName, attributeType, value) {
  let newValue;
  let comparisonOperator;

  if (isRangeClass(value)) {
    if (value.from && value.to) {
      newValue = [value.from, value.to];
      comparisonOperator = ComparisonOperator.Outside;
    } else if (value.from) {
      newValue = value.from;
      comparisonOperator = ComparisonOperator.LessThan;
    } else if (value.to) {
      newValue = value.to;
      comparisonOperator = ComparisonOperator.GreaterThan;
    }
  } else {
    newValue = value.uniqueValue || value.title;
    comparisonOperator = ComparisonOperator.NotEquals;
  }

  return new FilterCondition(createConditionString({
    attribute: attributeName,
    type: attributeType,
    comparisonOperator: comparisonOperator,
    value: newValue
  })).toString();
}
const createOtherHiddenCondition = (values, attributeName, attributeType) => {
  const value = values[values.length - 1];
  let hiddenCondition;

  if (isRangeClass(value)) {
    hiddenCondition = new FilterCondition(createConditionString({
      attribute: attributeName,
      type: attributeType,
      comparisonOperator: ComparisonOperator.LessOrEquals,
      value: value.to || value.from
    })).toString();
  } else {
    const conditions = values.map(val => new FilterCondition(createConditionString({
      attribute: attributeName,
      type: attributeType,
      comparisonOperator: ComparisonOperator.Equals,
      value: val.uniqueValue
    })).toString());
    hiddenCondition = "( " + conditions.filter(Boolean).join(" " + FilterConditionOperation.OR + " ") + " )";
  }

  return hiddenCondition;
};
const getMinimizedLegendValues = (attribute, classified, formatValue, index, otherTitle) => {
  const other = {
    title: otherTitle,
    parameterValue: classified.defaultValue,
    hiddenCondition: createOtherHiddenCondition(classified.values.map(val => getClassificationValue(val.value, otherTitle, new ClassificationCondition(val.condition))), attribute.name, attribute.type)
  };
  const items = classified.values.map(paramValue => {
    const parameterValue = getParameterValue(paramValue.value);
    const result = {
      parameterValue,
      attribute
    };

    if (isRangeCondition(paramValue.condition)) {
      const from = getValueFromConditionPart(paramValue.condition, 1);
      const to = getValueFromConditionPart(paramValue.condition, 2);
      result.from = from ? isNumeric(from) ? +from : formatDate(from) : null;
      result.to = to ? isNumeric(to) ? +to : formatDate(to) : null;
      result.title = createValueTitleFromCondition(paramValue, attribute, formatValue, index);
      return result;
    }

    result.uniqueValue = formatValue ? formatValue(attribute.type, paramValue.value, attribute.stringFormat) : paramValue.value.toString();
    result.title = getTitleFromCondition({
      condition: paramValue.condition
    });
    result.hiddenCondition = createHiddenCondition(attribute.name, attribute.type, getClassificationValue(paramValue.value, result.title, new ClassificationCondition(paramValue.condition)));
    return result;
  });
  return [...items, other];
};
const getMaximizedLegendValues = (attribute, param, params, classified, symbol, formatValue, sectionIndex, otherTitle) => {
  const other = {
    title: otherTitle,
    symbol: createLegendSymbol(classified.defaultValue, param, params, symbol),
    hiddenCondition: createOtherHiddenCondition(classified.values.map(val => getClassificationValue(val.value, otherTitle, new ClassificationCondition(val.condition))), attribute.name, attribute.type)
  };
  const items = classified.values.map((paramValue, index) => {
    const result = {
      symbol: createLegendSymbol(paramValue.value, param, params, symbol)
    };
    result.title = isRangeCondition(paramValue.condition) ? createValueTitleFromCondition(paramValue, attribute, formatValue, sectionIndex) : getTitleFromCondition({
      condition: paramValue.condition
    });
    result.hiddenCondition = createHiddenCondition(attribute.name, attribute.type, getClassificationValue(paramValue.value, result.title, new ClassificationCondition(classified.values[index].condition)));
    return result;
  });
  return [...items, other];
};
const classifyParamsReduce = (symbol, classifyParams, index) => {
  return classifyParams == null ? void 0 : classifyParams.reduce((result, classified) => {
    const param = get(symbol, classified);
    return (param == null ? void 0 : param.type) === 'byAttribute' ? _extends({}, result, {
      [classified]: _extends({
        index
      }, param)
    }) : result;
  }, {});
};
const getClassified = layerInfo => {
  var _layerInfo$style2, _layerInfo$style2$chi, _layerInfo$style4, _layerInfo$style5;

  if (!layerInfo) return undefined;

  if ((_layerInfo$style2 = layerInfo.style) != null && (_layerInfo$style2$chi = _layerInfo$style2.children) != null && _layerInfo$style2$chi.length) {
    var _layerInfo$style3;

    return {
      symbol: {
        type: 'byAttribute',
        defaultValue: layerInfo.style.symbol,
        title: null,
        values: (_layerInfo$style3 = layerInfo.style) == null ? void 0 : _layerInfo$style3.children
      }
    };
  }

  const classifyParams = SYMBOL_CLASSIFICATION[layerInfo.geometryType];

  if ((_layerInfo$style4 = layerInfo.style) != null && _layerInfo$style4.symbol && isCombinedPolylineSymbol(layerInfo.style.symbol)) {
    var _layerInfo$style$symb;

    if (!((_layerInfo$style$symb = layerInfo.style.symbol.values) != null && _layerInfo$style$symb.length)) return undefined;
    return layerInfo.style.symbol.values.reduce((result, polyline, index) => {
      return _extends({}, result, classifyParamsReduce(polyline, classifyParams, index));
    }, {});
  }

  return classifyParamsReduce((_layerInfo$style5 = layerInfo.style) == null ? void 0 : _layerInfo$style5.symbol, classifyParams);
};
const getSymbolStrokeWidth = symbol => {
  var _symbol$background;

  return isSvgPointSymbol(symbol) ? (_symbol$background = symbol.background) == null ? void 0 : _symbol$background.strokeWidth : symbol.strokeWidth;
};
const getParameterFromSymbol = (symbol, parameter) => {
  let parameterFromSymbol = {};
  symbolParameterWalker(parameterValue => {
    parameterFromSymbol = parameterValue;
  })(symbol, parameter);
  return parameterFromSymbol;
};
const getLegendSymbolSize = symbol => {
  let size = 0;

  if (isSvgPointSymbol(symbol)) {
    size = getParameterValue(symbol.size);
  }

  if (isH3GridSymbol(symbol)) {
    size = getParameterValue(symbol.cellSize);
  }

  if (isTwoDimensionalSymbol(symbol)) {
    size = Math.max(getParameterValue(symbol.width), getParameterValue(symbol.height));
  }

  if (isSizableSymbol(symbol)) {
    const strokeWidth = getSymbolStrokeWidth(symbol);
    size = getParameterValue(symbol.size) + (strokeWidth ? getParameterValue(strokeWidth) + EXTRA_BORDER_SIZE : 0);
  }

  if (isPolylineSymbols(symbol)) {
    size = getParameterValue(getParameterFromSymbol(symbol, 'stroke.width'));
  }

  return Math.max(DEFAULT_LEGEND_SYMBOL_SIZE, size);
};
const serializeSvgPointSymbol = symbol => {
  var _symbol$figure, _symbol$background2, _symbol$background3, _symbol$background4, _symbol$background5, _symbol$figure2, _symbol$figure3;

  if (!symbol) return null;
  const figureFillColor = ((_symbol$figure = symbol.figure) == null ? void 0 : _symbol$figure.fillColor) || null;
  const bgFillColor = ((_symbol$background2 = symbol.background) == null ? void 0 : _symbol$background2.fillColor) || null;
  return _extends({
    type: 'svgPointSymbol',
    size: symbol.size,
    offset: symbol.offset,
    angle: symbol.angle
  }, bgFillColor ? {
    background: {
      id: 'symbol-bg',
      fillColor: bgFillColor,
      strokeColor: ((_symbol$background3 = symbol.background) == null ? void 0 : _symbol$background3.strokeColor) || null,
      strokeWidth: ((_symbol$background4 = symbol.background) == null ? void 0 : _symbol$background4.strokeWidth) || null,
      type: ((_symbol$background5 = symbol.background) == null ? void 0 : _symbol$background5.type) || SvgSymbolBg.Circle
    }
  } : {}, figureFillColor ? {
    figure: {
      id: 'symbol-figure',
      fillColor: figureFillColor,
      strokeColor: ((_symbol$figure2 = symbol.figure) == null ? void 0 : _symbol$figure2.strokeColor) || null,
      strokeWidth: ((_symbol$figure3 = symbol.figure) == null ? void 0 : _symbol$figure3.strokeWidth) || null
    }
  } : {});
};
const SIZE_PARAMETERS = ['size', 'height', 'strokeWidth', 'stroke.width'];
const isSizeClassification = parameter => SIZE_PARAMETERS.includes(parameter);
const getServiceConfiguration = layer => {
  const emptyServiceConfiguration = {
    name: ''
  };
  if (!isLayerService(layer) || !('configuration' in layer)) return emptyServiceConfiguration;
  return _extends({}, emptyServiceConfiguration, layer.configuration || {});
};
/** default attribute name which use for geometry info */

const GEOMETRY_ATTRIBUTE = 'geometry';
/** default attribute name which contains unique id info */

const DEFAULT_ID_ATTRIBUTE_NAME = 'gid';
const getAttributesConfiguration = layer => {
  const serviceConfiguration = getServiceConfiguration(layer);
  const emptyAttributesConfiguration = {
    geometryAttribute: GEOMETRY_ATTRIBUTE,
    idAttribute: DEFAULT_ID_ATTRIBUTE_NAME,
    tableName: ''
  };

  if (!serviceConfiguration || !('attributesConfiguration' in serviceConfiguration)) {
    return emptyAttributesConfiguration;
  }

  return _extends({}, emptyAttributesConfiguration, serviceConfiguration.attributesConfiguration || {});
};
const getLayerDefinition = layer => {
  const {
    geometryAttribute,
    idAttribute
  } = getAttributesConfiguration(layer);
  const emptyLayerDefinition = {
    attributes: {},
    geometryAttribute: geometryAttribute,
    idAttribute,
    geometryType: GeometryType.Unknown,
    titleAttribute: ''
  };

  if (!isLayerService(layer) || !('layerDefinition' in layer)) {
    return emptyLayerDefinition;
  }

  return _extends({}, emptyLayerDefinition, layer.layerDefinition || {}, {
    attributes: layer.layerDefinition.attributes || emptyLayerDefinition.attributes
  });
};
function getAttributeType(layer, attributeName) {
  const {
    attributes
  } = getLayerDefinition(layer);
  const attribute = attributes[attributeName];
  return attribute ? attribute.type : AttributeType.Unknown;
}
const getClassificationValue = (parameterValue, title, condition) => _extends({
  parameterValue,
  title
}, condition.isUnique() ? {
  uniqueValue: condition.uniqueValue
} : {
  from: condition.range[0],
  to: condition.range[1]
});

const metersToPixels = (meters, _ref) => {
  let {
    painter,
    crs = geo
  } = _ref;
  const {
    width
  } = painter;
  const zeroPoint = painter.getPointFromPxPosition(0, 0).projectTo(crs);
  const maxWidthPoint = painter.getPointFromPxPosition(width, 0).projectTo(crs);
  const widthDistance = distance(zeroPoint, maxWidthPoint);
  const pxK = width / (widthDistance || 1);
  return Math.round(meters * pxK);
};

const polygonCircleFromPoint = (center, diameter) => {
  const coordinates = [];
  const radius = diameter / 2;
  const endAngle = Math.PI * 2;
  const step = Math.max(Math.PI / 2 / radius, endAngle / 128);
  let start = 0;
  let end = endAngle;

  for (let ang = start; ang < end; ang += step) {
    coordinates.push([Math.cos(ang) * radius + center[0], Math.sin(ang) * radius + center[1]]);
  }

  return [coordinates];
};

const DEFAULT_LEGEND_SYMBOL_SIZE = 26;
const EXTRA_BORDER_SIZE = 4;
const DEFAULT_SYMBOL_SIZE = 20;
const DEFAULT_SYMBOL_WITH_BG_SIZE = 24;
const DEFAULT_SYMBOL_FILL_COLOR = 'rgba(0, 163, 245, 1)';
const DEFAULT_SYMBOL_STROKE_COLOR = 'rgb(255, 255, 255)';
const DEFAULT_SYMBOL_OFFSET = [0, 0];
const DEFAULT_CLUSTER_SVG = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56 56\" width=\"56px\" height=\"56px\">\n  <circle cx=\"28\" cy=\"28\" r=\"22\" fill=\"#00AAFF\" stroke=\"#00AAFF\" stroke-opacity=\"0.28\" stroke-width=\"12\" id=\"symbol-bg\" />\n</svg>\n";
const SYMBOL_CLASSIFICATION = {
  [GeometryType.Polygon]: ['fill.color', 'stroke.color', 'stroke.width'],
  [GeometryType.Polyline]: ['stroke.color', 'stroke.width'],
  [GeometryType.Point]: ['angle', 'size', 'fill.color', 'fillColor', 'background.fillColor', 'background.strokeColor', 'background.strokeWidth', 'figure.fillColor', 'figure.strokeColor', 'figure.strokeWidth', 'singleObjectSymbol.size', 'singleObjectSymbol.figure.fillColor', 'singleObjectSymbol.figure.strokeColor', 'singleObjectSymbol.figure.strokeWidth', 'singleObjectSymbol.background.fillColor', 'singleObjectSymbol.background.strokeColor', 'singleObjectSymbol.background.strokeWidth']
};
const SYMBOL_LIMITS = {
  SIZE_MIN: 1,
  SIZE_MAX: 64,
  SIZE_STEP: 1,
  GRID_SIZE_MIN: 0.1,
  GRID_SIZE_MAX: 120,
  MIN_OBJECTS_COUNT: 2,
  MAX_OBJECTS_COUNT: 10000,
  MIN_CLUSTER_SIZE: 16,
  MAX_CLUSTER_SIZE: 120,
  STROKE_WIDTH_MIN: 0,
  STROKE_WIDTH_MAX: 32,
  STROKE_WIDTH_STEP: 0.25,
  ANGLE_MIN: -360,
  ANGLE_MAX: 360,
  ANGLE_STEP: 1,
  PREVIEW_SIZE_MAX: 32,
  PREVIEW_SIZE_MAX_WIDTH: 26
};
const DEFAULT_PARAMETER_INFO = {
  classifyAble: true,
  min: SYMBOL_LIMITS.STROKE_WIDTH_MIN,
  max: SYMBOL_LIMITS.STROKE_WIDTH_MAX,
  step: SYMBOL_LIMITS.STROKE_WIDTH_STEP,
  units: "px"
  /* Pixels */
  ,
  serialize: value => value,
  deserialize: value => value
};
const PARAMETER_INFOS = {
  size: /*#__PURE__*/_extends({}, DEFAULT_PARAMETER_INFO, {
    min: SYMBOL_LIMITS.SIZE_MIN,
    max: SYMBOL_LIMITS.SIZE_MAX,
    step: SYMBOL_LIMITS.SIZE_STEP,
    units: "px"
    /* Pixels */

  })
};
const OPERATOR_CONDITION_REMAP = {
  [ComparisonOperator.Equals]: '==',
  [ComparisonOperator.NotEquals]: '!=',
  [ComparisonOperator.GreaterThan]: '>',
  [ComparisonOperator.GreaterOrEquals]: '>=',
  [ComparisonOperator.LessThan]: '<',
  [ComparisonOperator.LessOrEquals]: '<=',
  [ComparisonOperator.Filled]: '!=',
  [ComparisonOperator.Empty]: '==',
  [ComparisonOperator.Contains]: '==',
  [ComparisonOperator.NotContains]: '!=',
  [ComparisonOperator.StartsWith]: '==',
  [ComparisonOperator.NotStartsWith]: '!=',
  [ComparisonOperator.EndsWith]: '==',
  [ComparisonOperator.NotEndsWith]: '!=',
  [ComparisonOperator.Between]: 'between',
  [ComparisonOperator.Outside]: '!between'
};
const BASE_OPERATORS = [ComparisonOperator.Equals, ComparisonOperator.NotEquals];
const CONTAINS_OPERATORS = [ComparisonOperator.Contains, ComparisonOperator.NotContains];
const FILLED_OPERATORS = [ComparisonOperator.Filled, ComparisonOperator.Empty];
const STARTS_WITH_OPERATORS = [ComparisonOperator.StartsWith, ComparisonOperator.NotStartsWith];
const ENDS_WITH_OPERATORS = [ComparisonOperator.EndsWith, ComparisonOperator.NotEndsWith];
const RANGE_OPERATORS = [ComparisonOperator.LessThan, ComparisonOperator.LessOrEquals, ComparisonOperator.GreaterThan, ComparisonOperator.GreaterOrEquals];
const BETWEEN_OPERATORS = [ComparisonOperator.Between, ComparisonOperator.Outside];
const numberComparisonOperators = [...BASE_OPERATORS, ...RANGE_OPERATORS, ...FILLED_OPERATORS, ...BETWEEN_OPERATORS];
const dateComparisonOperators = [...BASE_OPERATORS, ...RANGE_OPERATORS, ...FILLED_OPERATORS, ...BETWEEN_OPERATORS];
const textComparisonOperators = [...BASE_OPERATORS, ...CONTAINS_OPERATORS, ...STARTS_WITH_OPERATORS, ...ENDS_WITH_OPERATORS, ...FILLED_OPERATORS];

var SvgSymbolBg;

(function (SvgSymbolBg) {
  SvgSymbolBg["Rect"] = "rect";
  SvgSymbolBg["Circle"] = "circle";
})(SvgSymbolBg || (SvgSymbolBg = {}));

const DEFAULT_STROKE_OPACITY = 0.28;
const convertSvgToBase64 = svg => "data:image/svg+xml;base64," + window.btoa(svg);
const createSvgGradient = (svg, values) => svg.gradient('linear', add => {
  values == null ? void 0 : values.forEach((_ref, index) => {
    let {
      value
    } = _ref;
    add.stop(index / ((values == null ? void 0 : values.length) - 1), value);
  });
}).from(0, 0).to(1, 1); // eslint-disable-next-line max-lines-per-function

const manipulateSvgSymbol = _ref2 => {
  var _$exec2;

  let {
    SVGContainer,
    symbol,
    svg,
    bg,
    isClassified
  } = _ref2;
  if (!symbol) return SVGContainer;
  const symbolData = getParameterValue(svg || symbol.data);
  if (!symbolData) return SVGContainer;
  SVGContainer.clear();
  const {
    size,
    angle,
    background,
    figure
  } = symbol;
  const isUploadedFile = !bg && !symbolData.includes('symbol-bg') && !symbolData.includes('symbol-figure');
  const innerSvg = symbolData.replace(/<\?xml[^?]*\?>|<svg[^>]*>|<\/svg>/g, '');

  if (isUploadedFile) {
    var _$exec;

    SVGContainer.svg(innerSvg);
    const uploadedViewBox = (_$exec = /viewBox="([^"]+)"/g.exec(symbolData)) == null ? void 0 : _$exec[1];

    if (uploadedViewBox != null && uploadedViewBox[1]) {
      SVGContainer.viewbox(uploadedViewBox);
    }

    SVGContainer.size(size);
  } else {
    const hasBg = bg || (innerSvg == null ? void 0 : innerSvg.includes('symbol-bg'));
    let defaultSize = hasBg ? DEFAULT_SYMBOL_WITH_BG_SIZE : DEFAULT_SYMBOL_SIZE;
    const currentSize = size || defaultSize;
    let viewBox = [0, 0, defaultSize, defaultSize];
    const strokeWidth = getParameterValue(background == null ? void 0 : background.strokeWidth) || (typeof (background == null ? void 0 : background.strokeColor) === 'object' ? 1 : 0);

    if (strokeWidth) {
      defaultSize += strokeWidth;
      viewBox = [-strokeWidth / 2, -strokeWidth / 2, defaultSize, defaultSize];
    }

    if (hasBg) {
      SVGContainer.size(currentSize + "px", currentSize + "px").viewbox(viewBox.join(' '));
      const currentBg = bg || (background == null ? void 0 : background.type);

      if (currentBg) {
        const strokeColor = getParameterValue(background == null ? void 0 : background.strokeColor);
        const fillColor = getParameterValue(background == null ? void 0 : background.fillColor);
        SVGContainer.svg(currentBg === SvgSymbolBg.Circle ? "<circle\n                id=\"symbol-bg\"\n                cx=\"" + DEFAULT_SYMBOL_WITH_BG_SIZE / 2 + "\"\n                cy=\"" + DEFAULT_SYMBOL_WITH_BG_SIZE / 2 + "\"\n                r=\"" + DEFAULT_SYMBOL_WITH_BG_SIZE / 2 + "\"\n                fill=\"" + (fillColor || DEFAULT_SYMBOL_FILL_COLOR) + "\"\n                stroke=\"" + (strokeColor || DEFAULT_SYMBOL_STROKE_COLOR) + "\"\n                stroke-width=\"" + strokeWidth + "\"\n              />" : "<rect\n                id=\"symbol-bg\"\n                width=\"" + DEFAULT_SYMBOL_WITH_BG_SIZE + "\"\n                height=\"" + DEFAULT_SYMBOL_WITH_BG_SIZE + "\"\n                rx=\"4\"\n                fill=\"" + (fillColor || DEFAULT_SYMBOL_FILL_COLOR) + "\"\n                stroke=\"" + (strokeColor || DEFAULT_SYMBOL_STROKE_COLOR) + "\"\n                stroke-width=\"" + strokeWidth + "\"\n              />");
        SVGContainer.svg(innerSvg);
        SVGContainer.find('#symbol-bg:not(:first-child)').each(item => item.remove());
        SVGContainer.find(':not(#symbol-bg)').each(item => item.center(DEFAULT_SYMBOL_WITH_BG_SIZE / 2, DEFAULT_SYMBOL_WITH_BG_SIZE / 2).fill('white'));
        const symbolBg = SVGContainer.find('#symbol-bg')[0];

        if (isClassified) {
          symbolBg == null ? void 0 : symbolBg.stroke({
            opacity: DEFAULT_STROKE_OPACITY
          });
        } // eslint-disable-next-line max-depth


        if (isParameterByAttribute(background == null ? void 0 : background.fillColor)) {
          var _background$fillColor;

          symbolBg == null ? void 0 : symbolBg.fill(createSvgGradient(SVGContainer, background == null ? void 0 : (_background$fillColor = background.fillColor) == null ? void 0 : _background$fillColor.values));
        }

        if (isParameterByAttribute(background == null ? void 0 : background.strokeColor)) {
          var _background$strokeCol;

          symbolBg == null ? void 0 : symbolBg.stroke({
            color: createSvgGradient(SVGContainer, background == null ? void 0 : (_background$strokeCol = background.strokeColor) == null ? void 0 : _background$strokeCol.values)
          });
        }
      } else {
        SVGContainer.svg(innerSvg);
      }
    } else {
      const strokeColor = getParameterValue(figure == null ? void 0 : figure.strokeColor);
      const strokeWidth = getParameterValue(figure == null ? void 0 : figure.strokeWidth) || (typeof (figure == null ? void 0 : figure.strokeColor) === 'object' ? 1 : 0);
      const fillColor = getParameterValue(figure == null ? void 0 : figure.fillColor);
      SVGContainer.size(currentSize + "px", currentSize + "px").viewbox(viewBox.join(' '));
      SVGContainer.svg(innerSvg);
      SVGContainer.find('#symbol-figure').each(item => {
        item.center(DEFAULT_SYMBOL_SIZE / 2, DEFAULT_SYMBOL_SIZE / 2).fill(fillColor || DEFAULT_SYMBOL_FILL_COLOR).stroke({
          color: strokeColor,
          width: strokeWidth
        });

        if (isParameterByAttribute(figure == null ? void 0 : figure.fillColor)) {
          var _figure$fillColor;

          item == null ? void 0 : item.fill(createSvgGradient(SVGContainer, figure == null ? void 0 : (_figure$fillColor = figure.fillColor) == null ? void 0 : _figure$fillColor.values));
        }

        if (isParameterByAttribute(figure == null ? void 0 : figure.strokeColor)) {
          var _figure$strokeColor;

          item == null ? void 0 : item.stroke({
            color: createSvgGradient(SVGContainer, figure == null ? void 0 : (_figure$strokeColor = figure.strokeColor) == null ? void 0 : _figure$strokeColor.values)
          });
        }
      });
    }
  }

  const rootTransform = (_$exec2 = /<svg[^>]*transform="([^"]+)"/g.exec(symbolData)) == null ? void 0 : _$exec2[1];

  if (rootTransform) {
    const transformParts = rootTransform.slice(0, -1).split('(');
    SVGContainer.transform({
      [transformParts[0]]: transformParts[1].split(',')
    });
  }

  const rotatedAngle = SVGContainer.transform('rotate');

  if (rotatedAngle) {
    SVGContainer.rotate(-rotatedAngle, 0, 0);
  }

  if (angle !== undefined) {
    SVGContainer.rotate(angle * (180 / Math.PI), 0, 0);
  }

  return SVGContainer;
};

let CircleLineMiterRender = /*#__PURE__*/function (_LineMiterRender) {
  _inherits(CircleLineMiterRender, _LineMiterRender);

  var _super = /*#__PURE__*/_createSuper(CircleLineMiterRender);

  function CircleLineMiterRender() {
    _classCallCheck(this, CircleLineMiterRender);

    return _super.apply(this, arguments);
  }

  _createClass(CircleLineMiterRender, [{
    key: "usageSize",
    get: function get() {
      return this.miterSize + this.strokeWidth * 3;
    }
  }, {
    key: "createRings",
    value: function createRings(_ref, xMultiplier) {
      let [x, y] = _ref;
      return [[[x + (this.miterSize / 2 + this.strokeWidth) * xMultiplier, y]]];
    }
  }, {
    key: "createRender",
    value: function createRender(miterRings) {
      const isFilled = this.kind === LineEndingType.FilledCircle;
      return new PolyRender(polygonCircleFromPoint(miterRings[0][0], this.miterSize), {
        fillColor: isFilled ? this.color : 'transparent',
        strokeColor: this.color,
        strokeWidth: this.strokeWidth,
        enclosed: true
      });
    }
  }]);

  return CircleLineMiterRender;
}(LineMiterRender);

let SquareLineMiterRender = /*#__PURE__*/function (_LineMiterRender) {
  _inherits(SquareLineMiterRender, _LineMiterRender);

  var _super = /*#__PURE__*/_createSuper(SquareLineMiterRender);

  function SquareLineMiterRender() {
    _classCallCheck(this, SquareLineMiterRender);

    return _super.apply(this, arguments);
  }

  _createClass(SquareLineMiterRender, [{
    key: "usageSize",
    get: function get() {
      return this.miterSize + this.strokeWidth;
    }
  }, {
    key: "createRings",
    value: function createRings(_ref, xMultiplier) {
      let [x, y] = _ref;
      return [[[x, y + this.miterSize / 2], [x, y - this.miterSize / 2], [x + this.miterSize * xMultiplier, y - this.miterSize / 2], [x + this.miterSize * xMultiplier, y + this.miterSize / 2]]];
    }
  }, {
    key: "createRender",
    value: function createRender(miterRings) {
      const isFilled = this.kind === LineEndingType.FilledSquare;
      return new PolyRender(miterRings, {
        enclosed: true,
        fillColor: isFilled ? this.color : void 0,
        fillStyle: isFilled ? FillStyle.Color : FillStyle.None,
        lineCap: 'square',
        lineJoin: 'miter',
        strokeColor: this.color,
        strokeWidth: this.strokeWidth
      });
    }
  }]);

  return SquareLineMiterRender;
}(LineMiterRender);

const getLineMiterRender = options => {
  switch (options.kind) {
    case LineEndingType.Arrow:
    case LineEndingType.FilledArrow:
      return new ArrowLineMiterRender(options);

    case LineEndingType.Square:
    case LineEndingType.FilledSquare:
      return new SquareLineMiterRender(options);

    case LineEndingType.Circle:
    case LineEndingType.FilledCircle:
      return new CircleLineMiterRender(options);

    default:
      return null;
  }
};

const updateRingForRightMiter = (ring, miterSize, isLastRing) => {
  const reversedRing = ring.slice().reverse();

  for (let i = 0; i < reversedRing.length; i++) {
    const coordinates = reversedRing[i];

    if (isLastRing && i === 0) {
      reversedRing[i] = [coordinates[0] - miterSize, coordinates[1]];
    }

    const nextCoordinates = reversedRing[i - 1];

    if (nextCoordinates && nextCoordinates[0] < coordinates[0]) {
      reversedRing[i] = [nextCoordinates[0] - Math.abs(nextCoordinates[0] - coordinates[0]), coordinates[1]];
    }
  }

  return reversedRing.reverse();
};

const updateRingForLeftMiter = (ring, miterSize, isFirstRing) => {
  const newRing = ring.slice();

  for (let i = 0; i < newRing.length; i++) {
    const coordinates = newRing[i];

    if (i === 0 && isFirstRing) {
      newRing[i] = [coordinates[0] + miterSize, coordinates[1]];
    }

    const prevCoordinates = newRing[i - 1];

    if (prevCoordinates && prevCoordinates[0] > coordinates[0]) {
      newRing[i] = [prevCoordinates[0] + Math.abs(coordinates[0] - prevCoordinates[0]), coordinates[1]];
    }
  }

  return newRing;
};

const updateRingsForMiter = (rings, position, miterSize) => {
  return rings.map((ring, ringIndex) => {
    switch (position) {
      case 'right':
        return updateRingForRightMiter(ring, miterSize, ringIndex === rings.length - 1);

      default:
        return updateRingForLeftMiter(ring, miterSize, ringIndex === 0);
    }
  });
};

const copyRings = rings => rings.map(ring => ring.map(coordinates => coordinates.slice()));
let SGisPolylineSymbol = /*#__PURE__*/function (_sPolylineSymbol) {
  _inherits(SGisPolylineSymbol, _sPolylineSymbol);

  var _super = /*#__PURE__*/_createSuper(SGisPolylineSymbol);

  function SGisPolylineSymbol(originalSymbol) {
    var _originalSymbol$strok, _originalSymbol$strok2;

    var _this;

    _classCallCheck(this, SGisPolylineSymbol);

    _this = _super.call(this, {
      // @ts-ignore
      strokeColor: getHexColor(getParameterValue((_originalSymbol$strok = originalSymbol.stroke) == null ? void 0 : _originalSymbol$strok.color)),
      strokeWidth: clamp( // @ts-ignore
      getParameterValue((_originalSymbol$strok2 = originalSymbol.stroke) == null ? void 0 : _originalSymbol$strok2.width), PREVIEW_LIMITS.STROKE_WIDTH_MIN, PREVIEW_LIMITS.STROKE_WIDTH_MAX),
      // @ts-ignore
      lineDash: getLineDash(originalSymbol.stroke),
      // @ts-ignore
      lineCap: isDashedBrush(originalSymbol.stroke) ? 'square' : 'round'
    });
    _this.originalSymbol = originalSymbol;
    return _this;
  }

  _createClass(SGisPolylineSymbol, [{
    key: "renderFunction",
    value: function renderFunction(feature, resolution, crs) {
      if (!isSimplePolylineSymbol(this.originalSymbol)) return _get(_getPrototypeOf(SGisPolylineSymbol.prototype), "renderFunction", this).call(this, feature, resolution, crs);
      const {
        ending,
        beginning
      } = this.originalSymbol;
      const renders = [];
      const featureCopy = feature.clone();
      const beginningMiterRender = getLineMiterRender({
        color: this.strokeColor,
        // @ts-ignore
        kind: beginning.type,
        position: 'left',
        // @ts-ignore
        size: beginning.size,
        strokeWidth: this.strokeWidth
      });
      const endingMiterRender = getLineMiterRender({
        color: this.strokeColor,
        // @ts-ignore
        kind: ending.type,
        position: 'right',
        // @ts-ignore
        size: ending.size,
        strokeWidth: this.strokeWidth
      });

      if (beginningMiterRender) {
        const updatedRings = updateRingsForMiter(featureCopy.rings, 'left', beginningMiterRender.usageSize);
        const render = beginningMiterRender.getRender(updatedRings, feature.crs, resolution, crs);
        featureCopy.rings = updatedRings;
        renders.push(render);
      }

      if (endingMiterRender) {
        const updatedRings = updateRingsForMiter(featureCopy.rings, 'right', endingMiterRender.usageSize);
        const render = endingMiterRender.getRender(updatedRings, feature.crs, resolution, crs);
        featureCopy.rings = updatedRings;
        renders.push(render);
      } // NOTE: линия должна быть в начале чтобы быть под митерами


      renders.unshift(..._get(_getPrototypeOf(SGisPolylineSymbol.prototype), "renderFunction", this).call(this, featureCopy, resolution, crs));
      return renders;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new SGisPolylineSymbol(this.originalSymbol);
    }
  }]);

  return SGisPolylineSymbol;
}(PolylineSymbol);

let LabelSymbol = /*#__PURE__*/function (_DynamicPointSymbol) {
  _inherits(LabelSymbol, _DynamicPointSymbol);

  var _super = /*#__PURE__*/_createSuper(LabelSymbol);

  function LabelSymbol(_temp) {
    var _this;

    let {
      component,
      offset
    } = _temp === void 0 ? {} : _temp;

    _classCallCheck(this, LabelSymbol);

    _this = _super.call(this, {
      offset
    });
    _this.component = component;
    return _this;
  }

  _createClass(LabelSymbol, [{
    key: "_getFeatureNode",
    value: function _getFeatureNode(feature) {
      const node = document.createElement('div');
      this.renderDom(feature.content, node);
      return node;
    }
  }, {
    key: "_updateFeatureNode",
    value: function _updateFeatureNode(feature) {
      this.renderDom(feature.content, this.getNode(feature));
    }
  }, {
    key: "renderDom",
    value: function renderDom(content, node) {
      if (!node) {
        return;
      }

      const Component = this.component;

      if (Component) {
        ReactDOM.render(React.createElement(Component, {
          content: content
        }), node);
      } else {
        node.innerText = content;
      }
    }
  }]);

  return LabelSymbol;
}(DynamicPointSymbol);

const defaultOffset = [8, -16];
const createLabelSymbol = props => {
  const {
    offset = defaultOffset,
    renderLabel = _ref => {
      let {
        content
      } = _ref;
      return React.createElement("div", null, content);
    },
    onClose = undefined
  } = props || {};
  return new LabelSymbol({
    offset,
    component: _ref2 => {
      let {
        content
      } = _ref2;
      return renderLabel({
        content,
        onClose
      });
    }
  });
};

let ShadowedPointSymbol = /*#__PURE__*/function (_PointSymbol) {
  _inherits(ShadowedPointSymbol, _PointSymbol);

  var _super = /*#__PURE__*/_createSuper(ShadowedPointSymbol);

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function ShadowedPointSymbol(options) {
    _classCallCheck(this, ShadowedPointSymbol);

    return _super.call(this, options);
  }

  _createClass(ShadowedPointSymbol, [{
    key: "renderFunction",
    value: function renderFunction(feature, resolution, crs) {
      if (!(feature instanceof PointFeature)) return [];
      const {
        position
      } = feature.projectTo(crs);
      const pxPosition = [position[0] / resolution + (this.offset[0] || 0), -position[1] / resolution + (this.offset[1] || 0)];
      const shadowRender = this.getShadow(pxPosition, feature, position);
      const pointArc = this.getPoint(pxPosition, feature, position);
      return shadowRender ? [shadowRender, pointArc] : [pointArc];
    }
  }, {
    key: "getShadow",
    value: function getShadow(position, _feature, mapCoordinates) {
      return ShadowedPointSymbol.getShadowArc(position, this, mapCoordinates);
    }
  }, {
    key: "getPoint",
    value: function getPoint(position, _feature, mapCoordinates) {
      return ShadowedPointSymbol.getPointArc(position, this, mapCoordinates);
    }
  }], [{
    key: "getShadowArc",
    value: function getShadowArc(position, _ref, mapCoordinates) {
      let {
        strokeWidth = 2,
        shadowColor,
        shadowSize,
        size = 6
      } = _ref;
      return new Arc(position, {
        fillColor: "transparent",
        strokeColor: shadowColor,
        strokeWidth: shadowSize,
        radius: (size + strokeWidth + shadowSize) / 2,
        mapCoordinates
      });
    }
  }, {
    key: "getPointArc",
    value: function getPointArc(position, _ref2, mapCoordinates) {
      let {
        strokeWidth,
        fillColor,
        strokeColor,
        size = 6
      } = _ref2;
      return new Arc(position, {
        fillColor,
        strokeColor,
        strokeWidth,
        radius: size / 2,
        mapCoordinates
      });
    }
  }]);

  return ShadowedPointSymbol;
}(PointSymbol);

const getSimplifiedPolygonCoordinates = function getSimplifiedPolygonCoordinates(feature, crs, tolerance) {
  if (tolerance === void 0) {
    tolerance = 1;
  }

  const projected = feature.crs.equals(crs) ? feature.rings : feature.projectTo(crs).rings;
  return simplifyCoordinates(projected, tolerance);
};
function createShadowRender(position, _ref) {
  let {
    strokeWidth = 1,
    shadowColor,
    shadowSize,
    size = 3,
    mapCoordinates
  } = _ref;
  const shadowRadius = (size + strokeWidth + shadowSize) / 2;
  return new Arc(position, {
    fillColor: "transparent",
    strokeColor: shadowColor,
    strokeWidth: shadowSize,
    radius: shadowRadius,
    mapCoordinates
  });
}
function createPointRender(position, _ref2) {
  let {
    strokeColor,
    strokeWidth,
    fillColor,
    size = 3,
    mapCoordinates
  } = _ref2;
  const radius = size / 2;
  return new Arc(position, {
    fillColor,
    strokeColor,
    strokeWidth,
    radius,
    mapCoordinates
  });
}
let ShadowedPolySymbol = /*#__PURE__*/function (_PolylineSymbol) {
  _inherits(ShadowedPolySymbol, _PolylineSymbol);

  var _super = /*#__PURE__*/_createSuper(ShadowedPolySymbol);

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function ShadowedPolySymbol(options) {
    _classCallCheck(this, ShadowedPolySymbol);

    return _super.call(this, options);
  }

  _createClass(ShadowedPolySymbol, [{
    key: "renderFunction",
    value: function renderFunction(feature, resolution, crs) {
      if (!(feature instanceof Poly)) return [];

      const coordinates = _get(_getPrototypeOf(ShadowedPolySymbol.prototype), "getRenderedCoordinates", this).call(this, feature, resolution, crs);

      const simplifiedFeatureCoordinates = getSimplifiedPolygonCoordinates(feature, crs);
      const polyRender = this.getPolyRender(coordinates, feature, simplifiedFeatureCoordinates);
      const shadowRender = this.getShadow(coordinates, feature, simplifiedFeatureCoordinates);
      const vertexRenders = this.getVertexRenders(coordinates, simplifiedFeatureCoordinates);
      let renders = [polyRender];

      if (shadowRender) {
        renders = [shadowRender, polyRender];
      }

      if (vertexRenders) {
        renders = renders.concat(vertexRenders);
      }

      return renders;
    }
  }, {
    key: "getShadow",
    value: function getShadow(coordinates, _feature, mapCoordinates) {
      return new PolyRender(coordinates, {
        fillStyle: FillStyle.None,
        enclosed: this.enclose,
        strokeColor: this.shadowColor,
        strokeWidth: this.shadowSize,
        lineDash: this.lineDash,
        mapCoordinates
      });
    }
  }, {
    key: "getPolyRender",
    value: function getPolyRender(coordinates, _feature, mapCoordinates) {
      return new PolyRender(coordinates, {
        fillStyle: this.enclose ? FillStyle.Color : FillStyle.None,
        enclosed: this.enclose,
        fillColor: this.fillColor,
        strokeColor: this.strokeColor,
        strokeWidth: this.strokeWidth,
        lineDash: this.lineDash,
        mapCoordinates
      });
    }
  }, {
    key: "getVertexRenders",
    value: function getVertexRenders(coordinates, mapCoordinates) {
      if (!this.showVertex) return;
      const pointRenderers = [];
      const shadowRenderers = [];

      for (let i = 0; i < coordinates.length; i++) {
        const ring = coordinates[i];

        for (let j = 0; j < ring.length; j++) {
          const point = ring[j];
          const featurePoint = mapCoordinates[i][j];
          const shadowRender = createShadowRender(point, {
            size: 6,
            strokeWidth: 2,
            shadowColor: this.shadowColor,
            strokeColor: this.strokeColor,
            shadowSize: this.vertexShadowSize !== undefined ? this.vertexShadowSize : 2,
            fillColor: 'transparent',
            mapCoordinates: featurePoint
          });
          const pointRender = createPointRender(point, {
            size: 6,
            strokeWidth: 2,
            shadowColor: this.shadowColor,
            strokeColor: this.strokeColor,
            shadowSize: this.vertexShadowSize !== undefined ? this.vertexShadowSize : 2,
            fillColor: '#ffffff',
            mapCoordinates: featurePoint
          });
          shadowRenderers.push(shadowRender);
          pointRenderers.push(pointRender);
        }
      }

      return [...pointRenderers, ...shadowRenderers];
    }
  }]);

  return ShadowedPolySymbol;
}(PolylineSymbol);
const polySymbolParams = {
  strokeWidth: 2,
  strokeColor: '#e33600',
  shadowSize: 8,
  shadowColor: 'rgba(227, 54, 0, 0.3)'
};
const measureSymbolParams = {
  strokeColor: '#ff6933',
  shadowSize: 0,
  vertexShadowSize: 0
};
const measureLengthSymbol = /*#__PURE__*/new ShadowedPolySymbol( /*#__PURE__*/_extends({}, polySymbolParams, measureSymbolParams, {
  enclose: false,
  showVertex: true
}));
const measureAreaSymbol = /*#__PURE__*/new ShadowedPolySymbol( /*#__PURE__*/_extends({}, polySymbolParams, measureSymbolParams, {
  fillColor: 'rgba(255, 105, 51, 0.25)',
  enclose: true,
  showVertex: true
}));
const snapSymbolParams = {
  size: 10,
  strokeWidth: 2,
  strokeColor: '#e33600',
  fillColor: '#ffffff',
  shadowColor: 'rgba(227, 54, 0, 0.3)',
  shadowSize: 3
};
const measurePolygonSnapSymbol = /*#__PURE__*/new ShadowedPointSymbol( /*#__PURE__*/_extends({}, snapSymbolParams, {
  strokeColor: '#ff6933',
  shadowSize: 0
}));

let SelectedPointSymbol = /*#__PURE__*/function (_ShadowedPointSymbol) {
  _inherits(SelectedPointSymbol, _ShadowedPointSymbol);

  var _super = /*#__PURE__*/_createSuper(SelectedPointSymbol);

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function SelectedPointSymbol(props) {
    _classCallCheck(this, SelectedPointSymbol);

    return _super.call(this, props);
  }

  _createClass(SelectedPointSymbol, [{
    key: "getShadow",
    value: function getShadow(position, feature, mapCoordinates) {
      if (feature.isSelected) {
        return _get(_getPrototypeOf(SelectedPointSymbol.prototype), "getShadow", this).call(this, position, feature, mapCoordinates);
      }
    }
  }, {
    key: "getPoint",
    value: function getPoint(position, feature, mapCoordinates) {
      const pointRender = _get(_getPrototypeOf(SelectedPointSymbol.prototype), "getPoint", this).call(this, position, feature, mapCoordinates);

      if (feature.isSelected) {
        pointRender.strokeColor = this.selectedStrokeColor;
        pointRender.fillColor = this.selectedFillColor;
      }

      return pointRender;
    }
  }]);

  return SelectedPointSymbol;
}(ShadowedPointSymbol);

let SelectedPolySymbol = /*#__PURE__*/function (_ShadowedPolySymbol) {
  _inherits(SelectedPolySymbol, _ShadowedPolySymbol);

  var _super = /*#__PURE__*/_createSuper(SelectedPolySymbol);

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function SelectedPolySymbol(props) {
    _classCallCheck(this, SelectedPolySymbol);

    return _super.call(this, props);
  }

  _createClass(SelectedPolySymbol, [{
    key: "getShadow",
    value: function getShadow(coordinates, feature, mapCoordinates) {
      if (feature.isSelected) {
        return _get(_getPrototypeOf(SelectedPolySymbol.prototype), "getShadow", this).call(this, coordinates, feature, mapCoordinates);
      }
    }
  }, {
    key: "getPolyRender",
    value: function getPolyRender(coordinates, feature, mapCoordinates) {
      const polyRender = _get(_getPrototypeOf(SelectedPolySymbol.prototype), "getPolyRender", this).call(this, coordinates, feature, mapCoordinates);

      if (feature.isSelected) {
        polyRender.fillColor = this.selectedFillColor;
        polyRender.strokeColor = this.selectedStrokeColor;

        if (this.selectedStrokeWidth !== void 0) {
          polyRender.strokeWidth = this.selectedStrokeWidth;
        }
      }

      return polyRender;
    }
  }]);

  return SelectedPolySymbol;
}(ShadowedPolySymbol);

const selectedPoint = /*#__PURE__*/new SelectedPointSymbol({
  size: 8,
  strokeWidth: 2,
  strokeColor: 'rgba(255, 87, 34, 0.3)',
  fillColor: 'rgba(255, 255, 255, 0.65)',
  shadowColor: 'rgba(255, 87, 34, 0.3)',
  shadowSize: 3,
  selectedStrokeColor: '#ff5722',
  selectedFillColor: 'rgba(255, 255, 255, 0.65)'
});
const selectedPolyline = /*#__PURE__*/new SelectedPolySymbol({
  strokeWidth: 6,
  strokeColor: 'rgba(255, 87, 34, 0.2)',
  shadowSize: 8,
  shadowColor: 'rgba(255, 87, 34, 0.3)',
  selectedStrokeColor: '#ff5722',
  selectedStrokeWidth: 2
});
const selectedPolygon = /*#__PURE__*/new SelectedPolySymbol({
  strokeWidth: 2,
  strokeColor: 'rgba(255, 87, 34, 0.3)',
  shadowSize: 8,
  shadowColor: 'rgba(255, 87, 34, 0.3)',
  fillColor: 'rgba(255, 255, 255, 0.36)',
  enclose: true,
  selectedFillColor: 'rgba(255, 255, 255, 0.56)',
  selectedStrokeColor: '#ff5722'
});

const defaultPathStyles = {
  strokeWidth: 2,
  strokeColor: 'rgb(0, 163, 245)',
  fillStyle: FillStyle.None
};
let SVGPoly = /*#__PURE__*/function (_Symbol) {
  _inherits(SVGPoly, _Symbol);

  var _super = /*#__PURE__*/_createSuper(SVGPoly);

  function SVGPoly(_temp) {
    var _this;

    let {
      redrawFeatureNode,
      pathStyles,
      circle,
      className,
      appendToSvg
    } = _temp === void 0 ? {} : _temp;

    _classCallCheck(this, SVGPoly);

    _this = _super.call(this);
    _this.container = document.createElement('div');
    _this.container.style.position = 'absolute';
    _this.redrawFeatureNode = redrawFeatureNode;
    _this.pathStyles = _extends({
      center: [0, 0],
      fillColor: 'none'
    }, pathStyles);
    _this.circle = circle;
    _this.className = className;
    _this.appendToSvg = appendToSvg;
    return _this;
  }

  _createClass(SVGPoly, [{
    key: "renderFunction",
    value: function renderFunction(feature, resolution, crs) {
      const coordinates = feature instanceof Poly ? new PolylineSymbol().getRenderedCoordinates(feature, resolution, crs) : feature.centroid;
      this.setCirclePxRaius(crs);
      this.container.innerHTML = '';
      const svg = this.setSvg(coordinates);
      svg && this.container.append(svg);
      feature.__dynamicSymbolRender = new DynamicRender({
        node: this.container,
        update: (bbox, resolution) => this.update({
          bbox,
          resolution,
          feature,
          crs
        }),
        redraw: () => {
          this.redrawFeatureNode && this.redrawFeatureNode(feature);
        }
      });

      this._setEventListeners(feature);

      return [feature.__dynamicSymbolRender];
    }
  }, {
    key: "setCirclePxRaius",
    value: function setCirclePxRaius(crs) {
      if (this.circle && this.pathStyles) {
        var _this$circle;

        this.pathStyles.radius = metersToPixels(this.circle.radius, {
          painter: this.circle.painter,
          crs
        }) + (((_this$circle = this.circle) == null ? void 0 : _this$circle.pxOffset) || 0);
      }
    }
  }, {
    key: "update",
    value: function update(_ref) {
      var _this$pathStyles, _this$pathStyles2, _this$pathStyles3, _this$pathStyles4;

      let {
        bbox,
        resolution,
        feature,
        crs
      } = _ref;
      if (!feature) return;
      if (!bbox) bbox = feature.__lastBbox;
      if (!resolution) resolution = feature.__lastResolution;
      if (!bbox || !resolution || !feature.crs.canProjectTo(bbox.crs)) return;

      if (feature.__lastResolution && resolution !== feature.__lastResolution) {
        const newCoordinates = feature instanceof Poly ? new PolylineSymbol().getRenderedCoordinates(feature, resolution, crs) : feature.centroid;
        this.setCirclePxRaius(crs);
        this.container.innerHTML = '';
        const svg = this.setSvg(newCoordinates);
        svg && this.container.append(svg);
      }

      const polygon = feature.projectTo(bbox.crs);
      const radiusOffset = (_this$pathStyles = this.pathStyles) != null && _this$pathStyles.radius ? ((_this$pathStyles2 = this.pathStyles) == null ? void 0 : _this$pathStyles2.radius) + ((_this$pathStyles3 = this.pathStyles) != null && _this$pathStyles3.strokeWidth ? ((_this$pathStyles4 = this.pathStyles) == null ? void 0 : _this$pathStyles4.strokeWidth) / 2 : 0) : 0;
      const dx = Math.round((polygon.bbox.xMin - bbox.xMin) / resolution) - radiusOffset;
      const dy = Math.round((bbox.yMax - polygon.bbox.yMax) / resolution) - radiusOffset;
      this.container.style.left = dx.toString() + "px";
      this.container.style.top = dy.toString() + "px";
      feature.__lastBbox = bbox;
      feature.__lastResolution = resolution;
    }
  }, {
    key: "setSvg",
    value: function setSvg(coordinates) {
      const {
        lineCap,
        lineJoin,
        miterLimit,
        lineDash,
        dashOffset
      } = this.pathStyles || {};
      const svgRender = new SvgRender(_extends({
        coordinates
      }, defaultPathStyles, {
        appendToSvg: this.appendToSvg
      }, this.pathStyles));

      if (this.circle) {
        svgRender._setArcNode();
      } else {
        svgRender._setPolyNode();
      }

      let svgElement;
      svgRender.getNode((_, svg) => {
        svgElement = svg;
        this.className && svgElement.classList.add(this.className);
        const path = svgElement && svgElement.querySelector(this.circle ? 'circle' : 'path');

        if (path) {
          path.setAttribute('stroke-linecap', lineCap || 'round');
          path.setAttribute('stroke-linejoin', lineJoin || 'round');
          path.setAttribute('stroke-miterlimit', (miterLimit || 10).toString());
          path.setAttribute('stroke-dashoffset', (dashOffset || 0).toString());

          if (this.circle) {
            path.setAttribute('stroke-dasharray', lineDash && lineDash.length > 0 ? lineDash.join(',') : '');
          }
        }
      });
      return svgElement;
    }
  }, {
    key: "_setEventListeners",
    value: function _setEventListeners(dynamicFeature) {
      var _dynamicFeature$__dyn;

      if (dynamicFeature.eventFlags === MouseEventFlags.None) return;
      const svgNode = dynamicFeature == null ? void 0 : (_dynamicFeature$__dyn = dynamicFeature.__dynamicSymbolRender) == null ? void 0 : _dynamicFeature$__dyn.node.querySelector(this.circle ? 'circle' : 'path');
      Object.keys(mouseEvents).forEach(eventName => {
        if (dynamicFeature.eventFlags & mouseEvents[eventName].flag) {
          listenDomEvent(svgNode, mouseEvents[eventName].type, event => {
            dynamicFeature.fire(mouseEvents[eventName].type, {
              node: svgNode,
              browserEvent: event
            });
          });
        }
      });
    }
  }]);

  return SVGPoly;
}(Symbol$1);

function isSGisPointSymbol(symbol) {
  return symbol instanceof PointSymbol || symbol instanceof StaticImageSymbol || symbol instanceof SquareSymbol || symbol instanceof MaskedImage;
}
function isSGisImageSymbol(symbol) {
  return symbol instanceof StaticImageSymbol || symbol instanceof MaskedImage;
}
function isSGisPolygonSymbol(symbol) {
  return symbol instanceof PolygonSymbol || symbol instanceof BrushFill || symbol instanceof ImageFill;
}
function isSGisPolylineSymbol(symbol) {
  return symbol instanceof PolylineSymbol;
}
function isSGisH3Symbol(symbol) {
  return symbol instanceof H3Symbol;
}
function isSGisCombinedPolylineSymbol(symbol) {
  return symbol instanceof CombinedPolylineSymbol;
}
function isSGisClusterSymbol(symbol) {
  return !!symbol.singleObjectSymbol;
}

/**
 * Моки фич для отображения превью символа
 * http://cf.everpoint.ru/pages/viewpage.action?pageId=45024217
 */

const viewBoxSize = 100;
const pointFeature = /*#__PURE__*/new PointFeature([50, -50], {
  crs: plain
});
const lineFeature = /*#__PURE__*/new Polyline([[0, -57], [26, -57], [40, -35], [60, -65], [74, -43], [100, -43]], {
  crs: plain
});
const combinedLineFeature = /*#__PURE__*/new CombinedPolyline([[0, -57], [26, -57], [40, -35], [60, -65], [74, -43], [100, -43]], {
  crs: plain
});
const polygonFeature = /*#__PURE__*/new Polygon([[20, -20], [80, -20], [80, -80], [20, -80]], {
  crs: plain
});
const h3gridFeature = /*#__PURE__*/new H3Feature([[50, -15], [80, -33], [80, -67], [50, -85], [20, -67], [20, -33], [50, -15]], {
  crs: plain
});
const lineLegendFeature = /*#__PURE__*/new Polyline([[0, -50], [100, -50]], {
  crs: plain
});
const polygonLegendFeature = /*#__PURE__*/new Polygon([[20, -20], [80, -20], [80, -80], [20, -80]], {
  crs: plain
});
const polygonMapLegendFeature = /*#__PURE__*/new Polygon([[50, 0], [100, -25], [100, -75], [50, -100], [0, -75], [0, -25]], {
  crs: plain
});
const MAP_LEGEND_FEATURES = {
  polygon: polygonMapLegendFeature
};
const LEGEND_FEATURES = {
  point: pointFeature,
  polyline: lineLegendFeature,
  combinedPolyline: combinedLineFeature,
  polygon: polygonLegendFeature,
  h3grid: h3gridFeature
};
const MOCK_FEATURES = {
  point: pointFeature,
  polyline: lineFeature,
  combinedPolyline: combinedLineFeature,
  polygon: polygonFeature,
  h3grid: h3gridFeature
};

function getSymbolRenders(symbol, size, features) {
  if (size === void 0) {
    size = viewBoxSize;
  }

  if (features === void 0) {
    features = {};
  }

  const resolution = viewBoxSize / size;

  const featuresToRender = _extends({}, MOCK_FEATURES, features);

  if (isSGisPolygonSymbol(symbol)) {
    return symbol.renderFunctionAsync(featuresToRender.polygon, resolution, plain);
  }

  if (isSGisPolylineSymbol(symbol)) {
    return symbol.renderFunctionAsync(featuresToRender.polyline, resolution, plain);
  }

  if (isSGisH3Symbol(symbol)) {
    return symbol.renderFunctionAsync(featuresToRender.h3grid, resolution, plain);
  }

  if (isSGisCombinedPolylineSymbol(symbol)) {
    return symbol.renderFunctionAsync(featuresToRender.combinedPolyline, resolution, plain);
  }

  return symbol.renderFunctionAsync(featuresToRender.point, resolution, plain);
}
const getMapLegendSymbolRenders = function getMapLegendSymbolRenders(symbol, size) {
  if (size === void 0) {
    size = viewBoxSize;
  }

  return getSymbolRenders(symbol, size, MAP_LEGEND_FEATURES);
};
const getLegendSymbolRenders = function getLegendSymbolRenders(symbol, size) {
  if (size === void 0) {
    size = viewBoxSize;
  }

  return getSymbolRenders(symbol, size, LEGEND_FEATURES);
};

function renderSymbolToCanvas(renders, canvas) {
  renders.forEach(render => {
    canvas.draw(render);
  });
}

function deserializeSymbol(symbol) {
  switch (symbol.type) {
    case "h3grid":
      return deserializeH3Symbol(symbol);

    case "svgPointSymbol":
      return deserializeSvgPointSymbol(symbol);

    case 'circlePointSymbol':
      return deserializePointSymbol(symbol);

    case 'squarePointSymbol':
      return deserializeSquareSymbol(symbol);

    case 'maskedImagePointSymbol':
      return deserializeMaskedImageSymbol(symbol);

    case 'imagePointSymbol':
      return deserializeImagePointSymbol(symbol);

    case 'polygonSymbol':
      return deserializePolygonSymbol(symbol);

    case 'simplePolylineSymbol':
    case 'polylineSymbol':
      return deserializePolylineSymbol(symbol);

    case "clusterSymbol":
      return deserializeSymbol(symbol.singleObjectSymbol);

    default:
      return null;
  }
}

function deserializeH3Symbol(symbol) {
  var _symbol$stroke, _symbol$stroke2, _symbol$fill;

  return new H3Symbol(_extends({}, symbol, {
    cellSize: getParameterValue(symbol.cellSize),
    strokeWidth: getParameterValue(symbol == null ? void 0 : (_symbol$stroke = symbol.stroke) == null ? void 0 : _symbol$stroke.width),
    strokeColor: getParameterValue(symbol == null ? void 0 : (_symbol$stroke2 = symbol.stroke) == null ? void 0 : _symbol$stroke2.color),
    fillColor: getParameterValue(symbol == null ? void 0 : (_symbol$fill = symbol.fill) == null ? void 0 : _symbol$fill.color)
  }));
}

function deserializePointSymbol(symbol) {
  // @ts-ignore
  return new PointSymbol(deserializePointSymbolParams(symbol));
}

const getOffsetParameterValue = offset => [getParameterValue(offset == null ? void 0 : offset[0]), getParameterValue(offset == null ? void 0 : offset[1])];

function deserializeSvgPointSymbolParams(_ref) {
  let {
    type,
    data,
    size,
    offset,
    angle,
    background,
    figure
  } = _ref;
  return _extends({
    type: getParameterValue(type),
    data: getParameterValue(data),
    size: getParameterValue(size),
    offset: getOffsetParameterValue(offset),
    angle: getParameterValue(angle)
  }, background ? {
    background: _extends({}, background, {
      fillColor: deserializeColor(getParameterValue(background == null ? void 0 : background.fillColor)),
      strokeColor: deserializeColor(getParameterValue(background == null ? void 0 : background.strokeColor)),
      strokeWidth: getParameterValue(background == null ? void 0 : background.strokeWidth)
    })
  } : {}, figure ? {
    figure: _extends({}, figure, {
      strokeColor: deserializeColor(getParameterValue(figure == null ? void 0 : figure.strokeColor)),
      strokeWidth: getParameterValue(figure == null ? void 0 : figure.strokeWidth),
      fillColor: deserializeColor(getParameterValue(figure == null ? void 0 : figure.fillColor))
    })
  } : {});
}

function deserializeSvgPointSymbol(symbol) {
  return new PointSymbol(deserializeSvgPointSymbolParams(symbol));
}

function deserializeSquareSymbol(symbol) {
  return new SquareSymbol(_extends({}, deserializePointSymbolParams(symbol), {
    // @ts-ignore
    angle: getParameterValue(symbol.angle)
  }));
}

function deserializeMaskedImageSymbol(symbol) {
  return new MaskedImage(_extends({}, symbol, {
    // @ts-ignore
    angle: getParameterValue(symbol.angle),
    // @ts-ignore
    width: getParameterValue(symbol.width),
    // @ts-ignore
    height: getParameterValue(symbol.height),
    // @ts-ignore
    anchorPoint: deserializeAnchor(symbol.offset),
    // @ts-ignore
    imageSource: deserializeBase64(symbol.image),
    // @ts-ignore
    maskSource: deserializeBase64(symbol.imageMask),
    // @ts-ignore
    maskColor: deserializeColor(getParameterValue(symbol.maskedColor))
  }));
}

function deserializeImagePointSymbol(symbol) {
  return new StaticImageSymbol(_extends({}, symbol, {
    // @ts-ignore
    angle: getParameterValue(symbol.angle),
    // @ts-ignore
    width: getParameterValue(symbol.width),
    // @ts-ignore
    height: getParameterValue(symbol.height),
    // @ts-ignore
    anchorPoint: deserializeAnchor(symbol.offset),
    // @ts-ignore
    source: deserializeBase64(symbol.image)
  }));
}

function deserializePolygonSymbol(symbol) {
  if (isPolygonHasPatternBrush(symbol)) {
    return new SGisImageFill(symbol);
  }

  if (isPolygonHasHatchBrush(symbol)) {
    return new SGisBrushFill(symbol);
  }

  return new SGisPolygonSymbol(symbol);
}

function deserializePolylineSymbol(symbol) {
  return new SGisPolylineSymbol(symbol);
}

function deserializePointSymbolParams(_ref2) {
  let {
    size,
    offset,
    strokeColor,
    strokeWidth,
    fillColor
  } = _ref2;
  return {
    size: getParameterValue(size),
    offset: deserializeAnchor(offset),
    strokeWidth: getParameterValue(strokeWidth),
    strokeColor: deserializeColor(getParameterValue(strokeColor)),
    fillColor: deserializeColor(getParameterValue(fillColor))
  };
}

function deserializeBase64(base) {
  return "data:image/png;base64," + base;
}

function deserializeAnchor(offset) {
  // @ts-ignore
  return offset.map(getParameterValue);
}

function deserializeColor(color) {
  return color ? new Color(color).toString() : null;
}

const clampSymbol = (symbol, min, max) => {
  if (isSGisImageSymbol(symbol)) {
    symbol.width = clamp(symbol.width, min, max);
    symbol.height = clamp(symbol.height, min, max);
  } else if (isSGisPointSymbol(symbol)) {
    symbol.size = clamp(symbol.size, min, max);
  }

  return symbol;
};
function centerAlignSymbol(symbol) {
  if (isSGisImageSymbol(symbol)) {
    symbol.anchorPoint = [symbol.width / 2, symbol.height / 2];
  } else if (isSGisPointSymbol(symbol)) {
    symbol.offset = [0, 0];
  }

  return symbol;
}
const adjustSymbol = (symbol, _ref) => {
  let {
    size
  } = _ref;
  return centerAlignSymbol(clampSymbol(symbol, 0, size));
};

const DEFAULT_SYMBOL_SIZE$1 = 26;
function useSymbol(_ref, canvasRef) {
  let {
    symbol,
    size = DEFAULT_SYMBOL_SIZE$1,
    render = getSymbolRenders,
    maxWidth
  } = _ref;
  useEffect(() => {
    if (canvasRef.current !== null && symbol !== undefined) {
      const canvas = canvasRef.current;
      setCanvasSize(canvas, size, maxWidth);
      render(symbol, size).then(renders => {
        renderSymbolToCanvas(renders, canvas);
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [symbol, size, maxWidth]);
}

function setCanvasSize(canvas, size, maxWidth) {
  canvas.node.height = size;
  canvas.node.width = maxWidth ? Math.min(size, maxWidth) : size;
}

function useCanvas() {
  const canvas = useRef(null);
  const ref = useCallback(node => {
    if (node !== null) {
      canvas.current = new Canvas(node);
    } else {
      canvas.current = null;
    }
  }, []);
  return {
    canvas,
    ref
  };
}

function useMount(_ref) {
  let {
    onMount,
    onUnmount
  } = _ref;
  useEffect(() => {
    onMount && onMount();
    return onUnmount; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

function useProperty(_ref, deps) {
  let {
    factory,
    destructor,
    update
  } = _ref;

  if (deps === void 0) {
    deps = [];
  }

  const propRef = useRef();
  useMount({
    onUnmount() {
      if (propRef.current && destructor) {
        destructor(propRef.current);
      }
    }

  });
  return useMemo(() => {
    if (propRef.current) {
      if (update) {
        const newProp = update(propRef.current, deps, {
          factory,
          destructor
        });
        if (newProp) propRef.current = newProp;
      } else if (destructor) {
        destructor(propRef.current);
      }
    } else {
      if (!update || !propRef.current) {
        propRef.current = factory(deps);
      }
    }

    return propRef.current; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

function useUpdate(_ref) {
  let {
    onUpdate,
    shouldUpdate,
    deps
  } = _ref;
  useEffect(() => {
    if (!shouldUpdate || shouldUpdate()) {
      onUpdate();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, deps);
}

function useLayerOrder(layer, zIndex) {
  const {
    map
  } = useMapContext();
  useUpdate({
    onUpdate: () => map.insertLayer(layer, zIndex),
    deps: [zIndex, layer]
  });
}

function useLayerVisibility(layer, isDisplayed) {
  if (isDisplayed === void 0) {
    isDisplayed = true;
  }

  useUpdate({
    shouldUpdate: () => layer.isDisplayed !== isDisplayed,
    onUpdate: () => layer.isDisplayed = isDisplayed,
    deps: [isDisplayed, layer]
  });
}

function useLayerOpacity(layer, opacity) {
  if (opacity === void 0) {
    opacity = 1;
  }

  useUpdate({
    shouldUpdate: () => layer.opacity !== opacity,
    onUpdate: () => layer.opacity = opacity,
    deps: [opacity, layer]
  });
}

function useEvergisDynamicLayer(_ref) {
  let {
    name,
    zIndex,
    style,
    crs,
    ts,
    condition,
    isDisplayed,
    opacity,
    dataFilterId,
    onLoadStart,
    onLoadEnd
  } = _ref;
  const api = useEvergisContext();
  const {
    map
  } = useMapContext();
  const layer = useProperty({
    factory: () => new EvergisDynamicLayer$1({
      name,
      condition,
      style,
      crs,
      dataFilterId,
      onLoadStart,
      onLoadEnd
    }, api),
    destructor: layer => map.indexOf(layer) !== -1 && map.removeLayer(layer),
    update: (layer, _ref2) => {
      let [name, style, condition, crs = webMercator, dataFilterId] = _ref2;
      layer.name = name;
      layer.style = style;
      layer.condition = condition;
      layer.dataFilterId = dataFilterId;
      layer.crs = crs;
    }
  }, [name, style, condition, crs, dataFilterId, ts]);
  useLayerOrder(layer, zIndex);
  useLayerVisibility(layer, isDisplayed);
  useLayerOpacity(layer, opacity);
  return layer;
}

function useEvergisTileLayer(_ref) {
  let {
    name,
    sourceUrl,
    subDomains,
    zIndex,
    isDisplayed,
    crs,
    opacity
  } = _ref;
  const api = useEvergisContext();
  const {
    map
  } = useMapContext();
  const layer = useMemo(() => new EvergisTileLayer$1({
    name,
    sourceUrl,
    subDomains,
    crs,
    opacity
  }, api), // eslint-disable-next-line react-hooks/exhaustive-deps
  [name, sourceUrl, subDomains, crs, opacity]);
  useEffect(() => () => {
    map.indexOf(layer) !== -1 && map.removeLayer(layer);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [layer]);
  useLayerOrder(layer, zIndex);
  useLayerVisibility(layer, isDisplayed);
  return layer;
}

function useFeatureLayer(_ref) {
  let {
    zIndex,
    isDisplayed = true,
    features,
    opacity
  } = _ref;
  const {
    map
  } = useMapContext();
  const layer = useProperty({
    factory: () => new FeatureLayer$1({
      features,
      opacity
    }),
    destructor: layer => map.indexOf(layer) !== -1 && map.removeLayer(layer),
    update: (layer, _ref2) => {
      let [features] = _ref2;
      layer.features = features;
    }
  }, [features]);
  useLayerOrder(layer, zIndex);
  useLayerVisibility(layer, isDisplayed);
  useLayerOpacity(layer, opacity);
  return layer;
}

function useMapBboxChange(onBboxChange, force) {
  const {
    map
  } = useMapContext();
  const event = force ? BboxChangeEvent : BboxChangeEndEvent;
  const handleBboxChange = useCallback(() => {
    onBboxChange && onBboxChange(getMapState(map)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onBboxChange, map, event]);
  useEffect(() => {
    map.on(event.type, handleBboxChange);
    return () => {
      map.off(event.type, handleBboxChange);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleBboxChange, event]);
}
function getMapState(map) {
  return {
    position: map.position.slice(0),
    resolution: map.resolution
  };
}

function useMapResize(onResize) {
  const {
    painter
  } = useMapContext();
  const handleMapResize = useCallback(() => {
    onResize && onResize([painter.width, painter.height]); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onResize, painter]);
  useEffect(() => {
    painter.on(MapResize.type, handleMapResize);
    return () => {
      painter.off(MapResize.type, handleMapResize);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleMapResize]);
}

const useMapPick = () => {
  const {
    map,
    painter
  } = useMapContext();
  const [geometryParams, setGeometryParams] = useState();
  const evergisLayers = useMemo(() => map.layers, [map.layers]);
  const pick = useCallback(event => {
    if (!(event instanceof sGisClickEvent)) {
      return;
    }

    const imageRectangle = [0, 0, painter.width, painter.height];
    const [x, y] = painter.getPxPosition(event.point.position);
    setGeometryParams({
      pointPosition: event.point.position,
      clickPoint: [Math.round(x), Math.round(y)],
      envelopes: collectLayerEnvelopes(evergisLayers),
      imageRectangle,
      extentSr: map.crs.wkid
    });
  }, [painter, evergisLayers, map.crs.wkid]);
  useMount({
    onMount: () => map.on('click', pick),
    onUnmount: () => map.off('click', pick)
  });
  return geometryParams;
};

function getLayerBboxCoors(layer) {
  return (// @ts-ignore TODO _currentRender prop on DynamicLayer private
    layer._currentRender && // @ts-ignore
    layer._currentRender.bbox && // @ts-ignore
    layer._currentRender.bbox.coordinates
  );
}

function collectLayerEnvelopes(layers) {
  let envelopes = {};

  for (const layer of layers) {
    if (!isEvergisDynamicLayer(layer)) {
      continue;
    }

    envelopes[layer.name] = getLayerBboxCoors(layer);
  }

  return envelopes;
}

function useMapState(force) {
  const {
    map
  } = useMapContext();
  const [, dispatch] = useReducer(mapStateReducer, undefined, () => getMapState(map));
  const handleBboxChange = useCallback(dispatch, [dispatch]);
  useMapBboxChange(handleBboxChange, force);
  return getMapState(map);
}

function mapStateReducer(_, mapState) {
  return mapState;
}

function useMapView() {
  const {
    map,
    painter
  } = useMapContext();
  const {
    position,
    resolution
  } = useMapState();
  const level = useMemo(() => {
    const index = map.tileScheme.getLevel(resolution);
    if (index === void 0 && index === null) return;
    return map.tileScheme.levels[index].zIndex; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolution]); // eslint-disable-next-line react-hooks/exhaustive-deps

  const bbox = useMemo(() => painter.bbox, [position, resolution]);
  return {
    position,
    resolution,
    level,
    bbox
  };
}
function useMapLevel() {
  const {
    map
  } = useMapContext();
  const {
    resolution
  } = useMapState(true);
  return useMemo(() => {
    const index = map.tileScheme.getLevel(resolution);
    if (index === void 0 && index === null) return;
    return map.tileScheme.levels[index].zIndex; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolution]);
}

function useMapWrapper() {
  const {
    painter
  } = useMapContext();
  const wrapperRef = useRef(null);
  useMount({
    onMount: () => painter.wrapper = wrapperRef.current,
    onUnmount: () => painter.wrapper = null
  });
  return wrapperRef;
}

const byScale = scale => _ref => {
  let {
    zIndex
  } = _ref;
  return zIndex === scale;
};

const useMaxMinScale = (minScale, maxScale, currentPosition, currentResolution) => {
  const {
    map
  } = useMapContext();
  useEffect(() => {
    const levels = map.tileScheme.levels;

    if (maxScale !== undefined) {
      const {
        resolution
      } = levels.find(byScale(maxScale)) || {
        resolution: -1
      };
      map.minResolution = resolution;
    }

    if (minScale !== undefined) {
      const {
        resolution
      } = levels.find(byScale(minScale)) || {
        resolution: -1
      };
      map.maxResolution = resolution;
    }

    if (minScale !== undefined || maxScale !== undefined) {
      updateMapResolution(map, currentPosition, currentResolution);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [map, minScale, maxScale]);
};
const updateMapResolution = (map, currentPosition, currentResolution) => {
  if (currentPosition && currentResolution) {
    const newResolution = Math.min(Math.max(currentResolution, map.minResolution || 0), map.maxResolution || Number.MAX_VALUE);
    map.animateTo(currentPosition, newResolution);
  }
};

function getScale$1(scale) {
  const pow10 = Math.pow(10, (Math.floor(scale) + '').length - 1);
  const d = scale / pow10;
  return pow10 * (d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1);
}

function useCorrectedResolution(resolution) {
  const {
    painter
  } = useMapContext();
  const {
    height,
    width,
    bbox: {
      xMin,
      xMax,
      yMin,
      yMax,
      crs
    }
  } = painter;
  return useMemo(() => {
    if (width === 0) {
      return resolution;
    }

    const segmentLength = width / 10;
    const a = painter.getPointFromPxPosition(0, height / 2);
    const b = painter.getPointFromPxPosition(segmentLength, height / 2);
    return distance(a, b) / segmentLength; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height, width, xMin, xMax, yMin, yMax, crs.wkid, resolution, painter]);
}

function useScale(_ref) {
  let {
    resolution,
    minLength = 50
  } = _ref;
  const correctedResolution = useCorrectedResolution(resolution);
  return useMemo(() => {
    const minScale = minLength * correctedResolution;
    const currentScale = getScale$1(minScale);
    const width = getScale$1(minScale) / correctedResolution;
    return {
      currentScale,
      width
    };
  }, [correctedResolution, minLength]);
}

function useUpdateMapView(_ref, force) {
  let {
    position,
    resolution
  } = _ref;
  const {
    map
  } = useMapContext();
  const {
    animateTo
  } = useMapViewActions();
  useEffect(() => {
    if (shouldUpdateMapState(map, {
      position,
      resolution
    })) {
      animateTo({
        position,
        resolution
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [position, resolution, force]);
}

function shouldUpdatePosition(map, position) {
  return position && (!softEquals(map.position[0], position[0]) || !softEquals(map.position[1], position[1]));
}

function shouldUpdateResolution(map, resolution) {
  return resolution && !softEquals(map.resolution, resolution);
}

function shouldUpdateMapState(map, _ref2) {
  let {
    position,
    resolution
  } = _ref2;
  return shouldUpdatePosition(map, position) || shouldUpdateResolution(map, resolution);
}

const useTooltip = function useTooltip(zIndex) {
  if (zIndex === void 0) {
    zIndex = 1;
  }

  const {
    layer,
    popupLayer
  } = useTooltipContext();
  const {
    map
  } = useMapContext();
  const getEventPoint = useEventPoint();
  const targetFeatures = useRef([]);
  const labelFeature = useRef(null);
  const events = useRef([]);
  const onClickMap = useCallback(() => popupLayer.remove(popupLayer.features), [popupLayer]);
  const reset = useCallback(() => {
    targetFeatures.current.forEach((feature, index) => {
      const currentFeatureEvents = events.current[index];

      if (currentFeatureEvents) {
        const {
          onMouseOver,
          onMouseMove,
          onMouseOut,
          onClick
        } = currentFeatureEvents;

        if (feature.hasListener('mouseover', onMouseOver)) {
          feature.off('mouseover', onMouseOver);
        }

        if (feature.hasListener('mousemove', onMouseMove)) {
          feature.off('mousemove', onMouseMove);
        }

        if (feature.hasListener('mouseout', onMouseOut)) {
          feature.off('mouseout', onMouseOut);
        }

        if (feature.hasListener('click', onClick)) {
          feature.off('click', onClick);
        }
      }
    });
    map.off('click', onClickMap);
    targetFeatures.current = [];
    labelFeature.current = null;
    layer.remove(layer.features);
    events.current = [];

    if (map.indexOf(popupLayer) !== -1) {
      map.removeLayer(popupLayer);
    }
  }, [onClickMap, popupLayer, layer, map]);
  useEffect(() => {
    if (map.indexOf(layer) === -1) {
      map.insertLayer(layer, zIndex);
    }

    return reset;
  }, [reset, map, layer, zIndex]);
  const onSetLabelFeature = useCallback(_ref => {
    let {
      point,
      position,
      component,
      clickMode
    } = _ref;
    const feature = new LabelFeature(position || point.position, {
      symbol: new LabelSymbol({
        component: component
      }),
      crs: map.crs
    });

    if (clickMode) {
      if (map.indexOf(popupLayer) === -1) {
        map.insertLayer(popupLayer, zIndex);
      }

      popupLayer.remove(popupLayer.features);
      popupLayer.add(feature);
    } else {
      labelFeature.current = feature;
      layer.add(feature);
    }
  }, [popupLayer, layer, map, zIndex]);
  const onRemoveLabelFeature = useCallback(event => {
    if (event.node) {
      event.node.doNotBubbleToMap = true;
    }

    event.stopPropagation();
    labelFeature.current && layer.has(labelFeature.current) && layer.remove(labelFeature.current);
    labelFeature.current = null;
    layer.remove(layer.features);
  }, [layer]);
  return useCallback(tooltipParams => {
    const {
      feature,
      position,
      component,
      clickMode
    } = tooltipParams;
    const target = feature || map;
    targetFeatures.current.push(target);
    const isMap = target instanceof Map$1;
    const featureEvents = {};

    featureEvents.onMouseOver = event => {
      event.stopPropagation();
      onRemoveLabelFeature(event);
      onSetLabelFeature({
        point: getEventPoint(event),
        position,
        component
      });
    };

    featureEvents.onMouseMove = event => {
      if (!isMap) {
        event.stopPropagation();
      }

      if (event.node) {
        event.node.doNotBubbleToMap = true;
      }

      const point = getEventPoint(event);

      if (labelFeature.current) {
        isMap && !layer.has(labelFeature.current) && layer.add(labelFeature.current);
        labelFeature.current.position = position || point.position;
      } else {
        onSetLabelFeature({
          point: point,
          position,
          component
        });
      }
    };

    if (clickMode) {
      featureEvents.onClick = event => {
        event.stopPropagation();
        onSetLabelFeature({
          point: getEventPoint(event),
          position,
          component,
          clickMode
        });
      };
    }

    featureEvents.onMouseOut = onRemoveLabelFeature;
    events.current.push(featureEvents);
    const {
      onMouseOver,
      onMouseMove,
      onMouseOut,
      onClick
    } = featureEvents;

    if (clickMode && !isMap) {
      target.on('mouseover', onMouseOut);
      target.on('mousemove', onMouseOut);
      target.on('click', onClick);

      if (!map.hasListener('click', onClickMap)) {
        map.on('click', onClickMap);
      }
    } else {
      if (!isMap) {
        target.on('mouseover', onMouseOver);
      }

      target.on('mousemove', onMouseMove);
      target.on('mouseout', onMouseOut);
    }
  }, [onRemoveLabelFeature, onClickMap, map, onSetLabelFeature, getEventPoint, layer]);
};

function useClusterLayer(_ref) {
  let {
    zIndex,
    isDisplayed = true,
    features,
    onChangeGrid,
    size,
    distance,
    clusterSymbol
  } = _ref;
  const {
    map
  } = useMapContext();
  const currentFeatures = useRef(features);
  const layer = useProperty({
    factory: () => {
      const gridClusterProvider = new GridClusterProvider({
        size,
        distance,
        onChangeGrid: onChangeGrid ? features => onChangeGrid(features, layer) : void 0
      });
      const clusterLayer = new ClusterLayer$1({
        gridClusterProvider,
        clusterSymbol
      });
      currentFeatures.current = features;
      clusterLayer.add(features);
      return clusterLayer;
    },
    destructor: layer => map.indexOf(layer) !== -1 && map.removeLayer(layer),
    update: (clusterLayer, _ref2) => {
      let [features] = _ref2;
      clusterLayer.remove(currentFeatures.current);
      clusterLayer.add(features);
      currentFeatures.current = features;
    }
  }, [features]);
  useLayerOrder(layer, zIndex);
  useLayerVisibility(layer, isDisplayed);
  return layer;
}

const INIT_FEATURES = [];
const useEvergisSelect = _ref => {
  let {
    onPick,
    onFeatures
  } = _ref;
  const mapPickResult = useMapPick();
  const layers = useEvergisSelectContext();
  const [features, setFeatures] = useState(INIT_FEATURES);
  const resetSelection = useCallback(() => setFeatures(INIT_FEATURES), [setFeatures]);
  useEffect(() => {
    if (!mapPickResult) {
      return;
    }

    onPick(mapPickResult).then(features => {
      setFeatures(features.map(evaluateFeature(layers)));
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapPickResult]);
  return [typeof onFeatures === 'function' ? onFeatures(features) : features, resetSelection];
};

const useCrs = srId => {
  return useMemo(() => {
    return CRS_MAP[srId || DEFAULT_SRID] || DEFAULT_CRS;
  }, [srId]);
};

const setCursor = (painter, cursor) => painter.wrapper && typeof painter.wrapper !== 'string' && (painter.wrapper.style.cursor = cursor);

function none() {
  return;
}

const useDraggableMarker = _ref => {
  let {
    position,
    onChange,
    symbol
  } = _ref;
  const feature = useRef(null);
  const {
    map,
    painter
  } = useMapContext();
  const layer = useRef(new FeatureLayer$1());
  const pointEditor = useRef(new PointEditor(map, {
    isActive: false,
    activeLayer: layer.current
  }));
  const onMapClick = useCallback(event => {
    event.stopPropagation();

    if (!(event instanceof sGisClickEvent)) {
      return;
    }

    map.off('click', onMapClick);
    setCursor(painter, 'default');
    onChange(event.point.position);
  }, [painter, map, onChange]);
  useMount({
    onMount: () => {
      map.addLayer(layer.current);
      pointEditor.current.on('edit', () => {
        var _pointEditor$current$;

        return onChange(((_pointEditor$current$ = pointEditor.current.activeFeature) == null ? void 0 : _pointEditor$current$.position) || [0, 0]);
      });

      if (!position) {
        setCursor(painter, 'pointer');
        map.on('click', onMapClick);
      }
    },
    onUnmount: () => {
      map.removeLayer(layer.current);
      map.off('click', onMapClick);
      pointEditor.current.off('edit', () => {
        var _pointEditor$current$2;

        return onChange(((_pointEditor$current$2 = pointEditor.current.activeFeature) == null ? void 0 : _pointEditor$current$2.position) || [0, 0]);
      });
      setCursor(painter, 'default');
    }
  });
  useEffect(() => {
    if (position) {
      if (!feature.current) {
        const hasMapClick = map.hasListener('click', onMapClick);
        const pointFeature = new PointFeature(position, {
          crs: map.crs,
          symbol: symbol || new StaticImageSymbol()
        });
        pointFeature.on('mousemove', none);
        pointFeature.on('mouseover', () => setCursor(painter, 'pointer'));
        pointFeature.on('mouseout', () => setCursor(painter, 'default'));
        layer.current.add(pointFeature);
        pointEditor.current.activeFeature = pointFeature;
        pointEditor.current.isActive = true;
        feature.current = pointFeature;

        if (hasMapClick) {
          map.off('click', onMapClick);
          setCursor(painter, 'default');
        }
      } else if (feature.current && pointEditor.current.activeFeature) {
        pointEditor.current.activeFeature.position = position;
        layer.current.redraw();
      }
    } else if (feature.current) {
      layer.current.remove(feature.current);
      feature.current = null;
      setCursor(painter, 'pointer');
      map.on('click', onMapClick);
    }
  }, [onMapClick, painter, map, position, symbol]);
};

const useMetersToPixels = (meters, crs) => {
  const {
    painter,
    map
  } = useMapContext();
  const {
    resolution
  } = useMapState();
  return useMemo(() => metersToPixels(meters, {
    painter: painter,
    crs: crs || map.crs
  }), // eslint-disable-next-line react-hooks/exhaustive-deps
  [painter, meters, crs, map.crs, resolution]);
};
const useMetersToPixelsCb = () => {
  const {
    painter,
    map
  } = useMapContext();
  return useCallback((meters, crs) => metersToPixels(meters, {
    painter: painter,
    crs: crs || map.crs
  }), [painter, map.crs]);
};

const useDebouncedCallback = interval => {
  return useMemo(() => debounce(cb => {
    cb();
  }, interval), [interval]);
};

const useToggle = initial => {
  const [state, setState] = useState(initial !== undefined ? initial : false);
  const toggle = useCallback(() => setState(!state), [state]);
  return [state, toggle, setState];
};

function useNode() {
  const [node, onSetNode] = useState(null);
  const ref = useCallback(onSetNode, [onSetNode]);
  return [ref, node];
}

const Symbol = _ref => {
  let {
    symbol,
    size,
    render
  } = _ref;
  const {
    canvas,
    ref
  } = useCanvas();
  useSymbol({
    symbol,
    size,
    render
  }, canvas);
  return React.createElement("canvas", {
    ref: ref
  });
};

var _templateObject, _templateObject2;
const CompoundIcon = /*#__PURE__*/styled.div(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n  height: 32px;\n  width: 32px;\n"])), _ref => {
  let {
    geometryType,
    icons
  } = _ref;
  return "url(" + icons[geometryType] + ") center center / " + (geometryType === GeometryType.Polyline ? '2rem 1.3rem' : 'auto 1rem') + " no-repeat";
});
const ClusterSymbol = /*#__PURE__*/styled.div(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 32px;\n  height: 32px;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: inherit;\n    height: inherit;\n    background-color: ", ";\n    border-radius: 50%;\n    opacity: 0.28;\n  }\n  \n  :after {\n    content: \"99\";\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n    background-color: ", ";\n    border-radius: 50%;\n    color: white;\n    font-size: 0.75rem;\n    line-height: 1;\n  }\n"])), _ref2 => {
  let {
    color
  } = _ref2;
  return color;
}, _ref3 => {
  let {
    color
  } = _ref3;
  return color;
});

const MAX_SIZE = 32;
const StyleSymbol = _ref => {
  let {
    symbol,
    size = MAX_SIZE,
    children
  } = _ref;

  if (children) {
    return React.createElement(React.Fragment, null, children);
  }

  let sGisSymbol = null;

  try {
    sGisSymbol = deserializeSymbol(symbol);
  } catch (e) {// TODO generate Error symbol
  }

  if (!sGisSymbol) {
    return null;
  }

  if (isSGisClusterSymbol(symbol)) {
    var _sGisSymbol$backgroun, _sGisSymbol$figure;

    const color = getParameterValue((_sGisSymbol$backgroun = sGisSymbol.background) == null ? void 0 : _sGisSymbol$backgroun.fillColor) || getParameterValue((_sGisSymbol$figure = sGisSymbol.figure) == null ? void 0 : _sGisSymbol$figure.fillColor) || "rgb(0, 170, 255)";
    return React.createElement(ClusterSymbol, {
      color: color
    });
  }

  return React.createElement(Symbol, {
    symbol: adjustSymbol(sGisSymbol, {
      size: size - 1
    }),
    size: size
  });
};

var _templateObject$1, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;
const EvergisCardContainer = /*#__PURE__*/styled.div(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 2.25rem;\n  right: 0.5rem;\n  width: 22.5rem;\n  margin-bottom: 1rem;\n  max-height: 90%;\n  min-height: 1rem;\n  background: #fff;\n  border-radius: 4px;\n  z-index: 1;\n\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow: initial;\n  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);\n\n  ", " {\n    color: rgba(0, 0, 0, 0.65);\n    cursor: pointer;\n    user-select: none;\n\n    &:hover {\n      color: #1fb3aa;\n    }\n  }\n"])), Icon);
const StickyHeader = /*#__PURE__*/styled.div(_templateObject2$1 || (_templateObject2$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  position: sticky;\n  top: 0;\n  flex-direction: column;\n  background: #fff;\n"])));
const CardHeader = /*#__PURE__*/styled.div(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  padding: 1.5rem 1.5rem 1rem;\n  align-items: center;\n"])));
const CardTitle = /*#__PURE__*/styled.div(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: 0 0.5rem;\n  flex-grow: 1;\n"])));
const CardControls = /*#__PURE__*/styled.div(_templateObject5 || (_templateObject5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n\n  ", " {\n    margin: 0 0.5rem;\n  }\n"])), Icon);
const FeatureName = /*#__PURE__*/styled.div(_templateObject6 || (_templateObject6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-size: 1.25rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
const LayerName = /*#__PURE__*/styled.div(_templateObject7 || (_templateObject7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: #30454f;\n  font-size: 0.75rem;\n"])));
const CardPagination = /*#__PURE__*/styled.div(_templateObject8 || (_templateObject8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  height: 2.5rem;\n  padding: 0 1.5rem;\n  align-items: center;\n  font-size: 0.75rem;\n  justify-content: space-between;\n  background: linear-gradient(\n    0deg,\n    rgba(161, 186, 208, 0.12),\n    rgba(161, 186, 208, 0.12)\n  );\n"])));
const PaginationDescription = /*#__PURE__*/styled.div(_templateObject9 || (_templateObject9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
const CurrentFeatureIndex = /*#__PURE__*/styled.div(_templateObject10 || (_templateObject10 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  padding: 0 0.25rem;\n  color: #1fb3aa;\n"])));
const CardAttributes = /*#__PURE__*/styled.div(_templateObject11 || (_templateObject11 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 1rem 1.5rem;\n  overflow-y: scroll;\n"])));
const AttributeContainer = /*#__PURE__*/styled.div(_templateObject12 || (_templateObject12 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding-bottom: 0.5rem;\n"])));
const AttributeTitle = /*#__PURE__*/styled.div(_templateObject13 || (_templateObject13 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin: 0.25rem 0;\n  color: #30454f;\n  font-size: 0.75rem;\n"])));
const AttributeValueContainer = /*#__PURE__*/styled.div(_templateObject14 || (_templateObject14 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  flex-wrap: wrap;\n  display: flex;\n"])));
const SimpleAttribute = /*#__PURE__*/styled.div(_templateObject15 || (_templateObject15 = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
const ValueLink = /*#__PURE__*/styled.a(_templateObject16 || (_templateObject16 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 0 0.25rem;\n  color: #1fb3aa;\n  text-decoration: none;\n"])));

const MailValue = _ref => {
  let {
    mail
  } = _ref;
  return React.createElement(ValueLink, {
    target: '_blank',
    rel: 'noreferrer',
    href: mailHref(mail)
  }, mail);
};

const PhoneValue = _ref => {
  let {
    phone
  } = _ref;
  return React.createElement(ValueLink, {
    target: '_blank',
    rel: 'noreferrer',
    href: phoneHref(phone)
  }, phone);
};

const UrlValue = _ref => {
  let {
    url
  } = _ref;
  return React.createElement(ValueLink, {
    target: '_blank',
    rel: 'noreferrer',
    href: urlHref(url)
  }, url);
};

const AttributeValue = _ref => {
  let {
    attribute
  } = _ref;
  const attributeValues = formatAttributeValue(attribute);
  return React.createElement(AttributeValueContainer, null, attributeValues.map((attributeValue, index) => {
    const {
      value
    } = attributeValue;
    const key = value + "-" + index;

    if (attributeValue.type === 2
    /* Url */
    ) {
      return React.createElement(UrlValue, {
        key: key,
        url: punycodeDecode(value)
      });
    }

    if (attributeValue.type === 3
    /* Mail */
    ) {
      return React.createElement(MailValue, {
        key: key,
        mail: value
      });
    }

    if (attributeValue.type === 1
    /* Phone */
    ) {
      return React.createElement(PhoneValue, {
        key: key,
        phone: value
      });
    }

    return React.createElement(SimpleAttribute, {
      key: value
    }, value);
  }));
};

function punycodeDecode(domains) {
  try {
    return domains.split('/').map(punycode.toUnicode).join('/');
  } catch (error) {
    return domains;
  }
}

const EvergisCardAttribute = _ref => {
  let {
    attribute,
    className
  } = _ref;
  return React.createElement(AttributeContainer, {
    className: className
  }, React.createElement(AttributeTitle, null, attribute.alias || attribute.name), React.createElement(AttributeValue, {
    attribute: attribute
  }));
};

const StyledCard = _ref => {
  let {
    features = [],
    className,
    reset,
    feature,
    zoom,
    prev,
    current,
    next,
    onAttributes,
    onStatistics,
    onFeatureChange,
    headerExtra,
    hideZoom
  } = _ref;
  useEffect(() => {
    onFeatureChange && onFeatureChange(current);
  }, [current, onFeatureChange]);
  return React.createElement(EvergisCardContainer, {
    className: className
  }, React.createElement(StickyHeader, null, React.createElement(CardHeader, null, React.createElement(StyleSymbol, {
    symbol: feature.symbol || {}
  }), React.createElement(CardTitle, null, React.createElement(FeatureName, {
    title: feature.displayName || ''
  }, feature.displayName), React.createElement(LayerName, null, feature.layerAlias)), React.createElement(CardControls, null, onStatistics && React.createElement(IconButton, {
    onClick: () => onStatistics(feature)
  }, React.createElement(EverCloudStatisticsIcon, null)), !hideZoom && React.createElement(IconButton, {
    onClick: zoom
  }, React.createElement(EverCloudZoomtoIcon, null)), React.createElement(IconButton, {
    onClick: reset
  }, React.createElement(EverCloudCloseIcon, null)))), features.length > 1 ? React.createElement(CardPagination, null, React.createElement(IconButton, {
    onClick: prev
  }, React.createElement(EverCloudPlayPrevIcon, null)), React.createElement(PaginationDescription, null, React.createElement(CurrentFeatureIndex, {
    onClick: zoom
  }, current + 1), "\u043E\u0431\u044A\u0435\u043A\u0442 \u0438\u0437 ", features.length), React.createElement(IconButton, {
    onClick: next
  }, React.createElement(EverCloudPlayNextIcon, null))) : null, headerExtra), React.createElement(CardAttributes, null, feature.attributes && (typeof onAttributes === 'function' ? onAttributes(feature.attributes) : feature.attributes).map(attribute => {
    return attribute.render || React.createElement(EvergisCardAttribute, {
      key: attribute.name,
      attribute: attribute
    });
  })));
};

const _excluded$1 = ["renderCard", "className", "children"];
const EvergisCard = _ref => {
  let {
    renderCard,
    className,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  const {
    features = []
  } = props;
  const hookProps = useEvergisCard(features);
  const {
    feature,
    current
  } = hookProps;

  const cardProps = _extends({}, props, hookProps);

  return feature ? React.createElement(React.Fragment, null, typeof renderCard === 'function' ? renderCard(cardProps) : React.createElement(StyledCard, Object.assign({
    className: className
  }, cardProps)), children && children(current)) : null;
};

const ClusterLayer = props => {
  useClusterLayer(props);
  return null;
};

const EvergisDynamicLayer = props => {
  useEvergisDynamicLayer(props);
  return null;
};

const FeatureLayer = props => {
  useFeatureLayer(props);
  return null;
};

const truthly = value => Boolean(value);

const setSelected = current => (feature, index) => {
  // @ts-ignore
  feature['isSelected'] = index === current;
  return feature;
};

const toSgis = feature => feature.sGisFeature(); // TODO inner hooks???


const useSGisFeatures = (features, currentIndex) => useMemo(() => features.map(toSgis).filter(truthly).map(setSelected(currentIndex)), [features, currentIndex]);

const EvergisSelectLayer = _ref => {
  let {
    features,
    zIndex,
    current
  } = _ref;
  const sGisFeatures = useSGisFeatures(features, current);
  return React.createElement(FeatureLayer, {
    features: sGisFeatures,
    zIndex: zIndex
  });
};

const EvergisTileLayer = props => {
  useEvergisTileLayer(props);
  return null;
};

const _excluded$2 = ["maskUrl", "zIndex", "isDisplayed"];
function useTileLayer(_ref) {
  let {
    maskUrl,
    zIndex,
    isDisplayed
  } = _ref,
      tileLayerParams = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  const {
    map
  } = useMapContext();
  const layer = useProperty({
    factory: () => new TileLayer$1(maskUrl, tileLayerParams),
    destructor: layer => map.indexOf(layer) !== -1 && map.removeLayer(layer)
  }, [maskUrl]);
  useLayerOrder(layer, zIndex);
  useLayerVisibility(layer, isDisplayed);
  return layer;
}

const TileLayer = props => {
  useTileLayer(props);
  return null;
};

const defaultZIndex = 200;
const EvergisSelect = _ref => {
  let {
    onPick,
    className,
    renderCard,
    zIndex,
    onFeatures,
    onAttributes,
    onStatistics
  } = _ref;
  const [features, resetSelection] = useEvergisSelect({
    onPick,
    onFeatures
  });
  return React.createElement(EvergisCard, {
    className: className,
    features: features,
    reset: resetSelection,
    renderCard: renderCard,
    onAttributes: onAttributes,
    onStatistics: onStatistics
  }, current => React.createElement(EvergisSelectLayer, {
    features: features,
    current: current,
    zIndex: zIndex || defaultZIndex
  }));
};

var _templateObject$2, _templateObject2$2, _templateObject3$1, _templateObject4$1, _templateObject5$1;

const topLeft = distance => css(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  top: ", ";\n  left: ", ";\n"])), distance, distance);

const topRight = distance => css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n  top: ", ";\n  right: ", ";\n"])), distance, distance);

const bottomLeft = distance => css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n  bottom: ", ";\n  left: ", ";\n"])), distance, distance);

const bottomRight = distance => css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n  bottom: ", ";\n  right: ", ";\n"])), distance, distance);

const placementMixin = function placementMixin(placement, distance) {
  if (placement === void 0) {
    placement = 'bottom-left';
  }

  if (distance === void 0) {
    distance = '1rem';
  }

  return css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), placement === 'top-left' && topLeft(distance), placement === 'top-right' && topRight(distance), placement === 'bottom-left' && bottomLeft(distance), placement === 'bottom-right' && bottomRight(distance));
};

var _templateObject$3, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$1, _templateObject7$1, _templateObject8$1;
const mapControlBtnMixin = /*#__PURE__*/css(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #fff;\n"])));
const ZoomInBtn = /*#__PURE__*/styled(Icon)(_templateObject2$3 || (_templateObject2$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), mapControlBtnMixin); // ZoomInBtn.defaultProps = { kind: "plus" };

const ZoomOutBtn = /*#__PURE__*/styled(Icon)(_templateObject3$2 || (_templateObject3$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), mapControlBtnMixin); // ZoomOutBtn.defaultProps = { kind: "minus" };

const SearchBtn = /*#__PURE__*/styled(Icon)(_templateObject4$2 || (_templateObject4$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), mapControlBtnMixin); // SearchBtn.defaultProps = { kind: "search" };
// TODO not exists in fonts

const FullscreenBtn = /*#__PURE__*/styled(Icon)(_templateObject5$2 || (_templateObject5$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), mapControlBtnMixin); // FullscreenBtn.defaultProps = { kind: "maximize" };

const MeasureBtn = /*#__PURE__*/styled(Icon)(_templateObject6$1 || (_templateObject6$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), mapControlBtnMixin); // MeasureBtn.defaultProps = { kind: "measure_length" };

const MapControl = /*#__PURE__*/styled.div(_templateObject7$1 || (_templateObject7$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border-radius: 0.15rem;\n  background: rgba(28, 33, 48, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 1.5rem;\n  cursor: pointer;\n  height: auto;\n  width: auto;\n  padding: 0.25rem;\n"])));
const MapControls = /*#__PURE__*/styled.div(_templateObject8$1 || (_templateObject8$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: absolute;\n  display: flex;\n  flex-direction: ", ";\n\n  ", "\n\n  ", " {\n    margin-bottom: ", ";\n    margin-right: ", ";\n    flex-direction: ", ";\n  }\n"])), _ref => {
  let {
    vertical
  } = _ref;
  return vertical ? 'column' : 'row';
}, _ref2 => {
  let {
    placement
  } = _ref2;
  return placementMixin(placement);
}, MapControl, _ref3 => {
  let {
    vertical
  } = _ref3;
  return vertical ? '0.5rem' : '0';
}, _ref4 => {
  let {
    vertical
  } = _ref4;
  return vertical ? '0' : '0.5rem';
}, _ref5 => {
  let {
    vertical
  } = _ref5;
  return vertical ? 'column' : 'row';
});

const Measure = () => {
  return React.createElement(MapControl, null, React.createElement(MeasureBtn, {
    onClick: () => {}
  }));
};

const Search = () => {
  return React.createElement(MapControl, null, React.createElement(SearchBtn, {
    onClick: () => {}
  }));
};

const Fullscreen = () => {
  return React.createElement(MapControl, null, React.createElement(FullscreenBtn, {
    onClick: () => {}
  }));
};

var _templateObject$4, _templateObject2$4, _templateObject3$3, _templateObject4$3, _templateObject5$3, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1, _templateObject16$1, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39;
const MapLegendDescription = /*#__PURE__*/styled.div(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-size: 0.75rem;\n"])));
const ItemText = /*#__PURE__*/styled.div(_templateObject2$4 || (_templateObject2$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  max-width: calc(100% - 2rem);\n  font: ", ";\n"])), _ref => {
  let {
    theme: {
      fonts
    }
  } = _ref;
  return fonts.description;
});
const ItemSeparator = /*#__PURE__*/styled.div(_templateObject3$3 || (_templateObject3$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  :after {\n    content: '-';\n    margin: 0 0.5rem;\n    font-size: 0.75rem;\n  }\n"])));
const SymbolContainer = /*#__PURE__*/styled('span')(_templateObject4$3 || (_templateObject4$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  min-width: 1.5rem;\n  margin-right: 0.5rem;\n"])));
const ClassifiedItem = /*#__PURE__*/styled.div(_templateObject5$3 || (_templateObject5$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: ", ";\n  pointer-events: ", ";\n\n  :not(:last-of-type) {\n    margin-bottom: 0.25rem;\n  }\n\n  ", ", ", " {\n    transition: opacity 150ms;\n  }\n\n  ", " {\n    opacity: ", ";\n  }\n\n  ", " {\n    opacity: ", ";\n  }\n\n  :hover {\n    ", ", ", " {\n      opacity: 1;\n    }\n  }\n\n  ", " {\n    margin-left: 0.5rem;\n  }\n"])), _ref2 => {
  let {
    isClusterFillColor
  } = _ref2;
  return isClusterFillColor ? 'default' : 'pointer';
}, _ref3 => {
  let {
    isClusterFillColor
  } = _ref3;
  return isClusterFillColor ? 'none' : 'auto';
}, ItemText, SymbolContainer, ItemText, _ref4 => {
  let {
    isHidden
  } = _ref4;
  return isHidden ? 0.28 : 0.65;
}, SymbolContainer, _ref5 => {
  let {
    isHidden
  } = _ref5;
  return isHidden ? 0.28 : 1;
}, ItemText, SymbolContainer, IconButton);
const SymbolButtonWithClick = /*#__PURE__*/css(_templateObject6$2 || (_templateObject6$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 3.875rem;\n  height: 3.875rem;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), _ref6 => {
  let {
    theme: {
      palette
    }
  } = _ref6;
  return palette.elementDeep;
});
const SymbolButton = /*#__PURE__*/styled.span(_templateObject7$2 || (_templateObject7$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 150ms;\n  ", ";\n\n  svg {\n    max-width: 4rem;\n    max-height: 4rem;\n  }\n"])), _ref7 => {
  let {
    onClick
  } = _ref7;
  return !!onClick && SymbolButtonWithClick;
});
const MapLegendControl = /*#__PURE__*/styled(MapControl)(_templateObject8$2 || (_templateObject8$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  cursor: default;\n"])));
const MapLegendContainer = /*#__PURE__*/styled.div(_templateObject9$1 || (_templateObject9$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  padding-bottom: 1rem;\n  box-sizing: border-box;\n\n  canvas {\n    height: 1.625rem;\n    width: 1.625rem;\n  }\n"])));
const MapLegendHeader = /*#__PURE__*/styled.div(_templateObject10$1 || (_templateObject10$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  max-width: 15rem;\n  margin-bottom: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: bold;\n"])));
const MapLegendDescriptionContainer = /*#__PURE__*/styled.div(_templateObject11$1 || (_templateObject11$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin-bottom: 0.5rem;\n  font-weight: 400;\n  font-size: 0.625rem;\n  color: rgba(48, 69, 79, 0.65);\n"])));
const MapLegendBadge = /*#__PURE__*/styled.span(_templateObject12$1 || (_templateObject12$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  min-width: 0.5rem;\n  height: 0.75rem;\n  display: inline-block;\n  margin-left: 0.25rem;\n  padding: 0.125rem 0.25rem;\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  text-align: center;\n"])), _ref8 => {
  let {
    theme: {
      borderRadius
    }
  } = _ref8;
  return borderRadius.xSmall;
}, _ref9 => {
  let {
    theme: {
      palette
    }
  } = _ref9;
  return palette.element;
}, _ref10 => {
  let {
    theme: {
      palette
    }
  } = _ref10;
  return palette.textPrimary;
});
const MaximizedLegendContainer = /*#__PURE__*/styled.div(_templateObject13$1 || (_templateObject13$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: ", ";\n  top: 0;\n  opacity: ", ";\n  visibility: ", ";\n  overflow: hidden;\n  transition: opacity 0.5s, visibility 0.5s;\n"])), _ref11 => {
  let {
    isShown
  } = _ref11;
  return isShown ? 'relative' : 'absolute';
}, _ref12 => {
  let {
    isShown
  } = _ref12;
  return isShown ? 1 : 0;
}, _ref13 => {
  let {
    isShown
  } = _ref13;
  return isShown ? 'visible' : 'hidden';
});
const MinimizedLegendContainer = /*#__PURE__*/styled(MaximizedLegendContainer)(_templateObject14$1 || (_templateObject14$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: calc(100% - 1.5rem);\n  padding-right: 1.5rem;\n"])));
const LegendHeaderButton = /*#__PURE__*/styled.span(_templateObject15$1 || (_templateObject15$1 = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
const MapLegendSectionContainer = /*#__PURE__*/styled.div(_templateObject16$1 || (_templateObject16$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 100%;\n\n  :not(:last-child) {\n    margin-bottom: 1rem;\n  }\n\n  ", " {\n    padding-left: 0.75rem;\n    visibility: hidden;\n\n    :first-child {\n      padding-left: 1rem;\n    }\n\n    :last-child {\n      margin-left: 0.75rem;\n      border-left: 1px ", " solid;\n    }\n  }\n  \n  :hover {\n    ", " {\n      visibility: visible;\n    }\n  }\n"])), LegendHeaderButton, _ref14 => {
  let {
    theme: {
      palette
    }
  } = _ref14;
  return palette.elementDeep;
}, LegendHeaderButton);
const MapLegendSectionItems = /*#__PURE__*/styled.div(_templateObject17 || (_templateObject17 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  height: ", "px;\n  overflow: ", ";\n  transition: height 0.5s;\n"])), _ref15 => {
  let {
    minHeight,
    maxHeight,
    isExpanded
  } = _ref15;
  return isExpanded ? (maxHeight || 0) + 4 : minHeight;
}, _ref16 => {
  let {
    isExpanded
  } = _ref16;
  return isExpanded ? 'none' : 'hidden';
});
const MapLegendValueDescr = /*#__PURE__*/styled.div(_templateObject18 || (_templateObject18 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  min-height: 1rem;\n  margin-bottom: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1rem;\n"])));

const SizeLegendItemMixin = function SizeLegendItemMixin(value) {
  if (value === void 0) {
    value = 0;
  }

  return css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  display: flex;\n  align-items: flex-end;\n  flex: none;\n  height: inherit;\n  width: inherit;\n  margin: 0 auto;\n  background: none;\n  border: none;\n\n  :after {\n    content: '';\n    display: flex;\n    border: 1px rgba(48, 69, 79, 0.28) solid;\n    border-radius: 50%;\n    margin: 0 0 0 -", "px;\n    width: ", "px;\n    height: ", "px;\n  }\n"])), value / 2, value, value);
};

const StrokeWidthLegendItemMixin = function StrokeWidthLegendItemMixin(value) {
  if (value === void 0) {
    value = 0;
  }

  return css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  flex: none;\n  width: calc(100% - 2rem);\n  height: ", "px;\n  margin: 0 0 0.25rem 0;\n  padding-left: 2rem;\n  font-size: 0.75rem;\n\n  :first-child,\n  :last-child {\n    height: auto;\n  }\n\n  :after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 1.5rem;\n    height: ", "px;\n    margin-top: -", "px;\n    background: rgb(224, 224, 224);\n  }\n"])), value, value, Math.round(value / 2));
};

const StrokeColorLegendItemMixin = /*#__PURE__*/css(_templateObject21 || (_templateObject21 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin-right: 0.5rem;\n  width: 1.5rem;\n"])));
const MapLegendItem = /*#__PURE__*/styled.div(_templateObject22 || (_templateObject22 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  flex: 1;\n  height: ", "rem;\n  background: ", ";\n  border: 1px rgba(48, 69, 79, 0.1) solid;\n  margin-right: -1px;\n  color: rgba(48, 69, 79, 0.65);\n  opacity: ", ";\n\n  ", "\n\n  ", "\n"])), _ref17 => {
  let {
    parameter
  } = _ref17;
  return isParameterType(['strokeColor', 'stroke.color'], parameter) ? 0.25 : 1;
}, _ref18 => {
  let {
    value
  } = _ref18;
  return typeof value === 'number' ? 'none' : value;
}, _ref19 => {
  let {
    isHidden
  } = _ref19;
  return isHidden ? 0.28 : 1;
}, _ref20 => {
  let {
    value,
    parameter
  } = _ref20;
  return isParameterType('size', parameter) && SizeLegendItemMixin(value);
}, _ref21 => {
  let {
    value,
    parameter
  } = _ref21;
  return isParameterType(['strokeWidth', 'stroke.width'], parameter) && StrokeWidthLegendItemMixin(value);
});
const MapLegendOther = /*#__PURE__*/styled(MapLegendItem)(_templateObject23 || (_templateObject23 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  flex: none;\n  position: relative;\n  width: 1rem;\n  margin-left: 0.25rem;\n  border-radius: 0.125rem;\n"])));
const SizeLegendItemsMixin = /*#__PURE__*/css(_templateObject24 || (_templateObject24 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 2rem;\n  height: 2rem;\n  margin: 0 auto;\n\n  ", " {\n    width: auto;\n    margin-left: 0;\n  }\n"])), MapLegendOther);
const StrokeWidthLegendItemsMixin = /*#__PURE__*/css(_templateObject25 || (_templateObject25 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  flex-direction: column;\n  width: auto;\n\n  ", " {\n    width: calc(100% - 2rem);\n    margin-left: 0;\n  }\n"])), MapLegendOther);
const SizeMinimizedLegend = /*#__PURE__*/styled.div(_templateObject26 || (_templateObject26 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin: 0.5rem 0 0.25rem;\n"])));
const SizeMinimizedLegendSymbol = /*#__PURE__*/styled.div(_templateObject27 || (_templateObject27 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 4rem;\n  margin-right: 0.75rem;\n"])));
const SizeMinimizedLegendLabel = /*#__PURE__*/styled.div(_templateObject28 || (_templateObject28 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  max-width: 9.75rem;\n  font-size: 0.75rem;\n"])));
const SizeMinimizedLegendDown = /*#__PURE__*/styled.div(_templateObject29 || (_templateObject29 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: rgba(48, 69, 79, 0.65);\n"])));
const SizeMinimizedLegendUp = /*#__PURE__*/styled(SizeMinimizedLegendDown)(_templateObject30 || (_templateObject30 = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
const SingleSizeLegendItemsMixin = /*#__PURE__*/css(_templateObject31 || (_templateObject31 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 4rem;\n  margin-right: 0.75rem;\n\n  ", ":after {\n    margin: 0 auto;\n  }\n"])), MapLegendItem);
const SingleLegendItemsMixin = /*#__PURE__*/css(_templateObject32 || (_templateObject32 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  justify-content: center;\n  width: 2rem;\n  height: auto;\n  margin: 0;\n  ", "\n\n  ", " {\n    position: relative;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    margin: 0;\n    height: auto;\n    width: auto;\n\n    ", "\n  }\n"])), _ref22 => {
  let {
    isSize
  } = _ref22;
  return isSize && SingleSizeLegendItemsMixin;
}, MapLegendItem, _ref23 => {
  let {
    parameter
  } = _ref23;
  return isParameterType(['strokeColor', 'stroke.color'], parameter) && StrokeColorLegendItemMixin;
});
const MapLegendItems = /*#__PURE__*/styled.div(_templateObject33 || (_templateObject33 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: 0.125rem;\n\n  ", ";\n  ", ";\n  ", ";\n"])), _ref24 => {
  let {
    isSize
  } = _ref24;
  return isSize && SizeLegendItemsMixin;
}, _ref25 => {
  let {
    isStrokeWidth
  } = _ref25;
  return isStrokeWidth && StrokeWidthLegendItemsMixin;
}, _ref26 => {
  let {
    isSingle
  } = _ref26;
  return isSingle && SingleLegendItemsMixin;
});
const MapLegendItemsContainer = /*#__PURE__*/styled.div(_templateObject34 || (_templateObject34 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n\n  ", " {\n    :first-child {\n      border-top-left-radius: 0.125rem;\n      border-bottom-left-radius: 0.125rem;\n    }\n\n    :last-child {\n      border-top-right-radius: 0.125rem;\n      border-bottom-right-radius: 0.125rem;\n    }\n  }\n"])), MapLegendItem);
const MapLegendValues = /*#__PURE__*/styled.div(_templateObject35 || (_templateObject35 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.75rem;\n  color: rgba(48, 69, 79, 0.65);\n"])));
const MapLegendValuesRange = /*#__PURE__*/styled.div(_templateObject36 || (_templateObject36 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  width: calc(100% - 1.25rem);\n\n  div {\n    flex: 1;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n\n    :first-child {\n      margin-right: 0.5rem;\n    }\n\n    :last-child {\n      margin-left: 0.5rem;\n      text-align: right;\n    }\n  }\n"])));
const MapLegendValuesOther = /*#__PURE__*/styled(MapLegendOther)(_templateObject37 || (_templateObject37 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  justify-content: center;\n  border: 0;\n  overflow: visible;\n"])));
const MapLegendExpandButton = /*#__PURE__*/styled.div(_templateObject38 || (_templateObject38 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  margin-top: 0.1rem;\n  font-size: 0.625rem;\n  color: #1fb3aa;\n"])));
const ClusterLegendContainer = /*#__PURE__*/styled.div(_templateObject39 || (_templateObject39 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin: -0.9rem;\n  transform: scale(0.5);\n"])));

const useSvgSymbol = (symbol, skipOffset, isClassified) => {
  const SVGWrapperRefElement = useRef(null);
  const SVGContainer = useMemo(() => SVG(), []);
  const initSvg = useCallback(() => {
    SVGContainer.addTo(SVGWrapperRefElement.current);
  }, [SVGContainer]);
  const getSvgData = useCallback(() => SVGContainer.svg(), [SVGContainer]);
  const manipulateSvg = useCallback(_ref => {
    let {
      svg,
      bg,
      newSymbol,
      isClassified
    } = _ref;
    manipulateSvgSymbol({
      SVGContainer,
      symbol: newSymbol || symbol,
      svg,
      bg,
      isClassified
    });
  }, [SVGContainer, symbol]);
  const getUpdatedSvgSymbol = useCallback((field, value) => {
    var _newSymbol$background;

    const {
      data,
      offset
    } = symbol;
    const newValue = value instanceof Color$1 ? value.toString('rgba') : value;

    const newSymbol = _extends({}, JSON.parse(JSON.stringify(symbol)), {
      offset: skipOffset ? DEFAULT_SYMBOL_OFFSET : isSizeClassification(field) ? getOffsetParameterValue(offset) : offset
    });

    if (field.indexOf('.') !== -1) {
      var _newSymbol$parts$;

      const parts = field.split('.');

      if ((_newSymbol$parts$ = newSymbol[parts[0]]) != null && _newSymbol$parts$[parts[1]]) {
        newSymbol[parts[0]][parts[1]] = newValue;
      } else {
        newSymbol[parts[0]] = _extends({}, newSymbol[parts[0]], {
          [parts[1]]: newValue
        }, parts[0] === 'background' ? {
          type: newSymbol.background.type,
          id: 'symbol-bg'
        } : parts[0] === 'figure' ? {
          id: 'symbol-figure'
        } : {});
      }
    } else {
      newSymbol[field] = newValue;
    }

    manipulateSvg({
      svg: getParameterValue(data),
      newSymbol,
      bg: (_newSymbol$background = newSymbol.background) == null ? void 0 : _newSymbol$background.type,
      isClassified
    });
    return _extends({}, newSymbol, {
      data: SVGContainer.svg()
    });
  }, [SVGContainer, manipulateSvg, skipOffset, symbol]);
  return {
    svgRef: SVGWrapperRefElement,
    initSvg,
    getSvgData,
    manipulateSvg,
    getUpdatedSvgSymbol
  };
};

var _templateObject$5, _templateObject2$5;
const SvgSymbolContainer = /*#__PURE__*/styled.div(_templateObject$5 || (_templateObject$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
const SvgSymbolLabel = /*#__PURE__*/styled.div(_templateObject2$5 || (_templateObject2$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  line-height: 0;\n"])), _ref => {
  let {
    fontSettings
  } = _ref;
  return !!(fontSettings != null && fontSettings.fontFamily) && "font-family: " + fontSettings.fontFamily;
}, _ref2 => {
  let {
    fontSettings
  } = _ref2;
  return !!(fontSettings != null && fontSettings.fontWeight) && "font-weight: " + fontSettings.fontWeight;
}, _ref3 => {
  let {
    fontSettings
  } = _ref3;
  return !!(fontSettings != null && fontSettings.fontStyle) && "font-style: " + fontSettings.fontStyle;
}, _ref4 => {
  let {
    fontSettings
  } = _ref4;
  return !!(fontSettings != null && fontSettings.fontColor) && "color: " + fontSettings.fontColor;
}, _ref5 => {
  let {
    fontSettings
  } = _ref5;
  return !!(fontSettings != null && fontSettings.fontSize) && "font-size: " + (typeof fontSettings.fontSize === 'string' ? fontSettings.fontSize : fontSettings.fontSize + "px");
}, _ref6 => {
  let {
    fontSettings
  } = _ref6;
  return !!(fontSettings != null && fontSettings.haloColor) && !!(fontSettings != null && fontSettings.haloWidth) && "-webkit-text-stroke: " + fontSettings.haloWidth + "px " + fontSettings.haloColor + ";";
});
const SvgSymbol = /*#__PURE__*/memo(_ref7 => {
  let {
    svg,
    bg,
    symbol,
    title,
    text,
    fontSettings,
    skipOffset,
    isClassified,
    onClick
  } = _ref7;
  const {
    svgRef,
    initSvg,
    getSvgData,
    manipulateSvg
  } = useSvgSymbol(symbol, skipOffset, isClassified);
  const onSelectSymbol = useCallback(() => {
    onClick == null ? void 0 : onClick(getSvgData(), _extends({}, symbol, bg ? {
      background: _extends({}, symbol.background, {
        type: bg
      })
    } : {}));
  }, [bg, getSvgData, onClick, symbol]);
  const renderSymbol = useMemo(() => React.createElement(SymbolButton, {
    ref: svgRef,
    title: title,
    onClick: onClick ? onSelectSymbol : undefined
  }), [svgRef, title, onClick, onSelectSymbol]);
  useEffect(() => {
    initSvg();
  }, [initSvg]);
  useEffect(() => {
    manipulateSvg({
      svg,
      bg,
      newSymbol: symbol,
      isClassified
    });
  }, [svg, symbol, bg, manipulateSvg, isClassified]);
  return text ? React.createElement(SvgSymbolContainer, null, renderSymbol, React.createElement(SvgSymbolLabel, {
    fontSettings: fontSettings
  }, text), !!(fontSettings != null && fontSettings.haloColor) && !!(fontSettings != null && fontSettings.haloWidth) && React.createElement(SvgSymbolLabel, {
    fontSettings: _extends({}, fontSettings, {
      haloColor: undefined,
      haloWidth: undefined
    })
  }, text)) : renderSymbol;
});

const ClusterSymbolPreview = _ref => {
  var _symbol$fillColor$val, _symbol$labelSymbol;

  let {
    symbol,
    index,
    size = 56,
    fontSize = '1.25rem'
  } = _ref;
  const isClassified = isParameterByAttribute(symbol.fillColor);
  const isClassifiedValue = isClassified && index !== undefined;
  const fillColor = isClassifiedValue ? ((_symbol$fillColor$val = symbol.fillColor.values[index]) == null ? void 0 : _symbol$fillColor$val.value) || symbol.fillColor.defaultValue : symbol.fillColor;
  const strokeColor = isClassified ? fillColor : symbol.strokeColor;
  const svgSymbol = {
    type: 'svgPointSymbol',
    size,
    offset: [0, 0],
    angle: 0,
    background: {
      id: 'symbol-bg',
      fillColor,
      strokeColor,
      strokeWidth: 6,
      type: 'circle'
    }
  };
  return React.createElement(SvgSymbol, {
    svg: DEFAULT_CLUSTER_SVG,
    symbol: svgSymbol,
    isClassified: isClassified,
    text: '99',
    fontSettings: _extends({}, symbol.labelSymbol, {
      fontSize: fontSize || ((_symbol$labelSymbol = symbol.labelSymbol) == null ? void 0 : _symbol$labelSymbol.fontSize)
    })
  });
};

const SymbolByType = _ref => {
  let {
    type,
    symbol,
    size,
    svg,
    skipOffset
  } = _ref;
  const defaultSymbol = useMemo(() => React.createElement(Symbol, {
    symbol: symbol,
    size: size
  }), [symbol, size]);

  switch (type) {
    case 'svgPointSymbol':
      return svg ? React.createElement(SvgSymbol, {
        svg: svg,
        size: size,
        skipOffset: skipOffset,
        symbol: serializeSvgPointSymbol(symbol)
      }) : defaultSymbol;

    default:
      return defaultSymbol;
  }
};

const LegendSymbolRenderer = /*#__PURE__*/memo(_ref => {
  let {
    symbol,
    index
  } = _ref;

  if (isClusterSymbol(symbol)) {
    return React.createElement(ClusterLegendContainer, null, React.createElement(ClusterSymbolPreview, {
      symbol: symbol,
      index: index
    }));
  }

  return React.createElement(SymbolByType, {
    symbol: deserializeSymbol(symbol),
    size: getLegendSymbolSize(symbol) || DEFAULT_LEGEND_SYMBOL_SIZE,
    type: symbol.type,
    svg: getParameterValue(symbol.data),
    skipOffset: true
  });
});

const LegendHeaderButtons = _ref => {
  let {
    layerName,
    hasHiddenLegends,
    isShared,
    clearHiddenLegends,
    goToClassification
  } = _ref;
  return React.createElement(React.Fragment, null, !!goToClassification && !isShared && React.createElement(LegendHeaderButton, null, React.createElement(IconButton, {
    onClick: goToClassification
  }, React.createElement(EverCloudClassificationIcon, null))), !!clearHiddenLegends && React.createElement(LegendHeaderButton, null, React.createElement(IconButton, {
    disabled: !hasHiddenLegends,
    onClick: () => clearHiddenLegends == null ? void 0 : clearHiddenLegends(layerName)
  }, React.createElement(EverCloudRefreshIcon, null))));
};

const getConditionAttribute = (attributes, condition) => {
  if (!condition) return null;
  const attributeName = getAttributeNameFromCondition(condition);
  let attribute = attributes.find(_ref => {
    let {
      name
    } = _ref;
    return name === attributeName;
  });

  if (!attribute) {
    if (attributeName === 'count') {
      attribute = {
        name: 'count',
        alias: 'Количество',
        type: AttributeType.Int32
      };
    } else {
      return null;
    }
  }

  return attribute;
};

const isHiddenLegend = (hiddenCondition, hiddenLegends) => !!(hiddenLegends != null && hiddenLegends.includes(hiddenCondition));

const renderColumn = (column, index) => {
  const dateTime = column.split(' ');
  return React.createElement(Fragment, {
    key: index
  }, React.createElement(ItemText, {
    title: column
  }, dateTime[0], React.createElement(MapLegendDescription, null, dateTime[1])), index === 0 && React.createElement(ItemSeparator, null));
};

const getLegendText = _ref => {
  let {
    title,
    index,
    isDate
  } = _ref;

  if (!title) {
    return React.createElement(ItemText, null, i18n.t("other", {
      ns: "style"
    }));
  }

  const columns = title == null ? void 0 : title.split(' - ');
  const isSingleColumn = (columns == null ? void 0 : columns.length) === 1;

  if (!isDate || index && isSingleColumn) {
    return React.createElement(ItemText, {
      title: title
    }, title);
  }

  if (!index && isSingleColumn) {
    return React.createElement(React.Fragment, null, React.createElement(ItemText, {
      title: "\u221E"
    }, "\u221E"), React.createElement(ItemSeparator, null), renderColumn(title));
  }

  return React.createElement(React.Fragment, null, columns.map(renderColumn));
};

const LegendChildren = _ref => {
  var _layerInfo$style, _layerInfo$style$chil;

  let {
    layerInfo,
    hiddenLegends,
    toggleHiddenLegend,
    clearHiddenLegends,
    formatValue
  } = _ref;
  if (!(layerInfo != null && (_layerInfo$style = layerInfo.style) != null && (_layerInfo$style$chil = _layerInfo$style.children) != null && _layerInfo$style$chil.length)) return null;
  const attributes = getLayerAttributes(layerInfo.layerDefinition);
  return React.createElement(MapLegendContainer, null, layerInfo.style.children.map((paramValue, index) => {
    var _getConditionAttribut;

    const attribute = getConditionAttribute(attributes, paramValue.condition);
    if (!attribute) return null;
    const hiddenCondition = createHiddenCondition(attribute.name, attribute.type, getClassificationValue(paramValue.symbol, paramValue.title, new ClassificationCondition(paramValue.condition)));
    const legendText = getLegendText({
      title: isRangeCondition(paramValue.condition) ? createValueTitleFromCondition(paramValue, attribute, formatValue, index) : getTitleFromCondition({
        condition: paramValue.condition,
        attribute,
        formatValue
      }),
      index,
      isDate: ((_getConditionAttribut = getConditionAttribute(attributes, paramValue.condition)) == null ? void 0 : _getConditionAttribut.type) === 'DateTime'
    });
    return React.createElement(ClassifiedItem, {
      key: index,
      isHidden: isHiddenLegend(hiddenCondition, hiddenLegends == null ? void 0 : hiddenLegends[layerInfo.name]),
      onClick: () => toggleHiddenLegend == null ? void 0 : toggleHiddenLegend(layerInfo.name, hiddenCondition)
    }, React.createElement(SymbolContainer, null, React.createElement(LegendSymbolRenderer, {
      symbol: paramValue.symbol
    })), legendText, React.createElement(LegendHeaderButtons, {
      layerName: layerInfo.name,
      clearHiddenLegends: clearHiddenLegends
    }));
  }));
};

const LegendParameterDescription = _ref => {
  let {
    parameter,
    index
  } = _ref;
  const {
    t
  } = useTranslation("style");
  const isSize = isParameterType("size", parameter);
  const isStrokeWidth = isParameterType(["strokeWidth", "stroke.width"], parameter);
  const isStrokeColor = isParameterType(["strokeColor", "stroke.color"], parameter);
  return React.createElement(MapLegendDescriptionContainer, null, isStrokeWidth || isStrokeColor ? isStrokeWidth ? t("strokeWidth") : t("strokeColor") : isSize ? t("symbolSize") : t("symbolColor"), !!index && React.createElement(MapLegendBadge, null, index));
};

const getValueFromLegendTitle = (title, minOrMax) => {
  if (title.includes(" - ")) {
    const result = title == null ? void 0 : title.split(" - ");
    return minOrMax === "min" ? result == null ? void 0 : result[0] : result == null ? void 0 : result[1];
  }

  if (title.includes(",")) {
    const result = title == null ? void 0 : title.split(",");
    return result.join(", ");
  }

  return title.split(" ").find(isNumeric) || title || "";
};

const MinimizedLegend = _ref => {
  var _currentValues$, _currentValues, _currentValues$2, _currentValues2;

  let {
    innerRef,
    isShown,
    values,
    title,
    parameter,
    hiddenLegends
  } = _ref;
  const {
    t
  } = useTranslation("style");
  const currentValues = [...values];
  const other = currentValues.pop();
  const isSize = isParameterType("size", parameter);
  const isStrokeWidth = isParameterType(["strokeWidth", "stroke.width"], parameter);
  const titleMax = getValueFromLegendTitle((_currentValues$ = currentValues[0]) == null ? void 0 : _currentValues$.title, "max");
  const titleMin = getValueFromLegendTitle((_currentValues = currentValues[currentValues.length - 1]) == null ? void 0 : _currentValues.title, "min");
  const checkIsHidden = useCallback(hiddenCondition => hiddenCondition ? hiddenLegends == null ? void 0 : hiddenLegends.some(condition => hiddenCondition.includes(condition)) : false, [hiddenLegends]);
  return React.createElement(MinimizedLegendContainer, {
    ref: innerRef,
    isShown: isShown
  }, !!title && React.createElement(MapLegendValueDescr, null, title), isSize ? React.createElement(React.Fragment, null, React.createElement(SizeMinimizedLegend, null, React.createElement(SizeMinimizedLegendSymbol, null, React.createElement(MapLegendItems, {
    parameter: parameter,
    isSize: true
  }, currentValues.map((value, index) => React.createElement(MapLegendItem, {
    key: "" + value.title + index,
    title: value.title,
    value: value.parameterValue,
    parameter: parameter,
    isHidden: checkIsHidden(value.hiddenCondition)
  })))), React.createElement(SizeMinimizedLegendLabel, null, React.createElement(SizeMinimizedLegendDown, null, (_currentValues$2 = currentValues[0]) == null ? void 0 : _currentValues$2.title), React.createElement(SizeMinimizedLegendUp, null, (_currentValues2 = currentValues[currentValues.length - 1]) == null ? void 0 : _currentValues2.title))), React.createElement(SizeMinimizedLegend, null, React.createElement(SizeMinimizedLegendSymbol, null, React.createElement(MapLegendItems, {
    parameter: parameter,
    isSize: true
  }, React.createElement(MapLegendOther, {
    title: t("other"),
    value: other == null ? void 0 : other.parameterValue,
    parameter: parameter,
    isHidden: checkIsHidden(other == null ? void 0 : other.hiddenCondition)
  }))), React.createElement(SizeMinimizedLegendLabel, null, React.createElement(SizeMinimizedLegendUp, null, t("other"))))) : isStrokeWidth ? React.createElement(MapLegendItems, {
    parameter: parameter,
    isStrokeWidth: true
  }, currentValues.map((value, index) => React.createElement(MapLegendItem, {
    key: "" + value.title + index,
    title: value.title,
    value: value.parameterValue,
    parameter: parameter,
    isHidden: checkIsHidden(value.hiddenCondition)
  }, (!index || index === currentValues.length - 1) && value.title)), React.createElement(MapLegendOther, {
    title: t("other"),
    value: other == null ? void 0 : other.parameterValue,
    parameter: parameter,
    isHidden: checkIsHidden(other == null ? void 0 : other.hiddenCondition)
  }, t("other"))) : React.createElement(MapLegendItems, {
    parameter: parameter
  }, React.createElement(MapLegendItemsContainer, null, currentValues.map((value, index) => React.createElement(MapLegendItem, {
    key: "" + value.title + index,
    title: value.title,
    value: value.parameterValue,
    parameter: parameter,
    isHidden: checkIsHidden(value.hiddenCondition)
  }))), React.createElement(MapLegendOther, {
    title: t("other"),
    value: other == null ? void 0 : other.parameterValue,
    parameter: parameter,
    isHidden: checkIsHidden(other == null ? void 0 : other.hiddenCondition)
  })), typeof (other == null ? void 0 : other.parameterValue) === "string" && (titleMax || titleMin) && React.createElement(MapLegendValues, null, React.createElement(MapLegendValuesRange, null, React.createElement("div", null, titleMax), React.createElement("div", null, titleMin)), React.createElement(MapLegendValuesOther, null, "-")));
};

const MaximizedLegend = _ref => {
  let {
    innerRef,
    isShown,
    layerName,
    symbol: sectionSymbol,
    parameter,
    values,
    index: sectionIndex,
    attributeType,
    hiddenLegends,
    toggleHiddenLegend
  } = _ref;
  const isDate = attributeType === 'DateTime';
  const isSize = isParameterType('size', parameter);
  const isStrokeWidth = isParameterType(['strokeWidth', 'stroke.width'], parameter);
  const isStrokeColor = isParameterType(['strokeColor', 'stroke.color'], parameter);
  const parameterValue = useMemo(() => get(sectionSymbol, parameter), [sectionSymbol, parameter]);
  const renderLegend = useCallback((_ref2, index) => {
    var _parameterValue$value;

    let {
      symbol,
      title,
      hiddenCondition
    } = _ref2;
    if (!symbol) return null;
    const isClusterFillColor$1 = isClusterFillColor(symbol, parameter);
    const value = getParameterValue(parameterValue == null ? void 0 : (_parameterValue$value = parameterValue.values[index]) == null ? void 0 : _parameterValue$value.value) || (parameterValue == null ? void 0 : parameterValue.defaultValue);
    return React.createElement(ClassifiedItem, {
      key: sectionIndex + title + index,
      isHidden: isHiddenLegend(hiddenCondition, hiddenLegends),
      isClusterFillColor: isClusterFillColor$1,
      onClick: () => toggleHiddenLegend == null ? void 0 : toggleHiddenLegend(layerName, hiddenCondition)
    }, isSize || isStrokeWidth || isStrokeColor ? React.createElement(MapLegendItems, {
      parameter: parameter,
      isSize: isSize,
      isStrokeWidth: isStrokeWidth,
      isStrokeColor: isStrokeColor,
      isSingle: true
    }, React.createElement(MapLegendItem, {
      key: "" + title + index,
      title: title,
      value: value,
      parameter: parameter
    })) : React.createElement(SymbolContainer, null, React.createElement(LegendSymbolRenderer, {
      index: index,
      symbol: isClusterFillColor$1 ? sectionSymbol : getExtractedSymbol(symbol, true)
    })), getLegendText({
      title,
      index,
      isDate
    }));
  }, [parameter, sectionIndex, hiddenLegends, isSize, isStrokeWidth, isStrokeColor, parameterValue, sectionSymbol, isDate, toggleHiddenLegend, layerName]);
  return React.createElement(MaximizedLegendContainer, {
    ref: innerRef,
    isShown: isShown
  }, values.map(renderLegend));
};

const LegendSection = _ref => {
  var _hiddenLegends$layerN, _hiddenLegends$layerN2;

  let {
    layerName,
    symbol,
    parameter,
    parameters,
    classified,
    hiddenLegends,
    toggleHiddenLegend,
    clearHiddenLegends,
    goToClassification,
    attribute,
    formatValue,
    index,
    count,
    isShared
  } = _ref;
  const {
    t
  } = useTranslation("style");
  const [isExpanded, toggleExpanded] = useToggle();
  const [maxRef, maxNode] = useNode();
  const [minRef, minNode] = useNode();
  if (!layerName || !attribute) return null;
  const currentSymbol = isCombinedPolylineSymbol(symbol) ? symbol.values[index] : symbol;
  return React.createElement(MapLegendSectionContainer, {
    hasHiddenLegends: !!(hiddenLegends != null && (_hiddenLegends$layerN = hiddenLegends[layerName]) != null && _hiddenLegends$layerN.length)
  }, React.createElement(MapLegendHeader, null, attribute.alias || attribute.name, React.createElement(LegendHeaderButtons, {
    layerName: layerName,
    hasHiddenLegends: !!(hiddenLegends != null && (_hiddenLegends$layerN2 = hiddenLegends[layerName]) != null && _hiddenLegends$layerN2.length),
    clearHiddenLegends: clearHiddenLegends,
    goToClassification: goToClassification,
    isShared: isShared
  })), React.createElement(LegendParameterDescription, {
    parameter: parameter,
    index: count && index !== undefined ? count - index : 0
  }), React.createElement(MapLegendSectionItems, {
    minHeight: minNode == null ? void 0 : minNode.offsetHeight,
    maxHeight: maxNode == null ? void 0 : maxNode.offsetHeight,
    isExpanded: isExpanded
  }, React.createElement(MaximizedLegend, {
    innerRef: maxRef,
    isShown: isExpanded,
    layerName: layerName,
    symbol: currentSymbol,
    hiddenLegends: hiddenLegends == null ? void 0 : hiddenLegends[layerName],
    toggleHiddenLegend: toggleHiddenLegend,
    parameter: parameter,
    attributeType: attribute.type,
    index: index,
    values: getMaximizedLegendValues(attribute, parameter, parameters, classified, currentSymbol, formatValue, index, t("other"))
  }), React.createElement(MinimizedLegend, {
    innerRef: minRef,
    isShown: !isExpanded,
    hiddenLegends: hiddenLegends == null ? void 0 : hiddenLegends[layerName],
    parameter: parameter,
    values: getMinimizedLegendValues(attribute, classified, formatValue, index, t("other"))
  })), React.createElement(MapLegendExpandButton, {
    onClick: toggleExpanded
  }, isExpanded ? t('hide') : t('show')));
};

const _excluded$3 = ["layerInfo", "formatValue", "hiddenLegends", "toggleHiddenLegend", "clearHiddenLegends", "goToClassification"];
const Legend = /*#__PURE__*/memo(_ref => {
  var _layerInfo$style, _layerInfo$style$chil;

  let {
    layerInfo,
    formatValue,
    hiddenLegends,
    toggleHiddenLegend,
    clearHiddenLegends,
    goToClassification
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  if (!layerInfo) return null;

  if ((_layerInfo$style = layerInfo.style) != null && (_layerInfo$style$chil = _layerInfo$style.children) != null && _layerInfo$style$chil.length) {
    return React.createElement(LegendChildren, {
      layerInfo: layerInfo,
      formatValue: formatValue,
      hiddenLegends: hiddenLegends,
      toggleHiddenLegend: toggleHiddenLegend,
      clearHiddenLegends: clearHiddenLegends,
      goToClassification: goToClassification
    });
  }

  const attributes = getLayerAttributes(layerInfo.layerDefinition);
  const renderItems = useMemo(() => {
    var _layerInfo$style2, _layerInfo$style3;

    const parameters = SYMBOL_CLASSIFICATION[layerInfo.geometryType];
    const props = {
      layerName: layerInfo.name,
      symbol: (_layerInfo$style2 = layerInfo.style) == null ? void 0 : _layerInfo$style2.symbol,
      parameters: parameters,
      formatValue: formatValue,
      hiddenLegends: hiddenLegends,
      toggleHiddenLegend: toggleHiddenLegend,
      clearHiddenLegends: clearHiddenLegends,
      goToClassification: goToClassification
    };

    if ((_layerInfo$style3 = layerInfo.style) != null && _layerInfo$style3.symbol && isCombinedPolylineSymbol(layerInfo.style.symbol)) {
      var _layerInfo$style4, _layerInfo$style4$sym, _layerInfo$style4$sym2;

      const values = (_layerInfo$style4 = layerInfo.style) == null ? void 0 : (_layerInfo$style4$sym = _layerInfo$style4.symbol) == null ? void 0 : (_layerInfo$style4$sym2 = _layerInfo$style4$sym.values) == null ? void 0 : _layerInfo$style4$sym2.reduce((result, symbol, index) => {
        return [classifyParamsReduce(symbol, parameters, index), ...result];
      }, []);
      return React.createElement(React.Fragment, null, values == null ? void 0 : values.map((value, index) => Object.keys(value).map((param, keyIndex) => {
        var _item$values$;

        const item = value[param];
        return React.createElement(LegendSection, Object.assign({
          key: [keyIndex, index].join("-"),
          index: item == null ? void 0 : item.index,
          count: values == null ? void 0 : values.length,
          attribute: getConditionAttribute(attributes, item == null ? void 0 : (_item$values$ = item.values[0]) == null ? void 0 : _item$values$.condition),
          parameter: param,
          classified: item
        }, props, rest));
      })));
    }

    const classified = getClassified(layerInfo);
    if (!classified) return null;
    return React.createElement(React.Fragment, null, Object.keys(classified).map((param, keyIndex) => {
      var _item$values$2;

      const item = classified[param];
      return React.createElement(LegendSection, Object.assign({
        key: [keyIndex, item.index].join("-"),
        index: item.index,
        attribute: getConditionAttribute(attributes, item == null ? void 0 : (_item$values$2 = item.values[0]) == null ? void 0 : _item$values$2.condition),
        parameter: param,
        classified: item
      }, props, rest));
    }));
  }, [layerInfo, formatValue, hiddenLegends, toggleHiddenLegend, clearHiddenLegends, goToClassification]);
  return React.createElement(MapLegendContainer, null, renderItems);
});

const Map = _ref => {
  let {
    className,
    position,
    resolution,
    minScale,
    maxScale,
    children,
    onBboxChange,
    style
  } = _ref;
  const wrapperRef = useMapWrapper();
  const {
    map
  } = useMapContext();
  const handleBboxChange = useCallback(state => {
    if (onBboxChange && shouldUpdateMapState(map, {
      position,
      resolution
    })) {
      onBboxChange(state);
    }
  }, [map, onBboxChange, position, resolution]);
  useUpdateMapView({
    position,
    resolution
  });
  useMaxMinScale(minScale, maxScale, position, resolution);
  useMapBboxChange(handleBboxChange);
  return React.createElement("div", {
    className: className,
    ref: wrapperRef,
    style: style
  }, children);
};

let MeasureTool = /*#__PURE__*/function (_React$Component) {
  _inherits(MeasureTool, _React$Component);

  var _super = /*#__PURE__*/_createSuper(MeasureTool);

  function MeasureTool() {
    var _this;

    _classCallCheck(this, MeasureTool);

    _this = _super.apply(this, arguments);

    _this.createFeature = event => {
      const feature = _this.getFeature([...event.feature.rings]);

      _this.layer && _this.layer.add(feature);

      if (_this.editorControl) {
        _this.editorControl.activeFeature = feature;
      }

      _this.switchMode(false, true);
    };

    _this.removeFeature = () => {
      if (_this.editorControl && _this.editorControl.activeFeature) {
        _this.layer && _this.layer.remove(_this.editorControl.activeFeature);
      }

      _this.switchMode(true, false);
    };

    _this.cancelFeatureCreation = () => {
      setTimeout(() => {
        _this.switchMode(false, false);

        _this.switchMode(true, false);
      }, 10);
    };

    return _this;
  }

  _createClass(MeasureTool, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      const {
        map,
        painter,
        renderLabelSymbol
      } = this.props;
      this.layer = new FeatureLayer$1();
      this.initCreateMode(map, painter, renderLabelSymbol);
      this.initEditMode(map, painter, renderLabelSymbol);
      this.props.map.addLayer(this.layer);
      this.switchMode(true, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.layer && this.props.map.removeLayer(this.layer);
      this.switchMode(false, false);
      this.offEvents();
      this.clearProperties();
    }
  }, {
    key: "initCreateMode",
    value: function initCreateMode(map, painter, renderLabelSymbol) {
      const {
        lengthSymbol,
        formatters,
        areaSymbol
      } = this.props;
      this.createControl = new BaseMeasureToolCreator(map, painter, {
        isActive: false,
        useTempLayer: true,
        symbol: lengthSymbol || measureLengthSymbol,
        areaSymbol,
        dblClickMinTime: 300,
        renderLabelSymbol,
        formatters: formatters
      }); // @ts-ignore

      this.createControl.on('drawingFinish', this.createFeature);
      this.createControl.on('cancel', this.cancelFeatureCreation);
    }
  }, {
    key: "initEditMode",
    value: function initEditMode(map, painter, renderLabelSymbol) {
      const {
        lengthSymbol,
        snapSymbol,
        formatters
      } = this.props;
      this.editorControl = new BaseMeasureToolEditor(map, painter, {
        isActive: false,
        activeLayer: this.layer,
        snappingSymbol: snapSymbol || measurePolygonSnapSymbol,
        symbol: lengthSymbol || measureLengthSymbol,
        renderLabelSymbol,
        formatters
      });
      this.editorControl.featureDragAllowed = false;
      this.editorControl.on('remove', this.removeFeature);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      let {
        formatters
      } = _ref;
      const {
        formatters: currentFormatters
      } = this.props;
      if (currentFormatters !== formatters && currentFormatters) if (this.editorControl) {
        this.editorControl.formatters = currentFormatters;
        this.editorControl.updateMeasureResult();
      }
    }
  }, {
    key: "offEvents",
    value: function offEvents() {
      if (this.createControl) {
        // @ts-ignore
        this.createControl.off('drawingFinish', this.createFeature);
      }

      this.editorControl && this.editorControl.off('remove', this.removeFeature);
      this.createControl && this.createControl.off('cancel', this.cancelFeatureCreation);
    }
  }, {
    key: "clearProperties",
    value: function clearProperties() {
      delete this.createControl;
      delete this.editorControl;
      delete this.layer;
    }
  }, {
    key: "switchMode",
    value: function switchMode(create, edit) {
      if (this.createControl) {
        this.createControl.isActive = create;
      }

      if (this.editorControl) {
        this.editorControl.isActive = edit;
      }
    }
  }, {
    key: "getFeature",
    value: function getFeature(rings) {
      const {
        lengthSymbol,
        areaSymbol,
        map
      } = this.props;
      let feature;

      if (isPolylineLikePolygon(rings, map.resolution)) {
        rings[0].shift();
        feature = new Polygon(rings, {
          crs: map.crs
        });
        feature.symbol = areaSymbol || measureAreaSymbol;
      } else {
        feature = new Polyline(rings, {
          crs: map.crs
        });
        feature.symbol = lengthSymbol || measureLengthSymbol;
      }

      return feature;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        style: {
          display: 'none'
        }
      });
    }
  }]);

  return MeasureTool;
}(React.Component);

const _excluded$4 = ["isActive"];
const Measurer = _ref => {
  let {
    isActive
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  const {
    map,
    painter
  } = useMapContext();
  return isActive ? React.createElement(MeasureTool, Object.assign({
    map: map,
    painter: painter
  }, props)) : null;
};

var _templateObject$6, _templateObject2$6, _templateObject3$4;
const ScaleRulerContainer = /*#__PURE__*/styled.div(_templateObject$6 || (_templateObject$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 2rem;\n  cursor: default;\n  display: flex;\n  align-items: flex-end;\n  padding: 0 0.5rem 0.5rem;\n  box-sizing: border-box;\n"])));
const ScaleRulerBlock = /*#__PURE__*/styled.div(_templateObject2$6 || (_templateObject2$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  width: ", ";\n  height: 0.25rem;\n  border: 0.0625rem solid white;\n  border-top: 0;\n"])), _ref => {
  let {
    width
  } = _ref;
  return width + "px";
});
const TextContainer = /*#__PURE__*/styled.div(_templateObject3$4 || (_templateObject3$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: ", ";\n  width: ", ";\n  color: #fff;\n  font-size: 1rem;\n  cursor: default;\n  padding: 0 0.5rem;\n"])), _ref2 => {
  let {
    alignEnd
  } = _ref2;
  return alignEnd ? 'flex-end' : 'center';
}, _ref3 => {
  let {
    width
  } = _ref3;
  return width || 'auto';
});

const ScaleRuler = () => {
  const {
    resolution
  } = useMapView();
  const {
    currentScale,
    width
  } = useScale({
    resolution: resolution || 0
  });
  return React.createElement(ScaleRulerContainer, null, React.createElement(ScaleRulerBlock, {
    width: width
  }, React.createElement(TextContainer, {
    alignEnd: true,
    margin: '0'
  }, currentScale >= 1000 ? currentScale / 1000 + "km" : currentScale + "m")));
};

const Zoom = _ref => {
  let {
    children
  } = _ref;
  const {
    zoomIn,
    zoomOut
  } = useMapViewActions();
  return React.createElement(MapControl, null, React.createElement(ZoomInBtn, {
    onClick: zoomIn
  }), React.createElement(ZoomOutBtn, {
    onClick: zoomOut
  }), children);
};

const ZoomLevel = () => {
  const level = useMapLevel();
  return React.createElement(TextContainer, {
    buttonText: true,
    width: '2rem'
  }, level || 0);
};

var _templateObject$7, _templateObject2$7, _templateObject3$5, _templateObject4$4, _templateObject5$4, _templateObject6$3, _templateObject7$3, _templateObject8$3, _templateObject9$2, _templateObject10$2, _templateObject11$2;

const cornerBottom = cornerSize => css(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  &:before {\n    left: 50%;\n    transform: translate(-50%, 100%);\n    bottom: 0;\n    border-left: ", " solid transparent;\n    border-right: ", " solid transparent;\n    border-top: ", " solid rgba(28, 33, 48, 0.8);\n  }\n"])), cornerSize, cornerSize, cornerSize);

const cornerLeft = cornerSize => css(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n  &:before {\n    transform: translate(-100%, -50%);\n    left: 0;\n    top: 50%;\n    border-top: ", " solid transparent;\n    border-right: ", " solid rgba(28, 33, 48, 0.8);\n    border-bottom: ", " solid transparent;\n  }\n"])), cornerSize, cornerSize, cornerSize);

const cornerRight = cornerSize => css(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n  &:before {\n    transform: translate(100%, -50%);\n    right: 0;\n    top: 50%;\n    border-top: ", " solid transparent;\n    border-left: ", " solid rgba(28, 33, 48, 0.8);\n    border-bottom: ", " solid transparent;\n  }\n"])), cornerSize, cornerSize, cornerSize);

const cornerTop = cornerSize => css(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n  &:before {\n    transform: translate(-50%, -100%);\n    left: 50%;\n    top: 0;\n    border-left: ", " solid transparent;\n    border-right: ", " solid transparent;\n    border-bottom: ", " solid rgba(28, 33, 48, 0.8);\n  }\n"])), cornerSize, cornerSize, cornerSize);

const top = (distance, cornerSize) => css(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n  transform: translate(-50%, 0);\n  left: -50%;\n  bottom: ", ";\n  ", "\n"])), distance, cornerSize && cornerBottom(cornerSize));

const right = (distance, cornerSize) => css(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["\n  transform: translate(0, -50%);\n  top: -50%;\n  left: ", ";\n  ", "\n"])), distance, cornerSize && cornerLeft(cornerSize));

const left = (distance, cornerSize) => css(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n  transform: translate(0, -50%);\n  top: -50%;\n  right: ", ";\n  ", "\n"])), distance, cornerSize && cornerRight(cornerSize));

const bottom = (distance, cornerSize) => css(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteralLoose(["\n  transform: translate(-50%, 0);\n  left: -50%;\n  top: ", ";\n  ", "\n"])), distance, cornerSize && cornerTop(cornerSize));

const placementMixin$1 = function placementMixin(placement, distance, cornerSize) {
  if (placement === void 0) {
    placement = 'top';
  }

  return css(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), placement === 'top' && top(distance, cornerSize), placement === 'right' && right(distance, cornerSize), placement === 'left' && left(distance, cornerSize), placement === 'bottom' && bottom(distance, cornerSize));
};
const corner = /*#__PURE__*/css(_templateObject10$2 || (_templateObject10$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &:before {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n  }\n"])));
const TooltipComponent = /*#__PURE__*/styled.div(_templateObject11$2 || (_templateObject11$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: absolute;\n  z-index: 999;\n  display: flex;\n  font-size: 0.625rem;\n  color: #fff;\n  background-color: rgba(28, 33, 48, 0.8);\n  padding: 0.4em 0.6em;\n  border-radius: 2px;\n  user-select: none;\n  box-sizing: border-box;\n  white-space: pre;\n  ", "\n  ", "\n"])), _ref => {
  let {
    placement,
    distance = '0.5rem',
    withArrow,
    cornerSize = '0.25rem'
  } = _ref;
  return placementMixin$1(placement, distance, withArrow ? cornerSize : null);
}, _ref2 => {
  let {
    withArrow
  } = _ref2;
  return withArrow && corner;
});

const _excluded$5 = ["features", "map", "center", "component", "zIndex", "children", "content", "onEachFeature", "clickMode"];

const {
  Provider,
  Consumer
} = /*#__PURE__*/createContext([]); // TODO I just cant read that

const Tooltip = _ref => {
  let {
    features = [],
    map,
    center,
    component,
    zIndex,
    children,
    content,
    onEachFeature,
    clickMode
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  const onTooltip = useTooltip(zIndex);
  useEffect(() => {
    (map ? [map] : features).forEach(feature => {
      const position = center && !(feature instanceof Map$1) && feature.bbox.center ? feature.bbox.center : undefined;
      onTooltip({
        feature,
        component: typeof onEachFeature === 'function' ? () => onEachFeature(feature) : () => React.createElement(TooltipComponent, Object.assign({}, props), content),
        position,
        clickMode
      });
    });
  }, [content, clickMode, onEachFeature, onTooltip, map, center, features, component, props]);
  return React.createElement(Provider, {
    value: features
  }, map ? children : children ? React.createElement(Consumer, null, children) : null);
};

/** No operation element */

const Noop = () => React.createElement("div", {
  style: {
    display: 'none'
  }
});

const DraggableMarker = _ref => {
  let {
    position,
    onChange,
    symbol
  } = _ref;
  useDraggableMarker({
    position,
    onChange,
    symbol
  });
  return React.createElement(Fragment, null);
};

export { ArrowLineMiterRender, BASE_OPERATORS, BETWEEN_OPERATORS, BaseMeasureToolCreator, BaseMeasureToolEditor, CONTAINS_OPERATORS, CRS_MAP, CardAttributes, CardHeader, CircleLineMiterRender, ClassificationCondition, ClassificationManager, ClassifiedItem, ClusterLayer, ClusterLegendContainer, ClusterSymbol, ClusterSymbolPreview, ComparisonOperator, CompoundIcon, DEFAULT_CLUSTER_SVG, DEFAULT_CRS, DEFAULT_ID_ATTRIBUTE_NAME, DEFAULT_LEGEND_SIZES, DEFAULT_LEGEND_STYLES, DEFAULT_LEGEND_SYMBOL_SIZE, DEFAULT_PARAMETER_INFO, DEFAULT_SRID, DEFAULT_SYMBOL_FILL_COLOR, DEFAULT_SYMBOL_OFFSET, DEFAULT_SYMBOL_SIZE, DEFAULT_SYMBOL_STROKE_COLOR, DEFAULT_SYMBOL_WITH_BG_SIZE, DateFormat, DraggableMarker, ENDS_WITH_OPERATORS, EXTRA_BORDER_SIZE, EvergisCard, EvergisCardAttribute, AttributeContainer as EvergisCardAttributeContainer, AttributeTitle as EvergisCardAttributeTitle, AttributeValueContainer as EvergisCardAttributeValueContainer, CardControls as EvergisCardCardControls, CardTitle as EvergisCardCardTitle, EvergisCardContainer, CurrentFeatureIndex as EvergisCardCurrentFeatureIndex, FeatureName as EvergisCardFeatureName, LayerName as EvergisCardLayerName, CardPagination as EvergisCardPagination, PaginationDescription as EvergisCardPaginationDescription, SimpleAttribute as EvergisCardSimpleValue, StickyHeader as EvergisCardStickyHeader, ValueLink as EvergisCardValueLink, EvergisDynamicLayer, EvergisFeature, EvergisLayer, EvergisProvider, EvergisSelect, EvergisSelectLayer, EvergisSelectProvider, EvergisStyle, EvergisTileLayer, FILLED_OPERATORS, FeatureLayer, FilterConditionOperation, Fullscreen, GEOMETRY_ATTRIBUTE, ItemSeparator, ItemText, LabelSymbol, Legend, LegendChildren, LegendHeaderButton, LegendParameterDescription, LegendProvider, LegendSection, LegendSymbolRenderer, LineMiterRender, Map, MapControl, MapControls, MapLegendBadge, MapLegendContainer, MapLegendControl, MapLegendDescription, MapLegendDescriptionContainer, MapLegendExpandButton, MapLegendHeader, MapLegendItem, MapLegendItems, MapLegendItemsContainer, MapLegendOther, MapLegendSectionContainer, MapLegendSectionItems, MapLegendValueDescr, MapLegendValues, MapLegendValuesOther, MapLegendValuesRange, MapProvider, MaximizedLegend, MaximizedLegendContainer, Measure, MeasureTool, Measurer, MinimizedLegend, MinimizedLegendContainer, NO_CONTENT_VALUE, Noop, OPERATOR_CONDITION_REMAP, PARAMETER_INFOS, PREVIEW_LIMITS, RANGE_OPERATORS, SGisBrushFill, SGisImageFill, SGisPolygonSymbol, SGisPolylineSymbol, SOLID_INTERVALS, STARTS_WITH_OPERATORS, SVGPoly, SYMBOL_CLASSIFICATION, SYMBOL_LIMITS, SYMBOL_SIZE_PARAMETERS, ScaleRuler, ScaleRulerBlock, ScaleRulerContainer, Search, SelectedPointSymbol, SelectedPolySymbol, ShadowedPointSymbol, ShadowedPolySymbol, SizeMinimizedLegend, SizeMinimizedLegendDown, SizeMinimizedLegendLabel, SizeMinimizedLegendSymbol, SizeMinimizedLegendUp, SquareLineMiterRender, SrId, StyleSymbol, SvgSymbol, SvgSymbolBg, Symbol, SymbolButton, SymbolByType, SymbolContainer, TextContainer, TileLayer, Tooltip, TooltipComponent, TooltipProvider, Zoom, ZoomLevel, adjustSymbol, applyParameterValue, checkLayerHasLegend, clamp, classifyParamsReduce, convertSvgToBase64, copyRings, createCompositeSymbol, createHiddenCondition, createLabelSymbol, createLegendSymbol, createOtherHiddenCondition, createPointRender, createShadowRender, createSvgGradient, createValueTitle, createValueTitleFromCondition, dateComparisonOperators, defaultOffset, defineStrokeStylePreset, deserializeSymbol, evaluateFeature, extractStyle, extractSymbol, findChildFeatureStyle, findChildFeatureSymbol, formatArea, formatAttributeValue, formatDate, formatLength, formatPolygonMeasure, formatRangeClassValue, formatUniqueClassValue, getAttributeFromCondition, getAttributeNameFromClassified, getAttributeNameFromCondition, getAttributeType, getAttributesConfiguration, getChildSymbols, getClassificationValue, getClassified, getCrs, getDashStylePreset, getDate, getDimensions, getExprFromCondition, getExtractedSymbol, getFeatureSymbol, getHexColor, getLayerDefinition, getLegendSymbolRenders, getLegendSymbolSize, getLineDash, getMapLegendSymbolRenders, getMapState, getMaximizedLegendValues, getMinimizedLegendValues, getOffsetParameterValue, getParameterFromSymbol, getParameterValue, getRangeValues$1 as getRangeValues, getScale, getServiceConfiguration, getSignFromConditionPart, getSimplifiedPolygonCoordinates, getSymbolParameterInfo, getSymbolRenders, getSymbolStrokeWidth, getTitleFromCondition, getValueFromConditionPart, isArrowLineMiter, isCalculatedParameter, isCircleLineMiter, isClusterFillColor, isClusterSymbol, isCombinedPolylineSymbol, isCompositeSymbol, isDashedBrush, isFilledLineMitter, isH3GridSymbol, isHatchBrush, isImageSymbol, isLabelSymbol, isLayerService, isMaskedImageSymbol, isMiterExist, isNumeric, isObject, isParameterByAttribute, isParameterType, isParameterValueSimple, isParameterValueSymbol, isPatternBrush, isPointLabelSymbol, isPointSymbol, isPolygonHasHatchBrush, isPolygonHasPatternBrush, isPolygonLabelSymbol, isPolygonSymbol, isPolylineLabelSymbol, isPolylineLikePolygon, isPolylineSymbol, isPolylineSymbols, isRangeClass, isRangeCondition, isRasterSymbol, isRequisiteNumbers, isSGisClusterSymbol, isSGisCombinedPolylineSymbol, isSGisH3Symbol, isSGisImageSymbol, isSGisPointSymbol, isSGisPolygonSymbol, isSGisPolylineSymbol, isScalablePolylineSymbol, isSimpleOffset, isSimplePolylineSymbol, isSimpleSymbol, isSizableSymbol, isSizeClassification, isSolidBrush, isSquareLineMiter, isSquareSymbol, isStaticImageSymbol, isStringAsInn, isStringAsKpp, isStringAsMail, isStringAsOgrn, isStringAsPhone, isStringAsUrl, isStringContainsDate, isStringParameterValue, isStrokeStyledSymbol, isStyle, isSvgPointSymbol, isSymbolWithOffset, isTwoDimensionalSymbol, isUniqueClass, isValidParameter, isValidUrl, mailHref, manipulateSvgSymbol, matchPhone, measureAreaSymbol, measureLengthSymbol, measurePolygonSnapSymbol, metersToPixels, numberComparisonOperators, numberWithSpaces, packStyle, phoneHref, polygonCircleFromPoint, printRangeClass, renderSymbolToCanvas, selectedPoint, selectedPolygon, selectedPolyline, serializeSvgPointSymbol, setDefaultParameterValue, setParameterValue, shouldUpdateMapState, solidStrokeStylePreset, strokeStylePresets, symbolParameterWalker, symbolTypeGuard, textComparisonOperators, toIntervals, toLineDash, unClassify, updateMapResolution, updateSymbolParameter, urlHref, useCanvas, useClusterLayer, useCrs, useDebouncedCallback, useDraggableMarker, useEventPoint, useEvergisContext, useEvergisDynamicLayer, useEvergisSelect, useEvergisSelectContext, useEvergisTileLayer, useFeatureLayer, useLayerOrder, useLayerVisibility, useLegendContext, useMapBboxChange, useMapContext, useMapLevel, useMapPick, useMapResize, useMapState, useMapView, useMapViewActions, useMapWrapper, useMaxMinScale, useMetersToPixels, useMetersToPixelsCb, useMount, useNode, useProperty, useScale, useSvgSymbol, useSymbol, useToggle, useTooltip, useTooltipContext, useUpdate, useUpdateMapView };
//# sourceMappingURL=react.esm.js.map
